export default {
    "fr": {
        "name": "Français",
        "messages": {
            "book_fast": "Une minute!",
            "important": "Important",
            "payment_book_1": "Avant d'acheter cette pièce, assurez-vous d'avoir contacté le vendeur afin de déterminer les frais d'envoi.",
            "payment_book_2": "Pour toute demande relative à votre transaction, vous pouvez nous contacter à info@classic-parts-finder.com. Le vendeur dispose de 72h pour expédier votre colis.",
            "book_tarif_1": "",
            "book_tarif_2": "",
            "pay": "Payer",
            "secure_purchase": "Acheter",
            "parts_available_button": "Autres pièces disponibles",
            "parts_notification_message": "Être averti par E-mail pour toutes les pièces de ce véhicule disponibles à la vente.",
            "available_parts": "Pièces disponibles",
            "registration": "Inscription",
            "login_failed": "Impossible de vous connecter",
            "back": "Retour",
            "choose_country": "Choisir un pays",
            "max_images": "Maximum 10 images",
            "email": "Adresse E-mail",
            "accept_cgu": "J'ai lu et j'accepte les {0} ainsi que les {1}",
            "negociable": "Négociable",
            "select_default_lang": "Définir en langue par défaut :",
            "non_negociable": "Non négociable",
            "moderation_message": "Message du modérateur",
            "voir_changements": "Voir les changements",
            "masquer_changements": "Masquer les changements",
            "refus_changement": "Refuser",
            "accept_changement": "Accepter les modifications et diffuser",
            "ad_modifications": "Modifications suggérées pour votre annonce",
            "research_modifications": "Modifications suggérées pour votre recherche",
            "cgu": "CGU",
            "privacy": "Politiques de confidentialité",
            "finish": "Envoyer",
            "email_already_used": "Cette adresse E-mail a déjà été utilisée. Veuillez nous contacter via le  {0}",
            "registering_error": "Impossible de vous enregistrer.  Veuillez nous contacter via le  {0}",
            "field_required": "Champ requis!",
            "field_email": "E-mail incorrect!",
            "field_email_used": "E-mail déjà utilisé!",
            "registering_email_sent": "Nous venons de vous envoyer un E-mail pour confirmer votre inscription",
            "check_spams": "Courriel non reçu? Vérifiez vos spams ou contactez le support de Classic Parts Finder à {1}",
            "back_login": "Retour à la page de connexion",
            "forgot_your_password": "Mot de passe oublié?",
            "reset_send_email": "Un E-mail vous sera envoyé afin de réinitialiser votre mot de passe",
            "inexistant_email": "Adresse E-mail inexistante!",
            "validate": "Valider",
            "reset_email_sent": "Un E-mail vous a été envoyé!",
            "update_your_password": "Modifier votre mot de passe",
            "set_new_password": "Définissez un nouveau mot de passe.",
            "at_least_x_char": "Au moins {0} caractères.",
            "password_must_be_identical": "Le mot de passe doit être identique",
            "modify": "Modifier",
            "password_updated": "Mot de passe modifié",
            "your_password_updated": "Votre mot de passe a bien été modifié!",
            "login": "Se connecter",
            "expired_link": "Le lien est arrivé à expiration",
            "research_expired_status": "Expiré",
            "confirm_new_passwd": "Confirmer le nouveau mot de passe",
            "log_in": "Connexion",
            "log_in_error": "Erreur de connexion :",
            "email_address": "Adresse E-mail",
            "password": "Mot de passe",
            "connection": "Connexion",
            "not_registered_yet": "Pas encore inscrit?",
            "i_research": "Je recherche des pièces",
            "i_sell": "Je vends des pièces",
            "log_out": "Déconnexion",
            "my_dashboard": "Mon tableau de bord",
            "last_step": "Dernière ligne droite",
            "complementary_details_required": "Quelques informations complémentaires sont requises.",
            "first_name": "Prénom",
            "field_alpha": "Valeur alphabétique uniquement!",
            "last_name": "Nom",
            "country": "Pays",
            "phone_number": "Numéro de téléphone",
            "confirm_new_password": "Confirmer le mot de passe",
            "information_editable_dashboard": "Vos informations ne seront pas partagées avec des tiers. Vous pourrez les modifier à tout moment dans la section 'Paramètres' de votre tableau de bord.",
            "complete_registering": "Finaliser mon inscription",
            "account_activated": "Votre compte est activé",
            "connect_to_dashboard": "Vous pouvez désormais vous connecter à votre tableau de bord, créer de nouvelles recherches,{0} ou configurer votre compte afin de vendre vos pièces!",
            "log_in_dashboard": "Se connecter au tableau de bord",
            "criteria_explanation": "Ces critères sont donnés à titre indicatif et ne se veulent pas exhaustifs. Ils n’engagent en rien la responsabilité de Classic Parts Finder. A noter que l’abrégé OEM (Original Equipment Manufacturer) est lié à la référence d'origine constructeur d'une pièce détachée automobile.",
            "factory_oem": "Pièce d’origine (OEM) d’époque",
            "strict_origin_factory": "Pièce strictement identique à l’origine, produite selon les spécifications et normes prévues par le constructeur du véhicule, durant toute la période de production de ce dernier et au-delà, sans interruption (10 ans en moyenne après la fin de production du véhicule).",
            "remade_oem": "Pièce d’origine (OEM) refabriquée",
            "strict_origin_remade": "Pièce strictement identique à l’origine, mais reproduite après une période d’interruption (en général plusieurs décennies après la fin de production du véhicule). Ce bien répond en tout point –voire surpasse- les critères et exigences de fabrication de la pièce fabriquée à l’époque.",
            "old_fixed": "Pièce d’origine d’époque reconditionnée",
            "strict_origin_fixed": "Pièce strictement identique à l’origine (pièce OEM d’époque), mais rénovée.",
            "remplacement_part": "Pièce de substitution",
            "quality_replacement": "Pièce de qualité équivalente ou adaptable. Elle peut être de l’époque de la fabrication du véhicule, ou reproduite ultérieurement, mais non-montée d’origine sur le véhicule. De valeur supposée égale, comparable, voire supérieure, elle comporte des différences -si même parfois à peine visibles- avec la pièce d’origine OEM montée sur le véhicule. Le bien se doit de respecter les conditions d’homologation.",
            "criteria_responsibility": "Ces critères sont donnés à titre indicatif et ne se veulent pas exhaustifs. Ils n’engagent en rien la responsabilité de Classic Parts Finder.",
            "our_advice": "Notre conseil ",
            "avoid_issue_defaults": "Afin d’éviter tout malentendu, pensez à mentionner systématiquement tous défauts et à les mettre en évidence dans vos photos!",
            "brand_new": "Neuf",
            "never_used": "Bien jamais utilisé et complet, de préférence avec son emballage d’origine. Il ne comprend aucune trace d’usure.",
            "very_good": "Très bon",
            "almost_never_used": "Bien très peu utilisé, voire jamais. Il est complet, et si pièce mécanique, en parfait état de fonctionnement. Il comporte toutefois quelques défauts ou traces d’usures à peine visibles (par exemple en raison d’un stockage prolongé, légères rayures, traces d'oxydation…).",
            "good": "Bon",
            "few_imperfections": "Bien déjà utilisé. Il comporte quelques imperfections, défauts et traces d’usure, en partie visibles à l’œil nu, mais qui n'altèrent en aucun cas son montage ou bon fonctionnement.",
            "satisfying": "Satisfaisant",
            "needs_cleaning": "Bien comportant des traces d’usure évidentes et nettement visibles à l’œil nu, mais fonctionnel. Il peut nécessiter une rapide révision ou nettoyage avant montage.",
            "renovate": "À rénover",
            "to_renovate_fix": "Bien non fonctionnel, endommagé, pour restauration ou récupération de pièces détachées",
            "other_question": "Autre question",
            "enter_your_question": "Entrez votre question",
            "send": "Envoyer",
            "cancel": "Annuler",
            "message_waiting_validation": "Message envoyé. Vous pouvez retrouver vos conversations dans la section messagerie (en haut à droite de votre écran).",
            "more_picture_product": "J’aimerais voir plus de photos",
            "where_product_from": "Pouvez-vous m'en dire plus sur son état?",
            "thanks_for_comment": "Merci pour votre commentaire",
            "add": "Ajouter",
            "research": "Recherche",
            "vehicle": "Véhicule",
            "simplified_announce": "Alerte",
            "product": "Annonce",
            "parameters": "Paramètres",
            "my_researches": "Mes recherches",
            "my_vehicles": "Mes véhicules",
            "my_simplified_announces": "Mes alertes",
            "my_products": "Mes annonces",
            "email_modification": "Modification de l'E-mail en cours",
            "to_change_email_dashboard": "Pour changer votre E-mail, veuillez vous reconnecter sur votre tableau de bord et modifier votre E-mail dans les paramètres de votre compte.{0} Si le problème persiste veuillez contacter le support Classic Parts Finder à {1}",
            "log_myself": "Me connecter",
            "success_email_change": "Votre E-mail a été changé avec succès",
            "other": "Autre",
            "vendor_parameters": "Paramètres vendeur",
            "sell_parts": "Vendez vos pièces détachées{0}sur Classic Parts Finder",
            "diffuse_products": "Diffuser vos annonces en quelques minutes!",
            "activate_vendor": "Activer mon compte vendeur",
            "all_modifications_taken": "Toutes les modifications ont été prises en compte.",
            "error_happened_wrong_param": "Une erreur est survenue, des champs sont peut-être incorrects?",
            "business_name": "Nom de l'entreprise",
            "business_address": "Adresse de l'entreprise",
            "zip_code": "Code postal",
            "city": "Ville",
            "region": "Région",
            "Numéro d'identification de votre entreprise (14 chiffres du Siret pour la France)": "N° d'identification de l'entreprise (14 chiffres du Siret pour la France)",
            "save_changes": "Enregistrer les modifications",
            "account_info_linked_business": "Les informations de votre compte vendeur sont liées à vos informations personnelles car vous êtes un vendeur particulier.",
            "become_pro": "Devenir vendeur pro",
            "password_security": "Mot de passe et sécurité",
            "actual_password": "Mot de passe actuel",
            "new_password": "Nouveau mot de passe",
            "confirm_your_new_password": "Confirmer votre nouveau mot de passe",
            "account_removal": "Toutes vos recherches, annonces, alertes, et trouvailles seront effacées.{0}Êtes-vous sûrs de vouloir supprimer votre compte?",
            "remove_my_account": "Supprimer mon compte",
            "action_will_disconnect": "Cette action vous déconnectera une fois validée. Votre compte ne sera plus accessible à partir de cet instant.",
            "confirm_account_removal": "Confirmer la suppression de mon compte",
            "personal_details": "Informations personnelles",
            "sell_parts_cpf": "Vendez vos pièces détachées{0}sur Classic Parts Finder",
            "publish_products_fast": "Diffuser vos annonces en quelques minutes!",
            "activate_seller_account": "Activer mon compte vendeur",
            "email_changing_to": "Demande de changement d'E-mail en cours vers",
            "address": "Adresse",
            "spoken_langage": "Langues parlées",
            "my_account": "Mon compte",
            "email_already_used_log": "L'adresse E-mail saisie est déjà utilisée. Veuillez dans ce cas vous connecter.",
            "cannot_register": "Impossible de vous enregistrer. Veuillez contacter le support de Classic Parts Finder à {1}",
            "nearly_there_login": "Vous y êtes presque! Il suffit de vous identifier pour créer votre recherche.",
            "nearly_there_register": "Vous y êtes presque! Afin de valider votre recherche, merci de renseigner votre adresse E-mail.",
            "already_have_account": "J'ai déjà un compte",
            "email_sent_confirm_research": "Veuillez consulter vos E-mails afin de confirmer votre inscription",
            "select_from_own": "Sélectionnez votre véhicule",
            "find_new_vehicle": "Ajoutez votre nouveau véhicule",
            "what_is_vehicle": "Quel est votre véhicule?",
            "brand_modele_etc": "Modèle, Marque",
            "cant_find_vehicle": "Je ne trouve pas mon véhicule dans la liste",
            "vehicle_not_found": "Véhicule non trouvé",
            "your_vehicle_not_found": "Votre véhicule",
            "keep_track_demand": "Cela nous permettra de vous tenir au courant de votre demande",
            "required_informations": "Information obligatoire",
            "thanks_demand": "Merci pour votre demande!",
            "email_contact_back": "Nous reviendrons vers vous par E-mail dès que le véhicule proposé sera disponible dans notre moteur de recherche.",
            "next_step": "Suivant",
            "your_email": "Votre E-mail",
            "add_vehicle": "Ajouter un véhicule",
            "previous_step": "étape précédente",
            "which_part_looking_for": "Quelle pièce recherchez-vous?",
            "part_name_etc": "Nom",
            "loading": "Chargement...",
            "which_kind_of_part": "Sélectionnez votre catégorie",
            "complementary_info": "Informations complémentaires",
            "lets_gain_time": "Renseignez du mieux possible votre recherche, sans quoi elle ne pourra être rapidement validée par notre équipe!",
            "year_vehicle": "Année du véhicule",
            "select_year": "Choisissez une année",
            "vehicle_version": "Version du véhicule",
            "motor_paint_etc": "Finition, Carrosserie, Motorisation",
            "part_precisions": "Vos précisions sur la pièce recherchée",
            "looking_version_part": "Je recherche...",
            "part_is_compatible": "Si cette pièce équipait d'autres véhicules, veuillez si possible les mentionner",
            "kind_of_part": "Vos exigences par rapport à la pièce recherchée",
            "part_type_guide": "Guide de typologie de pièces",
            "part_reference": "Réf. de la pièce et\/ou nom du fabricant",
            "reference_id_etc": "Référence ou numéro d'identification",
            "maximize_add_photos": "Photos ou schémas",
            "maximum_photos": "Maximum 5",
            "drop_files_here": "Déposez les fichiers ici",
            "or_if_prefer": "ou",
            "select_files": "Sélectionnez les fichiers",
            "remove": "Supprimer",
            "sending_progress": "Envoi en cours",
            "your_research": "Votre recherche",
            "brand_modele": "Modèle, Marque",
            "part_category": "Catégorie",
            "part_research": "Pièce recherchée",
            "vendor_account_ready": "Votre compte vendeur est prêt!",
            "account_secured_obvy": "Votre compte vendeur est sécurisé avec Stripe!",
            "and_now": "Et maintenant?",
            "can_sell_products": "Vous pouvez désormais vendre vos articles et recevoir votre argent.",
            "accept_paiements": "Accepter des paiements",
            "sell_with_obvy": "Vendez vos pièces en toute sérénité avec Stripe, notre partenaire qui sécurise vos ventes!",
            "secure_my_account": "Sécuriser mon compte",
            "go_further": "Envie d’aller plus vite?",
            "tell_part_category": "Indiquez seulement la catégorie de pièce que vous souhaitez vendre, et nous vous notifions dès que nous trouvons un acheteur.",
            "create_simplified_announce": "Créer mes alertes",
            "add_product": "Créer mes annonces",
            "create_first_product": "Créez votre première annonce, nous vous avertirons lorsque quelqu'un souhaite l’acheter.",
            "complete_later": "Accéder à mon tableau de bord",
            "all_rights": "Tous droits réservés",
            "new_simplified_announce": "Nouvelles alertes",
            "receive_mail_research": "Créez une alerte! Vous serez notifié dès que quelqu'un recherche une de vos pièces.",
            "vehicles_compatible": "Véhicule",
            "vehicles_with_alert": "",
            "brand_modeles_etc": "Modèle, Marque",
            "answer_by_mail": "Nous reviendrons vers vous par E-mail dès que le véhicule proposé sera disponible dans le système d'alertes.",
            "part_not_found": "Pièce non-trouvée",
            "your_unknown_part": "Votre pièce",
            "name_part": "Nom",
            "unknown_part_mail": "Nous reviendrons vers vous par E-mail dès que la pièce proposée sera disponible dans le système d'alertes.",
            "part_categories": "Catégories",
            "multiple_choices": "(plusieurs choix possibles)",
            "category_all_parts": "Toutes les pièces de la catégorie",
            "cant_find_part_list": "Je ne trouve pas ma pièce dans la liste",
            "activate_announce": "Activer les alertes!",
            "french_german": "Français, anglais, allemand...",
            "version_non_renseigne": "Version non renseignée",
            "new_research": "Recherche avancée",
            "see_vehicle": "Voir ma fiche véhicule",
            "find_by_brand_year_etc": "Rechercher par modèle, marque, année",
            "grid_display": "Affichage en grid",
            "line_display": "Affichage en ligne",
            "table_display": "Affichage en tableau",
            "confirm_vehicle_removal": "Êtes-vous sûr de vouloir supprimer le véhicule?",
            "all_research_removal": "Toutes les recherches{0}en cours vont être supprimées",
            "do_not_remove": "Ne pas supprimer",
            "searching_x_products": "Vous cherchez actuellement {0} pièce| Vous cherchez actuellement {0} pièces",
            "no_research_currently": "Aucune recherche en cours",
            "no_vehicles": "Cliquez sur l'onglet '+' afin d'ajouter un véhicule",
            "non_renseign": "non renseigné",
            "produit_suggr": "Pièce suggérée",
            "vehicle_details": "Détails de mon véhicule",
            "version": "Version",
            "add_version": "Ajouter une version",
            "year": "Année",
            "associated_researches": "Recherches associées",
            "see_x_findings": "Voir mes {length} trouvailles",
            "see_my_finding": "Voir ma trouvaille",
            "research_awaiting_validation": "Recherche en attente de validation",
            "experts_are_looking": "Nous recherchons votre pièce",
            "vehicle_parameters": "Paramètres du véhicule",
            "new_vehicle": "Nouveau véhicule",
            "name_too_short": "Nom trop court.",
            "name_too_long": "Nom trop long.",
            "update": "Mettre à jour",
            "what_is_your_vehicle": "Quel est votre véhicule?",
            "select_vehicle_first": "Sélectionnez d'abord un véhicule",
            "engine_bodywork_etc": "Finition, Carrosserie, Motorisation",
            "states_guide": "Guide des états",
            "administration": "Administration",
            "inbox": "Messagerie",
            "pice_suggre": "Pièce suggérée",
            "my_last_researches": "Mes dernières recherches",
            "no_researches_for_now": "Aucune recherche pour le moment",
            "all_my_researches": "Toutes mes recherches",
            "no_research_made": "Vous n'avez pas encore créé de recherche",
            "my_last_simplified_announces": "Mes dernières alertes",
            "no_simplified_announces_currently": "Aucune alerte pour le moment",
            "all_my_simplified_announces": "Toutes mes alertes",
            "didnt_config_seller_space": "Vous n'avez pas encore configuré votre espace vente",
            "configure": "Configurer",
            "new_part_for_your": "Besoin d'une pièce spécifique pour votre",
            "we_look_for_you": "Interrogez la communauté Classic Parts Finder!",
            "notifications": "Notifications",
            "all": "Toutes",
            "no_unread_notifications": "Aucune notification non lue",
            "someone_research_your_part": "Quelqu'un recherche une de vos pièces",
            "you_created_simplified_announce": "Vous avez créé une alerte",
            "we_found_product_for_you": "Nous avons trouvé une pièce pour vous",
            "you_created_research": "Vous avez créé une recherche",
            "part_attributed_to_research": "Une pièce a été attribuée à la recherche",
            "part_attributed_to_product": "Une pièce a été attribuée à l'article",
            "date": "Date",
            "part": "Catégorie\/Type",
            "see_simplified_announce": "Voir la recherche",
            "details": "Détails",
            "no_notification": "Aucune notification",
            "welcome_aboard": "Bienvenue à bord",
            "conversations": "Messages",
            "buying_product": "Achat de pièce(s)",
            "selling_product": "Vente de pièce(s)",
            "no_new_message": "Aucun nouveau message",
            "vous": "Vous",
            "sent_at": "Le {date}",
            "message_sent_for_validation": "Votre message sera envoyé dès validation par un administrateur.",
            "moderation_in_progress": "en modération",
            "sent": "Envoyé",
            "read": "Lu",
            "new_message": "Bonjour, ........ Merci",
            "from": "De :",
            "refused": "Refusé",
            "actual_message_to_moderate": "Message actuel à modérer",
            "missing_info_profil": "Informations manquantes sur votre profil",
            "required_info_to_continue": "Il est nécessaire d'entrer les informations suivantes afin de poursuivre :",
            "save_informations": "Enregistrer les informations",
            "my_orders": "Mes commandes",
            "reference": "Référence(s)",
            "amount": "Montant",
            "status": "Statut",
            "option": "Option",
            "options": "Options",
            "allow_sale": "Accepter la vente",
            "refuse_sale": "Refuser la vente",
            "paiement_accept": "Paiement accepté",
            "order_sent": "Commande expédiée",
            "confirm_reception": "Confirmer la réception",
            "do_reclamation": "Faire une réclamation",
            "reimburse_partiel": "Remboursement partiel",
            "reimburse_total": "Remboursement total",
            "no_order": "Vous n'avez pas encore de commande",
            "how_does_it_work": "Comment ça marche?",
            "advantages": "Avantages",
            "dashboard": "Tableau de bord",
            "selling_easy": "Avec{0}, vendre ses pièces détachées est un jeu d’enfants!",
            "create_market_fast": "Activez votre compte gratuitement!",
            "i_am_pro": "Je suis un professionnel",
            "i_am_individual": "Je suis un particulier",
            "receive_alert_research": "Soyez informé dès que quelqu'un recherche votre pièce!",
            "simplified_announce_explained": "Trop de pièces en stock et pas toujours le temps de publier vos annonces? Créez une alerte en quelques secondes!",
            "publish_products_fast_easy": "Ciblez une communauté de passionnés",
            "publish_large_catalog": "Publiez gratuitement vos annonces. Elles seront automatiquement envoyées auprès des collectionneurs de la communauté Classic Parts Finder, en ciblant précisément leur véhicule. Pour cela, nous avons élaboré une interface spécialement dédiée aux exigences de la vente de pièces détachées pour les véhicules anciens. Profitez également de nos conseils, de notre expertise, ainsi que de notre suivi client.",
            "ready_to_sell": "Prêt à vendre vos pièces?",
            "register_fast": "L'inscription ne vous prendra que quelques instants!",
            "free_service_part": "L'outil de référence des particuliers et professionnels pour la recherche, la vente de pièces pour voitures anciennes et de collection. Pièces originales ou rééditions de qualité pour véhicules anciens, Old- et Youngtimers.",
            "menu": "Menu",
            "take_my_research": "Je vous confie ma recherche",
            "facebook_link": "Lien vers la page Facebook Classic Parts Finder",
            "instagram_link": "Lien vers la page Instagram Classic Parts Finder",
            "privacy_policies": "Politiques de confidentialité",
            "cgu_full": "Conditions générales d'utilisation",
            "legals_info": "Mentions légales",
            "suivant": "Suivant",
            "valeurs_alphabtiques_uniquement": "Valeurs alphabétiques uniquement!",
            "doit_tre_compos_de_14_chiffres": "Doit être composé de 14 chiffres!",
            "valeur_numrique_uniquement": "Valeur numérique uniquement!",
            "n_de_siret": "N° de siret",
            "adresse_de_lentreprise": "Adresse de l'entreprise",
            "pays_de_lentreprise": "Siège de l'entreprise",
            "nom_de_lentreprise": "Nom de l'entreprise",
            "au_moins_2_caractres": "Au moins 2 caractères",
            "votre_nom": "Votre nom",
            "votre_prnom": "Votre prénom",
            "part_found": "{length} pièce trouvée | {length} pièces trouvées",
            "recherche_termine": "Recherche terminée",
            "la_recherche_a_t_archive": "Recherche archivée",
            "nos_experts_sont_en_cours_de_recherche": "Nous recherchons votre pièce",
            "faire_une_nouvelle_recherche": "Nouvelle recherche",
            "vous_souhaitez_acheter_des_pices_pour_votre_ancien": "Profitez de notre fonctionnalité inédite, en interrogeant les membres de la communauté.",
            "aucune_recherche": "Aucune recherche",
            "pas_de_recherche": "Pas de recherche",
            "product_found": "{length} pièce trouvée | {length} pièces trouvées",
            "dtails_de_la_recherche": "Détails de ma recherche",
            "suggested_product": "Pièce suggérée",
            "rechercher_par_modle_marque_produit_recherch": "Rechercher par modèle, marque, pièce...",
            "nous_sommes_dsols_nous_ne_sommes_pas_en_mesure_de": "Nous sommes désolés, nous ne sommes pas en mesure de récupérer ces informations pour le moment. Veuillez réessayer ultérieurement.",
            "recherches_avec_produits_trouvs": "Recherches avec pièces trouvées ({done}\/{total})",
            "afin_damliorer_la_qualit_de_nos_suggestions_pourri": "Afin d'améliorer la qualité des annonces, merci de préciser les raisons de votre choix:",
            "je_cherche_une_pice_en_meilleur_tat_le_prix_est_tr": "Je cherche une pièce en meilleur état, le prix est trop élevé, etc...",
            "nous_envoyer_une_suggestion": "Nous envoyer une suggestion",
            "quelle_est_votre_question_pour_ce_vendeur": "Quelle est votre question pour ce vendeur?",
            "en_savoir_plus_sur_obvy": "En savoir plus sur Stripe",
            "achat_scuris_avec": "Achat sécurisé avec",
            "trop_tard_ce_produit_nest_plus_disponible": "Cette pièce n'est plus disponible.",
            "en_savoir_plus": "En savoir plus",
            "grce_la_garantie_cpf": "",
            "achetez_en_toute_srnit": "Pourquoi nous faire confiance?",
            "frais_de_port_en_sus_calculer_selon_le_mode_de_liv": "Frais d'envoi en sus à calculer selon le mode de livraison proposé par le vendeur.",
            "colis_remis_au_transporteur_sous_jours": "(Colis remis au transporteur sous {averagepreparationtime} jours)",
            "expdition": "Expédition",
            "hors_frais_de_ports": "(hors frais d'envoi)",
            "prix": "Prix TTC",
            "dimensions_du_produit": "Dimensions (L x l x H)",
            "poids_du_produit": "Poids du colis",
            "jours": "{average_preparation_time} jours",
            "temps_moyen_de_prparation": "Temps moyen de préparation",
            "contacter_le_vendeur": "Poser une question",
            "vendu_directement_par_cpf": "Vendu directement par CPF",
            "seller": "Vendeur",
            "a_propos_du_vendeur": "A propos du vendeur",
            "fabricant": "Fabricant",
            "rfrence_du_produit": "Référence(s) de la pièce",
            "description": "Description",
            "state": "Etat :",
            "facebook": "Facebook",
            "copier_le_lien": "Copier le lien",
            "partager_le_produit": "Partager l'annonce",
            "trouvailles_par_page": "Trouvailles par page",
            "ce_formulaire": "ce formulaire",
            "vous_pouvez_nous_faire_votre_demande_via": "Vous pouvez nous faire votre demande via",
            "assistance_en_cas_de_litige": "Assistance en cas de litige, et sans chatbots!",
            "larticle_doit_tre_retourn_dans_son_tat_dorigine_et": "Le bien doit être retourné dans son état d’origine, et sans aucun signe d’utilisation. Les frais d’expédition de retour sont à la charge de l’acheteur, à moins que l’article n’ait pas été reçu conforme à sa description. L’acheteur reçoit un remboursement intégral, déduction faite des frais d’envoi.",
            "si_achat_auprs_dun_professionnel": "(si achat auprès d’un professionnel)",
            "droit_de_rtractation_de_14_jours": "Droit de rétractation de 14 jours",
            "garantie_lgale_des_vices_cachs": "",
            "garantie_lgale_de_conformit_du_bien": "Garantie légale de conformité du bien",
            "remboursement_total_ou_partiel_en_cas_de_perte_ou": "",
            "suivi_de_livraison_si_choix_via_mondial_relay_ou_c": "Garantie légale des vices cachés",
            "tarifs_de_livraison_ngocis_mondial_relay_et_chrono": "",
            "scurisation_des_fonds_protection_de_lacheteur_et_d": "Protection contre la fraude via notre partenaire Stripe",
            "garantie_de_paiement_sur_compte_squestre": "Garantie de transaction sécurisée",
            "garantie_de_transaction_scurise": "",
            "paiement_par_carte_ou_par_virement": "Nous ne publions que les annonces qui ont été vérifiées par nos soins. Les utilisateurs et les comportements suspects sont ainsi plus facilement et plus rapidement identifiés.",
            "garantie_classic_parts_finder": "Les avantages de Classic Parts Finder",
            "la_recherche_nest_pas_disponible": "Cette recherche n'est plus active",
            "donnez_nous_plus_de_dtails_sur_le_produit_que_vous": "Donnez-nous plus de détails sur la pièce que vous recherchez",
            "je_cherche_des_produits_neufs_les_prix_sont_trop_l": "Je cherche une pièce en meilleur état, le prix est trop élevé...",
            "pas_encore_de_trouvailles": "",
            "dgivrer_loffre": "Dégivrer l’offre",
            "vous_avez_chang_davis": "",
            "offre_refuse": "Offre déclinée",
            "consulter_loffre": "Consulter l’offre",
            "la_recherche_est_en_attente_de_validation": "Votre recherche est en attente de validation",
            "research_continues": "La recherche se poursuit, mais nous avons trouvé {size} pièce qui pourrait déjà vous convenir | La recherche se poursuit, mais nous avons trouvé {size} pièces qui pourraient déjà vous convenir",
            "les_trouvailles": "Mes recherches",
            "la_recherche_est_termine": "La recherche est terminée",
            "date_de_la_recherche": "Date de la recherche",
            "rfrence_du_produit2": "Numéro\/code de référence",
            "dtails": "Détails",
            "type_de_produit": "Type de pièce",
            "produit_recherch": "Pièce recherchée",
            "dtails_de_votre_recherche": "Détails de ma recherche",
            "product_suggested": "Pièce suggérée",
            "pour": "pour",
            "oups": "Oups...",
            "votre_recherche_est_introuvable_ou_a_dj_t_prolonge": "Votre recherche est introuvable ou a déjà été prolongée.",
            "accder_mon_tableau_de_bord": "Accéder à mon tableau de bord",
            "cest_not": "C'est noté!",
            "votre_recherche_a_bien_t_prolonge": "Votre recherche a bien été prolongée.",
            "accder_mon_tableau_de_bord2": "Accéder à mon tableau de bord",
            "bienvenue": "Bienvenue {expr}",
            "activer": "Activer",
            "dsactiver": "Désactiver",
            "dsactiv": "Désactivé",
            "en_attente_dune_recherche": "En attente d’une recherche",
            "voir_les_recherches": "Voir les recherches",
            "rfrence_de_la_pice": "Numéro\/code de référence",
            "localisation_de_lacheteur": "Localisation de l'acheteur",
            "date_de_la_recherche2": "Date de la recherche",
            "votre_question_pour_cet_acheteur_potentiel": "Votre question pour ce demandeur?",
            "proposer_un_produit": "Proposer une pièce",
            "si_vous_avez_besoin_dlments_plus_prcis_en_rapport": "(Veuillez noter que les conversations sont soumises à modération)",
            "contacter_lacheteur_potentiel": "Poser une question",
            "propos_de_lacheteur": "À propos de l’acheteur",
            "compatible_avec": "Compatible avec",
            "crer_mes_annonces_simplifies": "Créer mes alertes",
            "vous_souhaitez_vendre_des_produits_indiqueznous_si": "Trop de pièces en stock et pas toujours le temps de publier vos annonces? Créez une alerte en quelques secondes!",
            "aucune_annonces_simplifies": "Aucune alerte",
            "aucune_annonce_simplifie_ne_correspond_aux_filtres": "Aucune alerte ne correspond aux filtres",
            "supprimer_la_slection": "Supprimer la sélection",
            "annonce_dsactive": "Alerte désactivée",
            "rechercher_par_marque_modle": "Rechercher par marque",
            "vous_navez_pas_encore_de_vente": "Vous n'avez pas encore de vente",
            "commande_livr": "Commande livré",
            "mes_ventes": "Mes ventes",
            "si_malgr_tout_la_vente_na_pas_lieu_vous_navez_pas": "Si la vente n'a pas lieu, vous n'avez pas perdu votre temps! Votre annonce est diffusée et sera communiquée auprès de la communauté!",
            "le_produit_sera_transmis_lacheteur_aprs_validation": "Votre proposition sera transmise à l'acheteur après validation par un administrateur.",
            "confirmation_dajout_du_produit": "Confirmation d'ajout de pièce",
            "ajouter_mon_premier_produit": "Ajouter ma première pièce",
            "crez_et_diffusez_vos_annonces_sur_classic_parts_fi": "",
            "aucun_produit": "Aucune pièce",
            "supprimer_la_selection": "Supprimer la sélection",
            "aucun_produit_ne_correspond_votre_recherche": "Aucune annonce ne correspond à votre recherche",
            "diffuser": "Diffuser",
            "votre_produit_sera_diffus_ds_validation_par_un_adm": "Votre annonce sera diffusée dès validation par un administrateur.",
            "exporter_vos_produits": "Exporter vos annonces",
            "rechercher_par_type_de_produit_modle": "Rechercher par nom de pièce",
            "catgorie": "Catégorie",
            "lannonce_simplifie_nest_pas_disponible": "Trop tard! Il semble que l'acheteur ait déjà trouvé son bonheur...",
            "complter_la_fiche_produit": "Créer une annonce",
            "vrifier_que_vous_navez_pas_dj_cette_pice_dans_votr": "Vérifiez que vous n'avez pas déjà publié cette pièce (rubrique 'Mes annonces').",
            "de_quelques_informations_complmentaires_sur_votre": "de quelques informations complémentaires sur votre pièce",
            "nous_avons_dsormais_besoin": "Nous avons désormais besoin",
            "flicitations": "Félicitations!",
            "a_propos_de_lacheteur": "A propos de l’acheteur",
            "pas_cette_piece": "Je n’ai pas cette pièce",
            "jai_trait_ce_produit": "J'ai traité cette demande",
            "en_attente_de_traitement": "Requête à traiter",
            "je_nai_pas_le_produit": "Je n'ai pas la pièce",
            "vous_avez_chang_davis2": "Vous avez changé d'avis?",
            "jai_trait_ce_produit2": "J'ai traité cette demande",
            "jai_ce_produit": "Revoir la demande",
            "vous_avez_le_produit": "",
            "je_nai_pas_ce_produit2": "Je n’ai pas cette pièce.",
            "acheteur": "acheteur potentiel | acheteurs potentiels",
            "vos_acheteurs_potentiels": "Vos acheteurs potentiels",
            "date_de_publication": "Date de publication :",
            "catgorie_cible": "Catégorie ciblée",
            "pice_cible": "Pièce ciblée",
            "dtails_de_lannonce_simplifie": "Détails de l'alerte",
            "dtails_de_votre_annonce_simplifie": "Détails de votre alerte",
            "rsultats_de_mon_annonce": "Résultats de mon alerte",
            "je_nai_pas_trouv_ma_pice": "Je n'ai pas trouvé ma pièce",
            "diffuser_le_produit": "Diffuser l'annonce",
            "en_cours_denvoi": "En cours d'envoi",
            "brouillon": "Brouillon",
            "temps_moyen_de_prparation_jours": "Temps moyen de préparation : {0} jour | Temps moyen de préparation : {0} jours",
            "aperu_et_diffusion": "Aperçu et diffusion",
            "les_frais_lis_une_livraison_sont_la_charge_de_lach": "Les frais de livraison seront pris en charge par l'acheteur.",
            "longueur": "Longueur",
            "largeur": "Largeur",
            "hauteur": "Hauteur",
            "remise_en_main_propre_uniquement": "Remise en main propre uniquement",
            "remise_en_main_propre_et_envoi_postal": "Remise en main propre et envoi postal",
            "envoi_postal": "Envoi postal",
            "veuillez_slectionner_une_option": "Veuillez sélectionner une option",
            "mode_de_transport_du_produit": "Mode de transport proposé",
            "dlai_avant_remise_au_transporteur": "Délai avant remise au transporteur",
            "pensez_lemballage_arrondir_au_dessus": "Pensez bien au poids de votre emballage.",
            "poids_approximatif_du_produit": "Poids approximatif de votre colis",
            "oui": "Oui",
            "non": "Non",
            "le_prix_estil_ngociable": "Le prix est-il négociable?",
            "est_destine_couvrir_les_frais_de_recherche_et_de_t": "-à la charge de l'acheteur- est destinée à couvrir les frais de fonctionnement et de transaction.",
            "la_commission_de": "Une commission de",
            "the_selling_price": "Le prix de vente sera donc affiché à",
            "pour_vous": "Votre prix (TTC)",
            "indiquez_le_prix_de_vente_hors_livraison_minimum_2": "Indiquez le prix de vente hors livraison (minimum 2€).",
            "prix_de_vente_affich": "Prix de vente affiché",
            "prix_et_livraison": "Prix et livraison",
            "dplacer": "Déplacer",
            "rotation": "Rotation",
            "slectionnez_les_photos": "Sélectionnez les photos",
            "dposez_les_photos_de_votre_produit_ici": "Déposez ici vos photos",
            "maximiser_vos_chances_de_vendre_en_proposant_plusi": "Maximiser vos chances de vendre en proposant plusieurs photos sous différents angles!",
            "cette_pice_convient_aux_modles_dans_son_emballage": "Précisions sur l'état, l'historique, la compatibilité de la pièce, etc...",
            "merci_de_prciser_du_mieux_possible_les_spcificits": "Merci de préciser du mieux possible les spécificités de votre pièce!",
            "rfrence_interne_votre_stock_invisible_pour_lachete": "Référence interne à votre stock (invisible pour l'acheteur)",
            "typologie_de_la_produit": "Type de pièce recherchée",
            "etat_du_produit": "Etat",
            "quantit_disponible": "Quantité disponible",
            "titre_nom_prcis_du_produit": "Titre de votre annonce",
            "informations_gnrales": "Description",
            "votre_produit_pourra_tre_diffus_aprs_la_validation": "Votre annonce pourra être diffusée après la validation d'un administrateur",
            "nom_de_votre_produit": "Nom de votre pièce",
            "vous_ne_trouvez_pas_votre_produit": "Vous ne trouvez pas votre pièce?",
            "nom_du_produit": "Nom",
            "indiquez_le_nom_du_produit": "Indiquez le nom à partir de la liste",
            "type_de_produit_catgorie": "Pièce",
            "ce_produit_est_compatible_pour_les_modles": "Cette pièce est compatible pour...",
            "nouveau_produit": "Nouvelle annonce",
            "edition_de_produit": "Editer l'annonce",
            "recherches_par_page": "Alertes par page",
            "tous": "Tous",
            "prcdent": "Précédente",
            "operational_fees": "Frais de transactions",
            "selling_price": "Prix de vente",
            "lments_slectionns": "élément(s) sélectionné(s)",
            "dslectionner_tout": "Désélectionner tout",
            "tous_les_produits_de_la_catgorie": "Toutes les pièces de la catégorie",
            "image": "Image",
            "marque": "Marque",
            "modle": "Modèle",
            "recherches": "Recherches",
            "dition": "Édition",
            "sure_supprimer_ces_annonces_simplifies": "Êtes-vous sûr de vouloir supprimer ces alertes?",
            "sure_supprimer_cette_annonce_simplifie": "Êtes-vous sûr de vouloir supprimer cette alerte?",
            "annonces_par_page": "Annonces par page",
            "titre_de_lannonce": "Titre de l'annonce",
            "filtrer_par_nom": "Filtrer par nom",
            "filtrer_par_type_de_produit": "Filtrer par type de pièce",
            "marque_modle": "Marque \/ Modèle",
            "filtrer_par_modle": "Filtrer par modèle",
            "rfrence_interne": "Numéro\/code de réf. interne",
            "filtrer_par_rfrence": "Filtrer par numéro\/code de référence",
            "stock": "Stock",
            "etat": "Etat",
            "moderation_diffus": "Modération",
            "pas_de_modle": "Pas de modèle",
            "pas_de_ref_interne": "Pas de référence interne",
            "sure_supprimer_produit": "Êtes-vous sûr de vouloir supprimer l'annonce?",
            "max_photos": "10 photos maximum",
            "the_buyer": "L'acheteur",
            "the_seller": "Le vendeur",
            "sure_supprimer_vehicule": "Êtes-vous sûr de vouloir supprimer le véhicule?",
            "sure_supprimer_research": "Êtes-vous sûr de vouloir supprimer cette recherche?",
            "action": "Action",
            "type": "Type",
            "diffus": "Diffusée",
            "optional": "Optionnel",
            "max_vehicles_in_list": "Nombre maximum de véhicules atteint",
            "no_product_for_the_moment": "Aucune pièce ne correspond à votre recherche",
            "espace_recherche": "Espace recherche",
            "espace_vente": "Espace vente",
            "we_may_have_more_products_in_stock_for_this_vehicle": "Nous avons peut-être d'autres pièces pour ce véhicule!",
            "sur": "sur",
            "next": "Suivant",
            "vehicles_per_page": "Véhicules par page",
            "page": "page",
            "pro_seller": "Vendeur professionnel",
            "private_seller": "Vendeur particulier",
            "before_continuing": "Avant de continuer!",
            "not_search_engine_search_service_give_us_search_distribute_entire_classic_parts_finder_community_collectors_garages_breakers_etc": "Bienvenue dans la communauté Classic Parts Finder! Si vous recherchez une pièce en particulier, vous pouvez ici lancer votre recherche, que nous diffuserons auprès des membres.",
            "prefer_view_parts_already_available_classic_parts_finder_simply_register_enter_vehicle_model": "Si vous préférez consulter les annonces existantes, inscrivez-vous et renseignez votre véhicule.",
            "register_add_vehicle": "Je m’inscris et j’ajoute mon véhicule",
            "understand": "J'ai compris",
            "start_research": "Lancer une recherche",
            "These credentials do not match our records.": "Nous ne trouvons pas de compte correspondant.",
            "process_request": "Voir la demande",
            "parts_available_2": "Pièces actuellement disponibles",
            "delete_research": "Supprimer",
            "bulk_upload_a_file": "Téléverser un fichier",
            "bulk_column_mapping": "Mappage colonne",
            "bulk_import": "Importation",
            "bulk_importing_ads_file": "Importer des annonces depuis un fichier",
            "bulk_tool_allows_import_merge_ad_data_shop_excel_csv_file": "Cet outil vous permet d’importer (ou de fusionner) des données d’annonces dans votre boutique à partir d’un fichier Excel ou CSV.",
            "bulk_list_mandatory_fields": "Liste des champs obligatoires",
            "bulk_download_info": "Télécharger notre modèle de <a href='\/assets\/classic-parts-finder-import-example.csv'>fichier CSV<\/a> ou <a href='\/assets\/classic-parts-finder-import-example.xlsx'>Excel<\/a>.",
            "bulk_vehicle_model": "Modèle du véhicule",
            "bulk_brand_vehicle": "Marque du véhicule",
            "bulk_name_piece": "Nom\/Type de pièce",
            "bulk_title_ad": "Titre de votre annonce",
            "bulk_quantity": "Quantité",
            "bulk_url_image_1": "URL de l'image principale",
            "bulk_state": "État",
            "bulk_info": "infos",
            "bulk_type": "Type",
            "bulk_description": "Description",
            "bulk_price": "Prix en € TTC",
            "bulk_approximate_weight_piece": "Poids de la pièce en Kg",
            "bulk_proposed_mode_transport": "Mode de transport proposé",
            "bulk_show_optional_fields": "Afficher les champs facultatifs",
            "bulk_hide_optional_fields": "Masquer les champs facultatifs",
            "bulk_list_optional_fields": "Liste des champs facultatifs",
            "bulk_internal_reference": "Référence interne",
            "bulk_year_vehicle": "Année du véhicule",
            "bulk_manufacturer": "Fabricant",
            "bulk_reference_part": "Référence de la pièce",
            "bulk_price_negotiable": "Le prix est-il négociable?",
            "bulk_time_delivery_carrier_days": "Délai avant remise au transporteur (jours)",
            "bulk_height": "Hauteur",
            "bulk_width": "Largeur",
            "bulk_lenght": "Longueur",
            "bulk_url_image_2": "Url image 2",
            "bulk_url_image_3": "Url image 3",
            "bulk_url_image_4": "Url image 4",
            "bulk_url_image_5": "Url image 5",
            "bulk_start": "Commencer",
            "bulk_configuration_import_parameters": "Configuration des paramètres d'importation",
            "bulk_select_file_computer": "Choisir un fichier à partir de votre ordinateur",
            "bulk_maximum_size_8_mb": "Taille maximum 8 Mo",
            "bulk_csv_separator": "Séparateur CSV",
            "bulk_offer_ads_compatible_vehicles": "Proposer les annonces aux véhicules compatibles?",
            "bulk_checked_parts_will_displayed_compatible_vehicles_according_classic_parts_finder_database": "Si coché, vos pièces seront affichées comme compatibles avec d'autres véhicules selon la base de données de Classic Parts Finder.",
            "bulk_can_make_adjustment_individually_ad_import": "Vous pouvez effectuer ce réglages individuellement, sur chaque annonce, après l'importation.",
            "bulk_update_already_imported_ads": "Mettre à jour les annonces déjà importées?",
            "bulk_check_box_want_update_ads_already_imported": "Cochez cette case si vous souhaitez mettre à jour des annonces que vous avez déjà importées.",
            "bulk_important": "Important",
            "bulk_internal_reference_new_ads_must_identical_internal_reference_ads_already_imported": "La référence interne des nouvelles annonces doit être identique à la référence interne des annonces déjà importées.",
            "bulk_ignore_first_line_file": "Ignorer la première ligne du fichier?",
            "bulk_check_box_first_line_file_not_ad_example_named_columns": "Cochez cette case si la première ligne de votre fichier n'est pas une annonce. Par exemple, si vous avez nommé vos colonnes.",
            "bulk_previous_step": "Etape précédente",
            "bulk_continue": "Continuer",
            "bulk_associate_fields_file": "Associez les champs de votre fichiers",
            "bulk_column_choose_corresponding_criterion": "Pour chaque colonne, choisissez le critère correspondant.",
            "bulk_columns_file": "Colonnes de votre fichier",
            "bulk_correspondence": "Correspondance",
            "bulk_column": "Colonne",
            "bulk_not_assigned": "Non attribué",
            "bulk_required": "Obligatoire",
            "bulk_start_import": "Lancer l'importation",
            "bulk_import_started_will_not_able_cancel_check_columns_mapped_correspond_field_selected": "Une fois l’importation lancée vous ne pourrez plus l’annuler. Vérifiez bien que les colonnes que vous avez mapper correspondent bien au champ que vous avez sélectionné.",
            "bulk_successful_column_mapping": "Mapping des colonnes réussi!",
            "bulk_successful_column_mapping_description": "Vos annonces sont maintenant en cours d’importation. Nos robots donnent le meilleurs d'eux mêmes pour importer toutes vos annonces dans les meilleurs délais.  Vous pouvez quitter la page, vous serez averti par e-mail lorsque l’importation sera terminée.",
            "bulk_back_ads": "Retourner sur mes annonces",
            "btn_bulk_import": "Importer en masse",
            "status_to_be_verified": "À vérifier",
            "transport_propose_global_description": "",
            "transport_propose_description_1": "",
            "transport_propose_description_2": "",
            "transport_propose_description_3": "",
            "notice_cpf_title": "Le point de vue de Classic Parts Finder",
            "original_notice": "Voir dans la langue d'origine",
            "add_personal_comment": "Un commentaire à apporter? Exprimez-vous!",
            "report_ad": "Signaler cette annonce",
            "automatically_translated": "Traduit automatiquement",
            "view_original": "Voir l'original",
            "hide_original": "Masquez l'original",
            "price_negotiable_explanation": "",
            "price_negotiable_title_0": "Le prix de votre annonce n'est pas négociable",
            "price_negotiable_description_0": "",
            "price_negotiable_title_1": "Le prix de votre annonce est négociable",
            "price_negotiable_description_1": "",
            "no_research_alert": "Aucune recherche liée à cette pièce",
            "french": "Français",
            "english": "Anglais",
            "german": "Allemand",
            "image_is_processing": "Images en cours d'importation",
            "empty_car_title": "Aucun véhicule",
            "empty_car_description": "",
            "empty_car_add_first_car": "Ajouter mon premier véhicule",
            "own_research_title": "Vous ne trouvez pas votre pièce?",
            "contact": "Contact",
            "already_registered": "Déjà inscrit ?",
            "log_on_to": "Connectez-vous",
            "confirm_room_removal": "Êtes-vous sûr de vouloir supprimer la conversation ?",
            "confirm": "Confirmer",
            "msg_search_alert": "Alerte de recherche",
            "msg_product_is_no_longer_available": "L'article n'est plus disponible",
            "msg_you_have_no_conversation": "Aucune conversation",
            "msg_name_of_the_conversation": "Renommer la conversation",
            "msg_modify_advert": "Modifier l'annonce",
            "msg_modify_name_conversation": "Renommer la conversation",
            "msg_no_conversation_selected": "Sélectionnez une conversation",
            "shipping_address": "Adresse de livraison",
            "send_offer": "Confirmer la commande",
            "reservation_success": "Votre commande a été envoyée avec succès. Nous vous contacterons sous un délai de 24h maximum, en vous communiquant les meilleurs tarifs de livraison.",
            "well_done": "Bravo !",
            "thanks_trust": "Merci pour votre confiance",
            "parts_reservation": "Achat",
            "parts_reservation_description": "",
            "make_offer": "Acheter",
            "day": "{average_preparation_time} jour",
            "address_2": "Adresse (suite)",
            "activate_stripe_account": "Activer votre compte Stripe",
            "resume_stripe_activation": "Poursuivre l'activation de mon compte",
            "check_stripe_account": "Voir mon compte Stripe",
            "stripe_redirection_message": "Vous allez être redirigé dans quelques instants, veuillez patientez...",
            "stripe_onboarding_success": "L'inscription s'est terminée correctement, vous allez être redirigé",
            "stripe_onboarding_failure": "L'inscription ne s'est pas terminée correctement, vous allez être redirigé",
            "making_offer_widget_menu_title": "Modifier mon offre",
            "shipping_widget_menu_title": "Indiquer les frais d'envoi",
            "buyer_not_specified_shipping_address": "L'acheteur n'a pas encore précisé d'adresse de livraison, commencez par lui demander celle-ci.",
            "request_shipping_address": "Demander l'adresse de livraison",
            "stripe_account_not_activated": "Vous n'avez pas encore activé votre compte vendeur sur Stripe. Ceci est nécessaire afin de finaliser la vente.",
            "shipping_widget_title": "J’ajoute les frais d'envoi",
            "already_know_cost": "Je connais déjà le coût",
            "hand_delivered": "Remise en main propre",
            "product_price": "Prix de la pièce",
            "shipping_costs": "Frais de livraison",
            "no_shipping_costs": "Aucun frais de livraison",
            "shipping_widget_select_label": "Mode de livraison",
            "shipping_widget_alert": "Attention : Le mode de livraison actuellement sélectionné ne correspond pas à celui souhaité par l'acheteur :",
            "total": "Total",
            "do_not_know_cost": "Je ne connais pas le coût",
            "calcul_shipping_cost_instruction": "Afin de vous faciliter la vie, nous vous invitons à utiliser un outil comparateur d'envoi de colis. Nous recommandons 'Packlink', mais n'hésitez pas à tester d'autres solutions équivalentes proposées dans votre pays.",
            "calculate_cost": "Calculer",
            "warning": "Attention",
            "shipping_widget_send_proposal_btn": "Envoyer ma proposition",
            "making_offer_widget_title": "Modifier mon offre",
            "actual_price": "Prix actuel",
            "cpf_commission_included": "Commission CPF incluse",
            "cpf_commission_explanation_cost": "Une commission de {0} est destinée à couvrir les frais de fonctionnement et de transaction. La somme de {1} vous sera reversée.",
            "if_buyer_accept_offer_condition": "Si cette offre est acceptée par l’acheteur vous ne pourrez plus changer votre prix, et la vente sera définitivement validée.",
            "making_offer_widget_next_step_btn": "Étape suivante",
            "add_my_shipping_address": "Mon adresse de livraison",
            "confirm_shipping_address": "Intention d'achat",
            "confirm_my_address": "Valider l'adresse de livraison",
            "confirm_shipping_address_explanation": "Pour une livraison, veuillez confirmer votre adresse afin que le vendeur puisse calculer les frais d'envoi (seuls le code postal et la ville lui seront d'abord communiqués).",
            "change_shipping_address": "Modifier l'adresse de livraison",
            "hand_delivery_only": "Remise en main propre uniquement",
            "hand_delivery_only_explanation": "Veuillez discuter avant votre achat des modalités d'enlèvement avec le vendeur.",
            "understood": "J'ai compris",
            "seller_message_template_7": "Une notification a été envoyée à l'acheteur afin qu’il confirme son adresse de livraison.",
            "buyer_message_template_7": "Bonjour,\nAfin de connaître le coût total de la transaction, le vendeur doit estimer les frais d'envoi. Merci de confirmer votre adresse de livraison.",
            "buyer_action_template_7": "Confirmer votre adresse de livraison",
            "admin_message_template_7": "Une notification a été envoyée à l'acheteur afin qu’il confirme son adresse de livraison.",
            "seller_message_template_8": "Parfait! Votre correspondant a validé son adresse de livraison : {0} L’adresse complète vous sera transmise une fois la transaction terminée.",
            "seller_action_template_8": "Indiquer les frais d'envoi",
            "buyer_message_template_8": "Le vendeur va désormais calculer les frais de livraison pour cette adresse : {0}",
            "admin_message_template_8": "L'acheteur a validé son adresse de livraison : {0}",
            "seller_message_template_9": "Votre correspondant est informé de votre nouvelle offre : {0} {1} {2} \n Déduction des frais de commissionnement, il vous sera versé la somme de {3} \n La proposition a été lue: {4}",
            "buyer_message_template_9": "Ma nouvelle proposition est ici! Je propose d'adapter le prix de vente: {0} \n {1} {2} {3}",
            "buyer_action_template_9": "Acheter maintenant",
            "admin_message_template_9": "Voici une nouvelle offre du vendeur: {0} {1} {2}",
            "seller_message_template_10": "Une notification a été envoyée à votre correspondant : {0} {1} {2} \n Déduction des frais de commissionnement, il vous sera versé la somme de {3}\n\nSi vous le jugez nécessaire, vous pouvez lui envoyer un petit message personnalisé, et si vous n'avez pas de nouvelles de sa part après 48h, nous vous invitons à le relancer via la messagerie.",
            "buyer_message_template_10": "Détails de votre offre : {0} {1} {2}",
            "buyer_action_template_10": "Acheter maintenant",
            "admin_message_template_10": "Voici l'offre proposée par le vendeur : {0} {1} {2}",
            "seller_message_template_11": "Bonne nouvelle, {0} souhaite vous acheter votre pièce {1} au prix indiqué. \nVeuillez calculer les frais d'envoi pour une livraison à son adresse : {2} L’adresse complète vous sera transmise une fois la transaction terminée.",
            "seller_action_template_11": "Indiquer les frais de livraison",
            "buyer_message_template_11": "Vous serez notifié par E-Mail dès que le vendeur aura calculé les frais de livraison pour cette adresse : {0} N'hésitez pas à écrire un message si vous avez des exigences particulières",
            "admin_message_template_11": "Demande au vendeur de calculer les frais de livraison à cette adresse : {0}",
            "seller_message_template_12": "Bravo! \n{0} vient d'acheter votre pièce au prix de {1}. Déduction des frais de commissionnement, il vous sera versé la somme de {2}. Il est temps pour vous de l'envoyer via le transporteur que vous avez choisi à l'adresse suivante : {3}",
            "seller_hand_delivery_message_template_12": "Bravo! \n{0} vient d'acheter votre pièce au prix de {1}. Il est temps pour vous de convenir d'un rendez-vous afin de la collecter.",
            "check_list_step_1_message_template_12": "Transaction confirmée",
            "check_list_step_2_message_template_12": "Confirmer l’expédition du colis",
            "check_list_step_3_message_template_12": "Déblocage des fonds",
            "check_list_step_2_description_message_template_12": "Vous disposez de 72 heures maximum pour l'envoyer (veuillez sinon l'avertir au plus vite).",
            "check_list_step_2_button_message_template_12": "Confirmer l’expédition",
            "buyer_message_template_12": "Merci! \nNous venons de prévenir le vendeur de votre achat. Sauf contre-ordre, ce dernier dispose de 72 heures maximum pour vous l'envoyer.",
            "buyer_hand_delivery_message_template_12": "Merci! \nNous venons de prévenir le vendeur de votre achat. Contactez-le afin de définir d'une date d'enlèvement.",
            "admin_message_template_12": "L'achat a été confirmé par {0} pour un total de {1}.",
            "seller_message_template_13": "👋 Bonne nouvelle, quelqu'un s'intéresse à votre annonce!\n\nSi besoin, vous pouvez utiliser le bouton situé en bas à droite afin de modifier votre prix de vente ou les frais d'expédition. Veuillez noter que votre communication avec l'acheteur peut être soumise à modération et que l'échange de coordonnées est proscrit. Pour toute question, n'hésitez pas à nous contacter à <a class='basic-link' href='mailto:info@classic-parts-finder.com'>info@classic-parts-finder.com<\/a>\n\nL'équipe Classic Parts Finder 🚗✨",
            "buyer_message_template_13": "👋 Bienvenue dans votre espace de messagerie et de paiement !\n\nVeuillez noter que toute conversation peut être soumise à modération, et l'échange de coordonnées est proscrit. Nous sécurisons ainsi la transaction, le financement de la plateforme et vous bénéficiez de notre assistance en cas de litige.\n\nPour toute question, n'hésitez pas à nous contacter à <a class='basic-link' href='mailto:info@classic-parts-finder.com'>info@classic-parts-finder.com<\/a>\n\nL'équipe Classic Parts Finder 🚗✨",
            "admin_message_template_13": "Régles du fil de discussion",
            "admin_name_template_13": "",
            "if_wish_change_shipping_address_instructions": "Si vous souhaitez changer d'adresse de livraison, merci d'avertir le vendeur, qui recalculera les frais d'envoi avec votre nouvelle adresse.",
            "payment_title": "Paiement sécurisé",
            "buyer_payment_more_informations": "Soyez rassuré, votre argent est sécurisé durant toute la durée de la transaction. Vous disposerez de 48h pour signaler un problème après réception.",
            "stripe_error_code": "Code d'erreur",
            "stripe_redirect_error_code": "Une erreur est survenue lors du paiement. Veuillez réessayer.",
            "buy_with_stripe": "Régler via",
            "payment_in_progress": "Paiement en cours",
            "offer_no_longer_available": "L'offre n'est plus disponible...",
            "card_holder_name": "Nom du titulaire de la carte",
            "stripe_create_acount_explanation": "Si vous rencontrez des problèmes lors de la configuration de votre compte vendeur via Stripe, veuillez nous contacter par e-mail à l'adresse suivante : info@classic-parts-finder.com",
            "stripe_account": "Compte Stripe",
            "stripe_find_out_more": "En savoir plus sur Stripe",
            "see_product": "Voir",
            "contact_administrator": "Contacter l'administrateur",
            "verified_identity": "Identité vérifiée",
            "order_validation": "Validation de votre achat",
            "contact_details": "Coordonnées de contact",
            "order_summary": "Résumé de votre commande",
            "displayed_selling_price": "Prix de vente affiché",
            "cpf_commission_included_price": "Commission CPF de {0} incluse",
            "for": "pour",
            "phone_number_required_for_delivery": "Numéro de téléphone requis pour assurer le suivi de la livraison",
            "message_price_proposal_buyer_is_ue_and_seller_not_ue": "Cette pièce se trouve dans un pays situé hors de l'Union Européenne. Des frais de douanes pourraient s'appliquer à la livraison.",
            "message_price_proposal_buyer_not_ue": "Cette pièce se trouve dans un pays différent du vôtre. Des frais de douanes pourraient s'appliquer à la livraison.",
            "whats_prefered_shipping_mode": "Mode de livraison souhaité?",
            "no_preference": "Indifférent",
            "home_delivery": "Livraison à domicile",
            "relay_point_delivery": "Point relais",
            "by_hand_delivery": "Remis en main propre",
            "by_hand_delivery_alert": "Veuillez contacter le vendeur afin de convenir d’un lieu et d’un horaire pour l’échange.",
            "by_hand_delivery_button": "Je contacte le vendeur",
            "relay_point_delivery_alert": "Le vendeur sera invité à choisir un point relais proche de votre adresse de livraison.",
            "relay_point_delivery_seller_alert": "Sauf contre-ordre de l'acheteur, veuillez choisir un point relais proche de l'adresse de livraison (domicile).",
            "buyer_prefered_shipping_mode": "Mode de livraison souhaité:",
            "buyer_action_decline_offer": "Décliner l'offre",
            "seller_message_template_14": "Votre offre été déclinée pour la raison suivante:",
            "buyer_message_template_14": "Vous avez décliné l'offre pour la raison suivante:",
            "admin_message_template_14": "L'offre à été déclinée pour la raison suivante:",
            "decline_offer_modal_title": "Décliner",
            "decline_offer_modal_select_label": "Raison de votre refus",
            "decline_offer_default_select_option": "Choisir une raison",
            "too_high_select_option": "Frais de livraison trop élevés",
            "found_another_part_select_option": "J'ai déjà trouvé la pièce",
            "decline_offer_modal_other_reason_label": "Veuillez préciser pourquoi vous déclinez l'offre",
            "decline_offer_modal_btn_decline": "Je décline l'offre",
            "confirm_shipping_widget_menu_title": "Confirmer l'expédition",
            "confirm_shipping_widget_title": "Confirmer l'expédition",
            "confirm_shipping_widget_send_btn": "Confirmer l'expédition",
            "confirm_shipping_carrier_label_name": "Nom du transporteur",
            "confirm_shipping_carrier_select_placeholder": "Choisir dans la liste",
            "confirm_shipping_carrier_select_other": "Autre...",
            "confirm_shipping_parcel_tracking": "Numéro de suivi",
            "confirm_shipping_tracking_url_label": "URL complète de suivi",
            "seller_action_template_15": "Suivre la commande",
            "buyer_action_template_15": "Suivre ma commande",
            "admin_action_template_15": "Suivre la commande",
            "seller_message_title_template_15": "Commande expédiée",
            "buyer_message_title_template_15": "Votre commande est en route !",
            "admin_message_title_template_15": "La commande à été expédié",
            "seller_message_template_15": "Vous avez confirmé l'envoi de votre commande. Vous pouvez suivre votre colis sur le site du transporteur.",
            "buyer_message_template_15": "L'expéditeur a confirmé l'envoi de votre commande. Vous pouvez suivre votre colis sur le site du transporteur.",
            "admin_message_template_15": "L'expéditeur a confirmé l'envoi de la commande.",
            "complementary_info_second_title": "Références et illustrations",
            "complementary_info_second_title_description": "Veuillez renseigner au moins un des deux champs ci-dessous",
            "buyer_message_to_tell_choice_to_seller": "Si l'offre ne vous convient pas, veuillez par courtoisie la décliner!",
            "address_confirmation_already_sent_to_seller": "Vous avez déjà confirmé votre adresse, veuillez attendre la réponse du vendeur.",
            "address_confirmation_limit_reached": "Vous avez atteint la limite de confirmation d'adresse.",
            "loading_products": "Chargement...",
            "typologie_de_la_produit_2": "Type",
            "scroll_to_top": "Défiler vers le haut de page",
            "translate_in": "Traduire en",
            "view_translation_message": "Voir la traduction",
            "view_original_message": "Voir l'original",
            "translate_is_processing": "Traduction en cours",
            "your_interlocutor_speaks": "Votre interlocuteur parle",
            "your_messages_can_be_automatically_translated": "(si besoin, vos messages peuvent être traduits automatiquement)",
            "seller_offer": "Offre du vendeur",
            "vehicle_not_found_info": "Avez-vous bien rentré le nom de votre véhicule avant la marque? (il est inutile de spécifier la version). Veuillez sinon réessayer en appuyant sur le bouton 'Annuler'",
            "edit_research": "Modifier la recherche",
            "ask_the_community": "Interroger la communauté",
            "we_forward_your_request_to_members": "Interrogez la communauté Classic Parts Finder!",
            "check_stock_first": "Consulter d’abord le stock",
            "1_piece_currently_available": "1 pièce actuellement disponible",
            "parts_currently_available": "pièces actuellement disponibles",
            "what_do_you_want_to_do_now": "Que voulez-vous faire maintenant ?",
            "advanced_search_button": "Recherche avancée",
            "search_product_list": "Pièces disponibles",
            "unsubscribed_email_vehicle_notification_message": "La notification a bien été désactivée. Vous pouvez la réactiver à tout moment en vous rendant sur la fiche détaillée de votre véhicule.",
            "user_left_without_purchase": "{0} à quitter la conversation, la vente est clôturée au point actuel", // TODO: remove with the good message
            "seller_message_template_17": "Votre message n’a pas pu être envoyé du fait du partage de coordonnées privées. Ceci est contraire à nos conditions générales. Veuillez réitérer votre envoi. \n Message: {0}",
            "reading_new_price_9": "La proposition a été lue: {0}",
            "copy_info": "Copier les informations",
            "info_copied": "Copié !",
            "select_shipping_mode": "-- Choisir un mode de livraison --",
            "seller_action_item_paid_title": "Commande payée par l'acheteur !",
            "seller_action_item_paid_desc": "N'oubliez pas d'indiquer la confirmation d'envoi et le numéro de suivi dès que l'article est expédié.",
            "seller_action_item_paid_warning": "Attention : vous êtes responsable du bon acheminement de votre colis. Assurez-vous que votre colis soit bien couvert en cas de perte ou de dommage.",
            "oldPrice": "Ancien prix",
            "seller_action_item_paid_warning_ship": "Si vous n'êtes pas en mesure d'envoyer sous 72h, veuillez informer votre acheteur",
            "add_to_ad": "Ajouter à l'annonce",
        }
    },
    "en": {
        "name": "English",
        "messages": {
            "book_fast": "One minute!",
            "important": "Important",
            "payment_book_1": "Before purchasing this part, make sure you have contacted the seller to determine the shipping costs.",
            "payment_book_2": "For any queries about your transaction, please contact us at info@classic-parts-finder.com. The seller has 72 hours to dispatch your parcel.",
            "book_tarif_1": "",
            "book_tarif_2": "",
            "pay": "Pay",
            "secure_purchase": "Purchase",
            "parts_available_button": "Other parts available",
            "parts_notification_message": "Be notified by E-mail of the parts offered for sale on Classic Parts Finder for this vehicle.",
            "available_parts": "Parts available",
            "registration": "Registration",
            "login_failed": "Invalid credentials",
            "back": "Back",
            "choose_country": "Choose a country",
            "max_images": "Maximum 10 pictures",
            "email": "E-mail address",
            "accept_cgu": "By creating an account, I agree to the {0} and {1}",
            "negociable": "Negotiable",
            "select_default_lang": "Set default language to :",
            "non_negociable": "Not negotiable",
            "moderation_message": "Moderator's message",
            "voir_changements": "Show changes",
            "masquer_changements": "Hide changes",
            "refus_changement": "Decline",
            "accept_changement": "Accept changes and send",
            "ad_modifications": "Suggested changes to your ad",
            "research_modifications": "Suggested changes to your search",
            "cgu": "Terms of service",
            "privacy": "Privacy policies",
            "finish": "Send",
            "email_already_used": "This E-mail address has already been used. Please contact us via the {0}",
            "registering_error": "We are unable to complete your registration. Please contact us via the {0}",
            "field_required": "Required field!",
            "field_email": "Incorrect E-mail!",
            "field_email_used": "E-mail already used!",
            "registering_email_sent": "We have just sent you an E-mail to confirm your registration",
            "check_spams": "Didn't receive the email? Check your spam folder or contact Classic Parts Finder support at {1}",
            "back_login": "Back to the log in page",
            "forgot_your_password": "Forgot your password?",
            "reset_send_email": "An E-mail will be sent to you to reset your password",
            "inexistant_email": "This E-mail address does not exist!",
            "validate": "Confirm",
            "reset_email_sent": "An E-mail has been sent to you!",
            "update_your_password": "Change your password",
            "set_new_password": "Set a new password.",
            "at_least_x_char": "At least {0} characters.",
            "password_must_be_identical": "The password must be identical",
            "modify": "Edit",
            "password_updated": "Modified password",
            "your_password_updated": "Your password has been modified!",
            "login": "Log in",
            "expired_link": "The link has expired",
            "research_expired_status": "Expired",
            "confirm_new_passwd": "Confirm the new password",
            "log_in": "Log in",
            "log_in_error": "Connection error :",
            "email_address": "E-mail address",
            "password": "Password",
            "connection": "Connection",
            "not_registered_yet": "Not registered yet?",
            "i_research": "Search for parts",
            "i_sell": "Sell my parts",
            "log_out": "Log out",
            "my_dashboard": "My dashboard",
            "last_step": "Final stretch",
            "complementary_details_required": "Some additional information is required.",
            "first_name": "First name",
            "field_alpha": "Alphabetical value only!",
            "last_name": "Name",
            "country": "Country",
            "phone_number": "Phone number",
            "confirm_new_password": "Confirm your password",
            "information_editable_dashboard": "Your information will not be shared with third parties. It can be edited at any time in the dashboard settings section.",
            "complete_registering": "Finalize my registration",
            "account_activated": "Your account is activated",
            "connect_to_dashboard": "You can now log into your dashboard, create new searches, {0} or set up your account to sell your parts!",
            "log_in_dashboard": "Connect to the dashboard",
            "criteria_explanation": "These criteria, given as indicators, are not intended to be exhaustive and do not hold CPF responsible for their content. Note that the abbreviation OEM (Original Equipment Manufacturer) is linked to the manufacturer's reference of an original automotive spare part.",
            "factory_oem": "Original Equipment Manufacturer (OEM)",
            "strict_origin_factory": "Part strictly identical to the original, produced according to the specifications and standards provided by the vehicle manufacturer, throughout the period of production of the latter and beyond, without interruption (10 years on average after the end of production of the vehicle).",
            "remade_oem": "Remanufactured genuine part (OEM)",
            "strict_origin_remade": "Part strictly identical to the original, but reproduced after a period of interruption (usually several decades after the end of production of the vehicle). This item meets or exceeds all the criteria and requirements of the part manufactured at the time.",
            "old_fixed": "Reconditioned original part",
            "strict_origin_fixed": "Strictly identical to the original (vintage OEM part), but restored.",
            "remplacement_part": "Replacement part",
            "quality_replacement": "Part of equivalent or adaptable quality. It may be from the time of the vehicle's manufacture, or reproduced later, but not originally fitted to the vehicle. Of supposedly equal, comparable, or even superior value, it has differences - if sometimes barely visible - with the original OEM part mounted on the vehicle. The part must respect the conditions of vehicle approval process.",
            "criteria_responsibility": "These criteria, given as indicators, are not intended to be exhaustive and do not hold CPF responsible for their content.",
            "our_advice": "Our advice",
            "avoid_issue_defaults": "To avoid any misunderstanding, remember to systematically mention all defects and highlight them in your photos!",
            "brand_new": "New",
            "never_used": "Item never used and complete, preferably with its original packaging. No traces of wear appear.",
            "very_good": "Very good",
            "almost_never_used": "Very little used, or never. It is complete, and if it contains mechanical elements, in perfect working order. It comprises, however, some defaults or traces of visible wear (for example due to prolonged storage, light scratches, oxydation...).",
            "good": "Good",
            "few_imperfections": "Already used. It has some imperfections, defects and traces of wear, partly visible to the naked eye, but which do not alter in any way its assembly or proper functioning.",
            "satisfying": "Fair",
            "needs_cleaning": "Good with obvious traces of wear that are clearly visible to the naked eye, but it remains functional. It may need a quick overhaul or cleaning before assembly.",
            "renovate": "To restore",
            "to_renovate_fix": "Non-functional or damaged item for restoration or reuse of spare parts",
            "other_question": "Other question",
            "enter_your_question": "Enter your question",
            "send": "Send",
            "cancel": "Cancel",
            "message_waiting_validation": "Message sent. You can find your conversations in the messaging section (top right of your screen).",
            "more_picture_product": "I would like to see more photos",
            "where_product_from": "Can you tell me more about its current condition?",
            "thanks_for_comment": "Thank you for your comment",
            "add": "Add",
            "research": "Search",
            "vehicle": "Vehicle",
            "simplified_announce": "Alert",
            "product": "Advert",
            "parameters": "Settings",
            "my_researches": "My searches",
            "my_vehicles": "My vehicles",
            "my_simplified_announces": "My alerts",
            "my_products": "My ads",
            "email_modification": "E-mail address currently being modified",
            "to_change_email_dashboard": "To change your E-mail, please log back into your dashboard and change your E-mail in your account settings {0} If the problem persists, please contact Classic Parts Finder support at {1}",
            "log_myself": "Log in",
            "success_email_change": "Your E-mail has been changed successfully",
            "other": "Other",
            "vendor_parameters": "Vendor settings",
            "sell_parts": "Sell your spare parts {0} on Classic Parts Finder",
            "diffuse_products": "Publish your ads in a few minutes only!",
            "activate_vendor": "Activate my seller account",
            "all_modifications_taken": "All modifications have been taken into account.",
            "error_happened_wrong_param": "An error has occurred, perhaps some fields are incorrect?",
            "business_name": "Name of the company",
            "business_address": "Company address",
            "zip_code": "Postal code",
            "city": "City",
            "region": "Region",
            "Numéro d'identification de votre entreprise (14 chiffres du Siret pour la France)": "Company official identification number",
            "save_changes": "Save Changes",
            "account_info_linked_business": "Your vendor account information is linked to your personal information because you are a private seller.",
            "become_pro": "Become a professional seller",
            "password_security": "Password and security",
            "actual_password": "Current Password",
            "new_password": "New Password",
            "confirm_your_new_password": "Confirm your new password",
            "account_removal": "The termination of your account will result in the permanent deletion of your search, alerts, ads and matches history.{0}Are you sure you want to delete your account?",
            "remove_my_account": "Delete my account",
            "action_will_disconnect": "This action will disconnect you. Your account will no longer be accessible from this moment.",
            "confirm_account_removal": "Confirm the deletion of my account",
            "personal_details": "Personal details",
            "sell_parts_cpf": "Sell your spare parts {0} on Classic Parts Finder",
            "publish_products_fast": "Publish your ads in a few minutes only!",
            "activate_seller_account": "Activate my seller account",
            "email_changing_to": "Request for E-mail change in progress to",
            "address": "Address",
            "spoken_langage": "Spoken languages",
            "my_account": "My account",
            "email_already_used_log": "This E-mail address is already in use. Please log-in.",
            "cannot_register": "Registration has failed. Please contact Classic Parts Finder support at {1}",
            "nearly_there_login": "You are almost there! Just log in to create your search.",
            "nearly_there_register": "You are almost there! In order to confirm your search, please enter your E-mail address.",
            "already_have_account": "I already have an account",
            "email_sent_confirm_research": "Please check your E-mails to confirm your registration",
            "select_from_own": "Select your vintage car",
            "find_new_vehicle": "Ad your your new vehicle",
            "what_is_vehicle": "What's your vehicle?",
            "brand_modele_etc": "Model, Brand",
            "cant_find_vehicle": "I do not find my vehicle in the list",
            "vehicle_not_found": "Vehicle not found",
            "your_vehicle_not_found": "Your vehicle",
            "keep_track_demand": "This will allow us to keep you informed of your request",
            "required_informations": "Required information",
            "thanks_demand": "Thank you for your request!",
            "email_contact_back": "We will come back to you by E-mail as soon as the suggested vehicle is available in our search engine.",
            "next_step": "Next",
            "your_email": "Your E-mail",
            "add_vehicle": "Add a vehicle",
            "previous_step": "previous step",
            "which_part_looking_for": "What part are you looking for?",
            "part_name_etc": "Name",
            "loading": "Loading...",
            "which_kind_of_part": "Choose your category",
            "complementary_info": "Further information",
            "lets_gain_time": "Please provide precise details so that our team can validate your search in a quick manner!",
            "year_vehicle": "Vehicle year",
            "select_year": "Choose a year",
            "vehicle_version": "Vehicle version",
            "motor_paint_etc": "Trim level, Body style, Engine type",
            "part_precisions": "Details on the wanted part",
            "looking_version_part": "I am looking for...",
            "part_is_compatible": "If this part was used on other vehicles, please mention them if possible",
            "kind_of_part": "Your requirements for the part you are looking for",
            "part_type_guide": "Type classification guide",
            "part_reference": "Part No. and\/or name of manufacturer",
            "reference_id_etc": "Reference or identification number",
            "maximize_add_photos": "Images or diagrams",
            "maximum_photos": "Maximum 5",
            "drop_files_here": "Drop the files here",
            "or_if_prefer": "or",
            "select_files": "Select the files",
            "remove": "Delete",
            "sending_progress": "Processing",
            "your_research": "Your search",
            "brand_modele": "Model, brand",
            "part_category": "Category",
            "part_research": "Part wanted",
            "vendor_account_ready": "Your vendor account is ready!",
            "account_secured_obvy": "Your vendor account is secured with Stripe!",
            "and_now": "And now?",
            "can_sell_products": "You can now sell your parts and receive your money.",
            "accept_paiements": "Accept payments",
            "sell_with_obvy": "Sell your parts safely with Stripe, our partner who secures your sales!",
            "secure_my_account": "Secure my account",
            "go_further": "Want to go faster?",
            "tell_part_category": "Just indicate the type of part you want to sell, and we will notify you as soon as we find a buyer.",
            "create_simplified_announce": "Create my alerts",
            "add_product": "Publish my ads",
            "create_first_product": "Create your first ad, we will notify you when someone wants to buy it.",
            "complete_later": "Access to my dashboard",
            "all_rights": "All rights reserved",
            "new_simplified_announce": "New alerts",
            "receive_mail_research": "Create an alert! We will notify you when someone is looking for one of your parts.",
            "vehicles_compatible": "Vehicle",
            "vehicles_with_alert": "",
            "brand_modeles_etc": "Model, brand",
            "answer_by_mail": "We will come back to you by E-mail as soon as the suggested vehicle is available in the alert system.",
            "part_not_found": "Part not found",
            "your_unknown_part": "Your part",
            "name_part": "Name",
            "unknown_part_mail": "We will come back to you by E-mail as soon as the suggested part is available in the alert system.",
            "part_categories": "Categories",
            "multiple_choices": "(several choices available)",
            "category_all_parts": "All parts of the category",
            "cant_find_part_list": "I cannot find my part in the list",
            "activate_announce": "Activate the alerts!",
            "french_german": "French, English, German...",
            "version_non_renseigne": "Version not specified",
            "new_research": "Advanced search",
            "see_vehicle": "View my vehicle data sheet",
            "find_by_brand_year_etc": "Search by model, brand, year",
            "grid_display": "Grid display",
            "line_display": "Line display",
            "table_display": "Table display",
            "confirm_vehicle_removal": "Are you sure you want to delete the vehicle?",
            "all_research_removal": "All search {0} in progress will be deleted",
            "do_not_remove": "Do not delete",
            "searching_x_products": "You are currently looking for {0} part | You are currently looking for {0} parts",
            "no_research_currently": "No current search",
            "no_vehicles": "Click on the '+' tab to add a vehicle",
            "non_renseign": "not specified",
            "produit_suggr": "Suggested part",
            "vehicle_details": "My vehicle details",
            "version": "Version",
            "add_version": "Add a version",
            "year": "Year",
            "associated_researches": "Related searches",
            "see_x_findings": "View my {length} matches",
            "see_my_finding": "View my new match",
            "research_awaiting_validation": "Search pending validation",
            "experts_are_looking": "We are looking for your part",
            "vehicle_parameters": "Vehicle settings",
            "new_vehicle": "New vehicle",
            "name_too_short": "Name too short.",
            "name_too_long": "Name too long.",
            "update": "Update",
            "what_is_your_vehicle": "What is your vehicle?",
            "select_vehicle_first": "Choose a vehicle first",
            "engine_bodywork_etc": "Trim level, Body style, Engine type",
            "states_guide": "Condition guide",
            "administration": "Administration",
            "inbox": "Inbox",
            "pice_suggre": "Suggested part",
            "my_last_researches": "My last searches",
            "no_researches_for_now": "No search at this time",
            "all_my_researches": "All my searches",
            "no_research_made": "You have not yet created a search",
            "my_last_simplified_announces": "My last alerts",
            "no_simplified_announces_currently": "No alert at this time",
            "all_my_simplified_announces": "All my alerts",
            "didnt_config_seller_space": "You haven't set up yet your sales dashboard",
            "configure": "Configure",
            "new_part_for_your": "Need a specific part for your",
            "we_look_for_you": "Ask the Classic Parts Finder community!",
            "notifications": "Notifications",
            "all": "All",
            "no_unread_notifications": "No unread notification",
            "someone_research_your_part": "Someone is looking for one of your parts",
            "you_created_simplified_announce": "You have created an alert",
            "we_found_product_for_you": "We have found a part for you",
            "you_created_research": "You have created a search",
            "part_attributed_to_research": "A part has been allocated to your search",
            "part_attributed_to_product": "A part type has been assigned to your ad",
            "date": "Date",
            "part": "Category\/Type",
            "see_simplified_announce": "View the search",
            "details": "Details",
            "no_notification": "No notification",
            "welcome_aboard": "Welcome aboard",
            "conversations": "Messages",
            "buying_product": "Purchase of part(s)",
            "selling_product": "Sale of part(s)",
            "no_new_message": "No new message",
            "vous": "You",
            "sent_at": "The {date}",
            "message_sent_for_validation": "Your message will be sent as soon as it is reviewed by an administrator.",
            "moderation_in_progress": "under review",
            "sent": "Sent",
            "read": "Read",
            "new_message": "Hello, ........ Thank you",
            "from": "From:",
            "refused": "Declined",
            "actual_message_to_moderate": "Current message to review",
            "missing_info_profil": "Missing information on your profile",
            "required_info_to_continue": "It is necessary to enter the following information in order to proceed:",
            "save_informations": "Save information",
            "my_orders": "My orders",
            "reference": "Reference(s)",
            "amount": "Amount",
            "status": "Status",
            "option": "Option",
            "options": "Options",
            "allow_sale": "Accept the sale",
            "refuse_sale": "Refuse",
            "paiement_accept": "Payment accepted",
            "order_sent": "Order shipped",
            "confirm_reception": "Confirm receipt",
            "do_reclamation": "Make a claim",
            "reimburse_partiel": "Partial refund",
            "reimburse_total": "Total refund",
            "no_order": "You do not have any order yet",
            "how_does_it_work": "How does this work?",
            "advantages": "Advantages",
            "dashboard": "Dashboard",
            "selling_easy": "With {0}, selling your spare parts is a breeze!",
            "create_market_fast": "Create your account for free!",
            "i_am_pro": "I am a professional",
            "i_am_individual": "I am a private individual",
            "receive_alert_research": "Be notified as soon as someone is looking for your part!",
            "simplified_announce_explained": "Too many parts in stock and not always enough time to publish your ads? Create an alert in just a few seconds!",
            "publish_products_fast_easy": "Target a community of enthusiasts",
            "publish_large_catalog": "Post your ads for free. They will be automatically sent to vintage car enthousiasts of the Classic Parts Finder community, precisely targeting their vehicle. For this, we have developed an interface specially dedicated to the requirements of selling spare parts for classic cars. You can also benefit from our advices, expertise and customer service.",
            "ready_to_sell": "Ready to sell your spare parts?",
            "register_fast": "It only takes a few moments to register!",
            "free_service_part": "The reference tool for private individuals and professionnals for the search, sale, and restoration of spare parts for vintage cars. We deal in original parts or quality reissues for vintage cars, classics, and future classics.",
            "menu": "Menu",
            "take_my_research": "Search for parts",
            "facebook_link": "Link to the Facebook Classic Parts Finder page",
            "instagram_link": "Link to the Instagram Classic Parts Finder page",
            "privacy_policies": "Privacy policy",
            "cgu_full": "Terms of service",
            "legals_info": "Legal notice",
            "suivant": "Next",
            "valeurs_alphabtiques_uniquement": "Alphabetic values ​​only!",
            "doit_tre_compos_de_14_chiffres": "",
            "valeur_numrique_uniquement": "",
            "n_de_siret": "Company official identification number",
            "adresse_de_lentreprise": "Company address",
            "pays_de_lentreprise": "Company head office",
            "nom_de_lentreprise": "Company name",
            "au_moins_2_caractres": "At least 2 characters",
            "votre_nom": "Your last name",
            "votre_prnom": "Your first name",
            "part_found": "{length} part found | {length} parts found",
            "recherche_termine": "Search complete",
            "la_recherche_a_t_archive": "Search archived",
            "nos_experts_sont_en_cours_de_recherche": "We are looking for your parts",
            "faire_une_nouvelle_recherche": "New search",
            "vous_souhaitez_acheter_des_pices_pour_votre_ancien": "Take advantage of our unique feature by reaching out to members of the community.",
            "aucune_recherche": "No search",
            "pas_de_recherche": "No existing search",
            "product_found": "{length} part found | {length} parts found",
            "dtails_de_la_recherche": "My search details",
            "suggested_product": "Suggested part",
            "rechercher_par_modle_marque_produit_recherch": "Search by model, brand, part...",
            "nous_sommes_dsols_nous_ne_sommes_pas_en_mesure_de": "We are sorry, we are unable to retrieve this information at this time. Please try again later.",
            "recherches_avec_produits_trouvs": "Searches with parts found ({done} \/{total})",
            "afin_damliorer_la_qualit_de_nos_suggestions_pourri": "In order to improve the quality of the ads, could you specify the reasons for your choice?",
            "je_cherche_une_pice_en_meilleur_tat_le_prix_est_tr": "I am looking for a part in better condition, the price is too high, etc...",
            "nous_envoyer_une_suggestion": "Send us a suggestion",
            "quelle_est_votre_question_pour_ce_vendeur": "What is your question for this seller?",
            "en_savoir_plus_sur_obvy": "Learn more about Stripe",
            "achat_scuris_avec": "Secure online purchasing",
            "trop_tard_ce_produit_nest_plus_disponible": "This part is not available anymore.",
            "en_savoir_plus": "Learn more",
            "grce_la_garantie_cpf": "",
            "achetez_en_toute_srnit": "Find out more about your benefits",
            "frais_de_port_en_sus_calculer_selon_le_mode_de_liv": "Shipping costs to be added according to the delivery method proposed by the seller.",
            "colis_remis_au_transporteur_sous_jours": "(Package delivered to the carrier under {averagepreparetime} days)",
            "expdition": "Shipment",
            "hors_frais_de_ports": "(excluding shipping costs)",
            "prix": "Price incl. VAT",
            "dimensions_du_produit": "Dimensions (L x W x H)",
            "poids_du_produit": "Package weight",
            "jours": "{average_preparation_time} days",
            "temps_moyen_de_prparation": "Average time of preparation",
            "contacter_le_vendeur": "Ask a question",
            "vendu_directement_par_cpf": "Sold directly by CPF",
            "seller": "Seller",
            "a_propos_du_vendeur": "About the seller",
            "fabricant": "Manufacturer",
            "rfrence_du_produit": "Part reference(s)",
            "description": "Description",
            "state": "Condition:",
            "facebook": "Facebook",
            "copier_le_lien": "Copy the link",
            "partager_le_produit": "Share the ad",
            "trouvailles_par_page": "Matches per page",
            "ce_formulaire": "this form",
            "vous_pouvez_nous_faire_votre_demande_via": "You can place your request via",
            "assistance_en_cas_de_litige": "Assistance in the event of a dispute, with no chatbots!",
            "larticle_doit_tre_retourn_dans_son_tat_dorigine_et": "The item must be returned in its original condition, and without any sign of use. Return shipping costs are the responsibility of the buyer, unless the part is not received as described. The buyer will receive a full refund, minus the shipping costs.",
            "si_achat_auprs_dun_professionnel": "(if purchased from a professional)",
            "droit_de_rtractation_de_14_jours": "14-day right of withdrawal",
            "garantie_lgale_des_vices_cachs": "",
            "garantie_lgale_de_conformit_du_bien": "Legal guarantee of conformity of the good",
            "remboursement_total_ou_partiel_en_cas_de_perte_ou": "",
            "suivi_de_livraison_si_choix_via_mondial_relay_ou_c": "Legal guarantee against hidden defects",
            "tarifs_de_livraison_ngocis_mondial_relay_et_chrono": "",
            "scurisation_des_fonds_protection_de_lacheteur_et_d": "Fraud prevention via our partner Stripe",
            "garantie_de_paiement_sur_compte_squestre": "Guaranteed secure transaction",
            "garantie_de_transaction_scurise": "",
            "paiement_par_carte_ou_par_virement": "We only publish ads that have been cross-checked by us. This makes it easier and quicker to identify suspicious users and behavior.",
            "garantie_classic_parts_finder": "The benefits of Classic Parts Finder",
            "la_recherche_nest_pas_disponible": "The search is not available anymore",
            "donnez_nous_plus_de_dtails_sur_le_produit_que_vous": "Give us more details about the part you are looking for",
            "je_cherche_des_produits_neufs_les_prix_sont_trop_l": "I am looking for a part in better condition, the price is too high...",
            "pas_encore_de_trouvailles": "",
            "dgivrer_loffre": "Defrost the offer",
            "vous_avez_chang_davis": "",
            "offre_refuse": "Offer declined",
            "consulter_loffre": "View the offer",
            "la_recherche_est_en_attente_de_validation": "Your search is pending validation",
            "research_continues": "The search continues, but we have found {size} part that may already be of interest to you | The search continues, but we have found {size} parts that may already be of interest to you",
            "les_trouvailles": "My searches",
            "la_recherche_est_termine": "The search is over",
            "date_de_la_recherche": "Date of the search",
            "rfrence_du_produit2": "Reference code\/number",
            "dtails": "Details",
            "type_de_produit": "Type of part",
            "produit_recherch": "Part wanted",
            "dtails_de_votre_recherche": "My search details",
            "product_suggested": "Suggested part",
            "pour": "for",
            "oups": "Whoops...",
            "votre_recherche_est_introuvable_ou_a_dj_t_prolonge": "Your search cannot be found or has already been extended.",
            "accder_mon_tableau_de_bord": "Access my dashboard",
            "cest_not": "Noted!",
            "votre_recherche_a_bien_t_prolonge": "Your search has been extended.",
            "accder_mon_tableau_de_bord2": "Access my dashboard",
            "bienvenue": "Welcome {expp}",
            "activer": "Enable",
            "dsactiver": "Disable",
            "dsactiv": "Disabled",
            "en_attente_dune_recherche": "Waiting for a search",
            "voir_les_recherches": "View searches",
            "rfrence_de_la_pice": "Reference code\/number",
            "localisation_de_lacheteur": "Buyer's location",
            "date_de_la_recherche2": "Date of the search",
            "votre_question_pour_cet_acheteur_potentiel": "Your question for this enquirer?",
            "proposer_un_produit": "Submit a part",
            "si_vous_avez_besoin_dlments_plus_prcis_en_rapport": "(Please note that conversations are subject to moderation)",
            "contacter_lacheteur_potentiel": "Ask a question",
            "propos_de_lacheteur": "About the buyer",
            "compatible_avec": "Fitment\/Compatibility with",
            "crer_mes_annonces_simplifies": "Create my alerts",
            "vous_souhaitez_vendre_des_produits_indiqueznous_si": "Too many parts in stock and not always enough time to publish your ads? Create an alert in just a few seconds!",
            "aucune_annonces_simplifies": "No alert",
            "aucune_annonce_simplifie_ne_correspond_aux_filtres": "No alert matching the filters",
            "supprimer_la_slection": "Delete the selection",
            "annonce_dsactive": "Alert disabled",
            "rechercher_par_marque_modle": "Search by brand",
            "vous_navez_pas_encore_de_vente": "You do not have any sale yet",
            "commande_livr": "Order delivered",
            "mes_ventes": "My sales",
            "si_malgr_tout_la_vente_na_pas_lieu_vous_navez_pas": "If the sale does not take place, you have not wasted your time! Your ad is published and will be shared with the community!",
            "le_produit_sera_transmis_lacheteur_aprs_validation": "Your offer will be sent to the buyer after review by an administrator.",
            "confirmation_dajout_du_produit": "Confirmation of added part",
            "ajouter_mon_premier_produit": "Add my first part",
            "crez_et_diffusez_vos_annonces_sur_classic_parts_fi": "",
            "aucun_produit": "No part",
            "supprimer_la_selection": "Remove selection",
            "aucun_produit_ne_correspond_votre_recherche": "There are no ads matching your search",
            "diffuser": "Publish",
            "votre_produit_sera_diffus_ds_validation_par_un_adm": "Your ad will be published as soon as it is reviewed by an administrator.",
            "exporter_vos_produits": "Export your ads",
            "rechercher_par_type_de_produit_modle": "Search by part name",
            "catgorie": "Category",
            "lannonce_simplifie_nest_pas_disponible": "Too late! It seems the right part has already been found...",
            "complter_la_fiche_produit": "Create an ad",
            "vrifier_que_vous_navez_pas_dj_cette_pice_dans_votr": "Check that you do not already have published this item ('My ads' section).",
            "de_quelques_informations_complmentaires_sur_votre": "some additional information about your part",
            "nous_avons_dsormais_besoin": "We now need",
            "flicitations": "Congratulations!",
            "a_propos_de_lacheteur": "About the buyer",
            "pas_cette_piece": "I don't have this part",
            "jai_trait_ce_produit": "I processed this request",
            "en_attente_de_traitement": "Request to be processed",
            "je_nai_pas_le_produit": "I don't have the part",
            "vous_avez_chang_davis2": "Have you changed your mind?",
            "jai_trait_ce_produit2": "I processed this request",
            "jai_ce_produit": "View again this request",
            "vous_avez_le_produit": "",
            "je_nai_pas_ce_produit2": "I don't have this part.",
            "acheteur": "potential buyer | potential buyers",
            "vos_acheteurs_potentiels": "Your potential buyers",
            "date_de_publication": "Publication date :",
            "catgorie_cible": "Targeted category",
            "pice_cible": "Targeted part",
            "dtails_de_lannonce_simplifie": "Alert details",
            "dtails_de_votre_annonce_simplifie": "Details of your alert",
            "rsultats_de_mon_annonce": "Results of my alert",
            "je_nai_pas_trouv_ma_pice": "I did not find my part",
            "diffuser_le_produit": "Publish the ad",
            "en_cours_denvoi": "In progress",
            "brouillon": "Draft",
            "temps_moyen_de_prparation_jours": "Average time of preparation: {0} day | Average time of preparation: {0} days",
            "aperu_et_diffusion": "Review and submit",
            "les_frais_lis_une_livraison_sont_la_charge_de_lach": "The shipping costs will be paid by the buyer.",
            "longueur": "Length",
            "largeur": "Width",
            "hauteur": "Height",
            "remise_en_main_propre_uniquement": "Hand-delivered only",
            "remise_en_main_propre_et_envoi_postal": "Hand-delivery and Shipment",
            "envoi_postal": "Shipment",
            "veuillez_slectionner_une_option": "Please select one option",
            "mode_de_transport_du_produit": "Delivery option",
            "dlai_avant_remise_au_transporteur": "Delay before delivery to the carrier",
            "pensez_lemballage_arrondir_au_dessus": "Think about the weight of your packaging.",
            "poids_approximatif_du_produit": "Approximate weight of your parcel",
            "oui": "Yes",
            "non": "No",
            "le_prix_estil_ngociable": "Is the price negotiable?",
            "est_destine_couvrir_les_frais_de_recherche_et_de_t": "-at the buyer's expense- is intended to cover operating and transaction costs.",
            "la_commission_de": "A commission fee of",
            "the_selling_price": "The selling price will therefore be shown at",
            "pour_vous": "Your price (VAT incl.)",
            "indiquez_le_prix_de_vente_hors_livraison_minimum_2": "Indicate the selling price excluding delivery (minimum 2€).",
            "prix_de_vente_affich": "Published selling price",
            "prix_et_livraison": "Price and delivery",
            "dplacer": "Move",
            "rotation": "Rotation",
            "slectionnez_les_photos": "Select the images",
            "dposez_les_photos_de_votre_produit_ici": "Drop the images here",
            "maximiser_vos_chances_de_vendre_en_proposant_plusi": "Increase your chances of success by attaching images taken from different angles!",
            "cette_pice_convient_aux_modles_dans_son_emballage": "Details on its condition, history, compatibility of the part, etc...",
            "merci_de_prciser_du_mieux_possible_les_spcificits": "Please be as specific as you can about your part!",
            "rfrence_interne_votre_stock_invisible_pour_lachete": "Internal reference code, meant for your own stock (not visible to the buyer)",
            "typologie_de_la_produit": "Type of part sought",
            "etat_du_produit": "Condition",
            "quantit_disponible": "Quantity available",
            "titre_nom_prcis_du_produit": "Title of your ad",
            "informations_gnrales": "Description",
            "votre_produit_pourra_tre_diffus_aprs_la_validation": "Your ad will be published after being reviewed by an administrator",
            "nom_de_votre_produit": "Name of your part",
            "vous_ne_trouvez_pas_votre_produit": "Cannot find your part?",
            "nom_du_produit": "Name",
            "indiquez_le_nom_du_produit": "Indicate the name from the list",
            "type_de_produit_catgorie": "Part",
            "ce_produit_est_compatible_pour_les_modles": "This part fits to...",
            "nouveau_produit": "New ad",
            "edition_de_produit": "Edit ad",
            "recherches_par_page": "Alerts by page",
            "tous": "All",
            "prcdent": "Previous",
            "operational_fees": "Transactions fees",
            "selling_price": "Selling price",
            "lments_slectionns": "selected element(s)",
            "dslectionner_tout": "Deselect all",
            "tous_les_produits_de_la_catgorie": "All the parts in the category",
            "image": "Image",
            "marque": "Brand",
            "modle": "Model",
            "recherches": "Searches",
            "dition": "Edition",
            "sure_supprimer_ces_annonces_simplifies": "Are you sure you want to remove these alerts?",
            "sure_supprimer_cette_annonce_simplifie": "Are you sure you want to remove this alert?",
            "annonces_par_page": "Ads per page",
            "titre_de_lannonce": "Title of the ad",
            "filtrer_par_nom": "Filter by name",
            "filtrer_par_type_de_produit": "Filter by part type",
            "marque_modle": "Brand \/ Model",
            "filtrer_par_modle": "Filter by Model",
            "rfrence_interne": "Internal reference",
            "filtrer_par_rfrence": "Filter by reference number\/code",
            "stock": "Stock",
            "etat": "Condition",
            "moderation_diffus": "Review",
            "pas_de_modle": "No model",
            "pas_de_ref_interne": "No internal reference",
            "sure_supprimer_produit": "Are you sure you want to remove this ad?",
            "max_photos": "10 images maximum",
            "the_buyer": "The buyer",
            "the_seller": "The seller",
            "sure_supprimer_vehicule": "Are you sure you want to remove this vehicle?",
            "sure_supprimer_research": "Are you sure you want to remove this search?",
            "action": "Action",
            "type": "Type",
            "diffus": "Published",
            "optional": "Optional",
            "max_vehicles_in_list": "Maximum number of vehicles reached",
            "no_product_for_the_moment": "No parts match your search",
            "espace_recherche": "Search area",
            "espace_vente": "Sales area",
            "we_may_have_more_products_in_stock_for_this_vehicle": "We may have more parts for this vehicle!",
            "sur": "of",
            "next": "Next",
            "vehicles_per_page": "Vehicles per page",
            "page": "page",
            "pro_seller": "Professional seller",
            "private_seller": "Private individual",
            "before_continuing": "Before proceeding!",
            "not_search_engine_search_service_give_us_search_distribute_entire_classic_parts_finder_community_collectors_garages_breakers_etc": "Welcome to the Classic Parts Finder Community! If you are looking for a specific part, you can submit your query to the members.",
            "prefer_view_parts_already_available_classic_parts_finder_simply_register_enter_vehicle_model": "If you prefer to view existing ads, please register and enter your vehicle details.",
            "register_add_vehicle": "I register and add my vehicle",
            "understand": "I understand",
            "start_research": "Launch search",
            "These credentials do not match our records.": "These credentials do not match our records.",
            "process_request": "View request",
            "parts_available_2": "Parts currently available",
            "delete_research": "Delete",
            "bulk_upload_a_file": "Upload a file",
            "bulk_column_mapping": "Column mapping",
            "bulk_import": "Import",
            "bulk_importing_ads_file": "Import ads from a file",
            "bulk_tool_allows_import_merge_ad_data_shop_excel_csv_file": "This tool allows you to import (or merge) ad data in your store from an Excel or CSV file.",
            "bulk_list_mandatory_fields": "List of compulsory fields",
            "bulk_download_info": "Download our <a href='\/assets\/classic-parts-finder-import-example.csv'>CSV file<\/a> or <a href='\/assets\/classic-parts-finder-import-example.xlsx'>Excel file<\/a> template",
            "bulk_vehicle_model": "Vehicle model",
            "bulk_brand_vehicle": "Vehicle",
            "bulk_name_piece": "Name\/Type of part",
            "bulk_title_ad": "Title of your ad",
            "bulk_quantity": "Quantity",
            "bulk_url_image_1": "Main image URL",
            "bulk_state": "State",
            "bulk_info": "info",
            "bulk_type": "Kind",
            "bulk_description": "Description",
            "bulk_price": "Price in € incl.",
            "bulk_approximate_weight_piece": "Piece weight per kg",
            "bulk_proposed_mode_transport": "Mode of transport offered",
            "bulk_show_optional_fields": "View optional fields",
            "bulk_hide_optional_fields": "Hide the optional fields",
            "bulk_list_optional_fields": "List of optional fields",
            "bulk_internal_reference": "Internal Reference",
            "bulk_year_vehicle": "Vehicle year",
            "bulk_manufacturer": "Maker",
            "bulk_reference_part": "Piece reference",
            "bulk_price_negotiable": "Is the price negotiable?",
            "bulk_time_delivery_carrier_days": "Deadline before returning to the carrier (days)",
            "bulk_height": "Height",
            "bulk_width": "Width",
            "bulk_lenght": "Length",
            "bulk_url_image_2": "URL Image 2",
            "bulk_url_image_3": "URL Image 3",
            "bulk_url_image_4": "URL Image 4",
            "bulk_url_image_5": "URL Image 5",
            "bulk_start": "Begin",
            "bulk_configuration_import_parameters": "Configuration of import parameters",
            "bulk_select_file_computer": "Choose a file from your computer",
            "bulk_maximum_size_8_mb": "Maximum size 8 MB",
            "bulk_csv_separator": "CSV separator",
            "bulk_offer_ads_compatible_vehicles": "Offer announcements to compatible vehicles?",
            "bulk_checked_parts_will_displayed_compatible_vehicles_according_classic_parts_finder_database": "If checked, your parts will be displayed as compatible with other vehicles according to the Classic Parts Finder database.",
            "bulk_can_make_adjustment_individually_ad_import": "You can make this setting individually, on each ad, after importing.",
            "bulk_update_already_imported_ads": "Update the announcements already imported?",
            "bulk_check_box_want_update_ads_already_imported": "Check this box if you want to update announcements that you have already imported.",
            "bulk_important": "Important",
            "bulk_internal_reference_new_ads_must_identical_internal_reference_ads_already_imported": "The internal reference of new announcements must be identical to the internal reference of the announcements already imported.",
            "bulk_ignore_first_line_file": "Ignore the first line of the file?",
            "bulk_check_box_first_line_file_not_ad_example_named_columns": "Check this box if the first line of your file is not an ad. For example, if you have named your columns.",
            "bulk_previous_step": "Previous step",
            "bulk_continue": "Continue",
            "bulk_associate_fields_file": "Combine the fields of your file",
            "bulk_column_choose_corresponding_criterion": "For each column, choose the corresponding criterion.",
            "bulk_columns_file": "Columns of your file",
            "bulk_correspondence": "Correspondence",
            "bulk_column": "Column",
            "bulk_not_assigned": "Not attributed",
            "bulk_required": "Mandatory",
            "bulk_start_import": "Launch importation",
            "bulk_import_started_will_not_able_cancel_check_columns_mapped_correspond_field_selected": "Once the import is launched you will not be able to cancel it anymore. Make sure that the columns you have mapped correspond to the field you have selected.",
            "bulk_successful_column_mapping": "Successful column mapping!",
            "bulk_successful_column_mapping_description": "Your ads are now being imported. Our robots give the best of themselves to import all your ads as soon as possible. You can leave the page, you will be notified by e-mail when the import is over.",
            "bulk_back_ads": "Return to my ads",
            "btn_bulk_import": "Mass",
            "status_to_be_verified": "To be checked",
            "transport_propose_global_description": "",
            "transport_propose_description_1": "",
            "transport_propose_description_2": "",
            "transport_propose_description_3": "",
            "notice_cpf_title": "Classic Parts Finder's review",
            "original_notice": "See in its original language",
            "add_personal_comment": "Any comments? Do not hesitate!",
            "report_ad": "Report this ad",
            "automatically_translated": "Automatically translated",
            "view_original": "View the original",
            "hide_original": "Hide the original",
            "price_negotiable_explanation": "",
            "price_negotiable_title_0": "The price of your ad is not negotiable",
            "price_negotiable_description_0": "",
            "price_negotiable_title_1": "The price of your ad is negotiable",
            "price_negotiable_description_1": "",
            "no_research_alert": "No research related to this part",
            "french": "French",
            "english": "English",
            "german": "German",
            "image_is_processing": "Image is processing",
            "empty_car_title": "No vehicle",
            "empty_car_description": "",
            "empty_car_add_first_car": "Add my first vehicule",
            "own_research_title": "Can't find your part?",
            "contact": "Contact",
            "already_registered": "Already registered?",
            "log_on_to": "Sign in",
            "confirm_room_removal": "Are you sure you want to delete the conversation ?",
            "confirm": "Confirm",
            "msg_search_alert": "Search alert",
            "msg_product_is_no_longer_available": "The article is no longer available",
            "msg_you_have_no_conversation": "No conversation",
            "msg_name_of_the_conversation": "Rename conversation",
            "msg_modify_advert": "Modify the advert",
            "msg_modify_name_conversation": "Modify the name of the conversation",
            "msg_no_conversation_selected": "Select a conversation",
            "shipping_address": "Delivery address",
            "send_offer": "Confirm the offer",
            "reservation_success": "Your order has been sent successfully. We will contact you within 24 hours with the best delivery rates.",
            "well_done": "Well done !",
            "thanks_trust": "Thank you for your trust",
            "parts_reservation": "Order",
            "parts_reservation_description": "",
            "make_offer": "Purchase",
            "day": "{average_preparation_time} day",
            "address_2": "Address (cont.)",
            "activate_stripe_account": "Activate your Stripe account",
            "resume_stripe_activation": "Continue activating your account",
            "check_stripe_account": "View my Stripe account",
            "stripe_redirection_message": "You will be redirected in a few moments, please wait...",
            "stripe_onboarding_success": "Registration completed successfully, you will be redirected",
            "stripe_onboarding_failure": "Registration has not been completed correctly, you will be redirected",
            "making_offer_widget_menu_title": "Modify my offer",
            "shipping_widget_menu_title": "Indicate delivery costs",
            "buyer_not_specified_shipping_address": "The buyer has not yet specified a delivery address, start by asking for one.",
            "request_shipping_address": "Ask for delivery address",
            "stripe_account_not_activated": "You have not yet activated your seller account on Stripe. It is necessary in order to finalize a sale.",
            "shipping_widget_title": "I add the delivery cost",
            "already_know_cost": "I already know the cost",
            "hand_delivered": "Hand delivery",
            "product_price": "Price of the part",
            "shipping_costs": "Shipping cost",
            "no_shipping_costs": "No delivery costs",
            "shipping_widget_select_label": "Delivery method",
            "shipping_widget_alert": "Please note: The delivery method currently selected does not correspond to the delivery method requested by the buyer:",
            "total": "Total",
            "do_not_know_cost": "I don't know the cost",
            "calcul_shipping_cost_instruction": "To make your life easier, we invite you to use a parcel delivery comparison tool. We recommend 'Packlink', but don't hesitate to test other equivalent solutions available in your country.",
            "calculate_cost": "Calculate",
            "warning": "Warning",
            "shipping_widget_send_proposal_btn": "Send my proposal",
            "making_offer_widget_title": "Modify my offer",
            "actual_price": "Current price",
            "cpf_commission_included": "CPF commission included",
            "cpf_commission_explanation_cost": "A commission of {0} is intended to cover operating and transaction costs. The sum of {1} will be refunded to you.",
            "if_buyer_accept_offer_condition": "If this offer is accepted by the buyer you will no longer be able to change your price, and the sale will be made.",
            "making_offer_widget_next_step_btn": "Next step",
            "add_my_shipping_address": "My delivery address",
            "confirm_shipping_address": "Purchase enquiry",
            "confirm_my_address": "Validate delivery address",
            "confirm_shipping_address_explanation": "For delivery, please confirm your delivery address so that the seller can calculate the shipping costs (only the zip code and town will be first communicated to the seller).",
            "change_shipping_address": "Modify delivery address",
            "hand_delivery_only": "Hand-delivered only",
            "hand_delivery_only_explanation": "Please discuss collection arrangements with the seller prior to purchase.",
            "understood": "I understand",
            "seller_message_template_7": "A notification has been sent to the buyer to confirm his delivery address.",
            "buyer_message_template_7": "Hello,\nTo estimate the total cost of the transaction, the seller must estimate the shipping costs. Please confirm your delivery address",
            "buyer_action_template_7": "Confirm your delivery address",
            "admin_message_template_7": "A notification has been sent to the buyer to confirm the delivery address.",
            "seller_message_template_8": "Great! Your contact has validated his delivery address: {0} The full address will be sent to you once the transaction is completed.",
            "seller_action_template_8": "Indicate shipping costs",
            "buyer_message_template_8": "The seller will now calculate the delivery costs for this address: {0}",
            "admin_message_template_8": "The buyer has validated the delivery address: {0}",
            "seller_message_template_9": "Your contact is informed of your new offer: {0} {1} {2} \n After deduction of commission, you will be paid the sum of {3}. \n The proposal was read: {4}",
            "buyer_message_template_9": "My new proposal is here! I suggest to adapt the selling price as follow: {0} \n {1} {2} {3}",
            "buyer_action_template_9": "Buy Now",
            "admin_message_template_9": "Here is a new offer from the seller: {0} {1} {2}",
            "seller_message_template_10": "A notification has been sent to your contact: {0} {1} {2} \n After deduction of commission, you will be paid the sum of {3}.\n\nYou can send him a short personalized message if you wish, and if you don't hear from him after 48 hours, we invite you to contact him again via the messaging system.",
            "buyer_message_template_10": "Details of your offer: {0} {1} {2}",
            "buyer_action_template_10": "Buy Now",
            "admin_message_template_10": "Here is the offer proposed by the seller: {0} {1} {2}",
            "seller_message_template_11": "Good news, {0} wants to buy your part {1} at the indicated price. \nPlease calculate the shipping costs for delivery to their address: {2} The full address will be sent to you once the transaction is complete.",
            "seller_action_template_11": "Indicate shipping costs",
            "buyer_message_template_11": "You will be notified by E-Mail once the seller will have calculated the delivery costs for this destination: {0} Don't hesitate to write a message if you have any special requirements.",
            "admin_message_template_11": "Request to the seller to calculate delivery costs to this address: {0}",
            "seller_message_template_12": "Well done! \n{0} has just purchased your part for the price of {1}. After deduction of commission, you will be paid the sum of {2}. It's time for you to send your part via your chosen carrier to the following address: {3}",
            "seller_hand_delivery_message_template_12": "Well done! \n{0} has just purchased your part for the price of {1}. It's time for you to define a place to meet up.",
            "check_list_step_1_message_template_12": "Confirmed transaction",
            "check_list_step_2_message_template_12": "Confirm parcel dispatch",
            "check_list_step_3_message_template_12": "Release of funds",
            "check_list_step_2_description_message_template_12": "You have a maximum of 72 hours in which to send it (otherwise, please let us know as soon as possible).",
            "check_list_step_2_button_message_template_12": "Confirm shipment",
            "buyer_message_template_12": "Thanks! \nWe have just informed the seller of your purchase. Unless otherwise instructed, he has a maximum of 72 hours to send it to you.",
            "buyer_hand_delivery_message_template_12": "Thanks! \nWe have just informed the seller of your purchase. Please contact him to arrange a pick-up date.",
            "admin_message_template_12": "The purchase was confirmed by {0} for a total of {1}.",
            "seller_message_template_13": "👋 Good news, someone is interested in your ad!\n\nIf you wish, you can use the button at the bottom right to change your selling price or shipping costs. Please note that your communication with the buyer can be subject to moderation and that the exchange of contact details is prohibited. For any questions, do not hesitate to contact us at <a class='basic-link' href='mailto:info@classic-parts-finder.com'>info@classic-parts-finder.com<\/a>\n\nThe Classic Parts Finder team 🚗✨",
            "buyer_message_template_13": "👋 Welcome to your messaging and payment area!\n\nPlease note that all conversations may be subject to moderation, and the exchange of contact details is prohibited. By doing so, we secure the transaction and the financing of the platform, and you benefit from our assistance in the event of a dispute.\n\nFor questions, do not hesitate to contact us at <a class='basic-link' href='mailto:info@classic-parts-finder.com'>info@classic-parts-finder.com<\/a>\n\nThe Classic Parts Finder team 🚗✨",
            "admin_message_template_13": "Chat Rules",
            "admin_name_template_13": "",
            "if_wish_change_shipping_address_instructions": "If you wish to change your delivery address, please notify the seller, who will recalculate the delivery costs with your new address.",
            "payment_title": "Secure payment",
            "buyer_payment_more_informations": "Rest assured, your money is secure throughout the entire transaction. You have 48 hours to report a problem after receipt.",
            "stripe_error_code": "Error code",
            "stripe_redirect_error_code": "An error occurred during payment. Please try Again.",
            "buy_with_stripe": "Pay via",
            "payment_in_progress": "Payment in progress",
            "offer_no_longer_available": "The offer is no longer available...",
            "card_holder_name": "Cardholder's name",
            "stripe_create_acount_explanation": "If you encounter any problems while setting up your seller account via Stripe, please contact an administrator by email at info@classic-parts-finder.com.",
            "stripe_account": "Stripe Account",
            "stripe_find_out_more": "Find out more about Stripe",
            "see_product": "View",
            "contact_administrator": "Contact the administrator",
            "verified_identity": "Verified identity",
            "order_validation": "Validation of your order",
            "contact_details": "Contact details",
            "order_summary": "Order summary",
            "displayed_selling_price": "Displayed selling price",
            "cpf_commission_included_price": "CPF commission {0} included",
            "for": "for",
            "phone_number_required_for_delivery": "Phone number required for delivery tracking.",
            "message_price_proposal_buyer_is_ue_and_seller_not_ue": "This part is located in a country outside the European Union. Customs charges may apply to delivery.",
            "message_price_proposal_buyer_not_ue": "This part is located in a country different from yours. Customs charges may apply to delivery.",
            "whats_prefered_shipping_mode": "Preferred delivery method?",
            "no_preference": "Doesn't matter",
            "home_delivery": "Home delivery",
            "relay_point_delivery": "Pickup point",
            "by_hand_delivery": "Hand delivery",
            "by_hand_delivery_alert": "Please contact the seller to arrange a time and place for the exchange.",
            "by_hand_delivery_button": "Contact the seller",
            "relay_point_delivery_alert": "The seller will be invited to choose a pickup point close to your delivery address.",
            "relay_point_delivery_seller_alert": "Unless otherwise requested by the buyer, please choose a pickup point close to the delivery address (home).",
            "buyer_prefered_shipping_mode": "Preferred delivery method:",
            "buyer_action_decline_offer": "Decline the offer",
            "seller_message_template_14": "Your offer has been declined for the following reason:",
            "buyer_message_template_14": "You declined the offer for the following reason:",
            "admin_message_template_14": "The offer was declined for the following reason:",
            "decline_offer_modal_title": "Decline",
            "decline_offer_modal_select_label": "Reason for refusal",
            "decline_offer_default_select_option": "Choose a reason",
            "too_high_select_option": "Delivery costs too high",
            "found_another_part_select_option": "Part already found",
            "decline_offer_modal_other_reason_label": "Please specify why you are declining the offer",
            "decline_offer_modal_btn_decline": "I decline this offer",
            "confirm_shipping_widget_menu_title": "Confirm shipment",
            "confirm_shipping_widget_title": "Confirm shipment",
            "confirm_shipping_widget_send_btn": "Confirm shipment",
            "confirm_shipping_carrier_label_name": "Carrier name",
            "confirm_shipping_carrier_select_placeholder": "Choose from list",
            "confirm_shipping_carrier_select_other": "Other...",
            "confirm_shipping_parcel_tracking": "Tracking number",
            "confirm_shipping_tracking_url_label": "Full tracking URL",
            "seller_action_template_15": "Track order",
            "buyer_action_template_15": "Track my order",
            "admin_action_template_15": "Track order",
            "seller_message_title_template_15": "Order shipped",
            "buyer_message_title_template_15": "Your order is on its way!",
            "admin_message_title_template_15": "The order has been dispatched",
            "seller_message_template_15": "You have confirmed that your order has been dispatched. You can track your parcel on the carrier's website.",
            "buyer_message_template_15": "The sender has confirmed that your order has been dispatched. You can track your parcel on the carrier's website.",
            "admin_message_template_15": "The sender has confirmed that the order has been dispatched.",
            "complementary_info_second_title": "References and illustrations",
            "complementary_info_second_title_description": "Please complete at least one of the two fields below",
            "buyer_message_to_tell_choice_to_seller": "If the offer does not suit you, please decline as a courtesy!",
            "address_confirmation_already_sent_to_seller": "You have already confirmed your address, please wait for the seller's reply.",
            "address_confirmation_limit_reached": "You have reached the address confirmation limit.",
            "loading_products": "Loading...",
            "typologie_de_la_produit_2": "Type",
            "scroll_to_top": "Scroll to top",
            "translate_in": "Translate in",
            "view_translation_message": "View translation",
            "view_original_message": "View original",
            "translate_is_processing": "Translation is processing",
            "your_interlocutor_speaks": "Your interlocutor speaks",
            "your_messages_can_be_automatically_translated": "(if needed, your messages can be automatically translated)",
            "seller_offer": "Seller's offer",
            "vehicle_not_found_info": "Did you enter the name of your vehicle before the brand? (There is no need to specify the version). If not, please try again by pressing the ‘Cancel’ button.",
            "edit_research": "Edit search",
            "ask_the_community": "Ask the community",
            "we_forward_your_request_to_members": "Ask the Classic Parts Finder community!",
            "check_stock_first": "Check stock first",
            "1_piece_currently_available": "1 part currently available",
            "parts_currently_available": "parts currently available",
            "what_do_you_want_to_do_now": "What do you want to do now?",
            "advanced_search_button": "Advanced search",
            "search_product_list": "Parts available",
            "unsubscribed_email_vehicle_notification_message": "The notification has been successfully disabled. You can reactivate it at any time under your vehicle's details.",
            "user_left_without_purchase": "{0} leaves the conversation; the sale is closed at this point", // TODO: remove with the good message
            "seller_message_template_17": `Your message could not be sent because it contained private contact information. This violates our terms and conditions. Please try sending it again. \n Message: {0}`,
            "reading_new_price_9": "The proposal was read: {0}",
            "copy_info": "Copy information",
            "info_copied": "Copied!",
            "select_shipping_mode": "-- Select a shipping method --",
            "seller_action_item_paid_title": "Order paid by the buyer!",
            "seller_action_item_paid_desc": "Remember to confirm shipment and add the tracking number once the item is sent.",
            "seller_action_item_paid_warning": "Attention : vous êtes responsable du bon acheminement de votre colis. Assurez-vous que votre colis soit bien couvert en cas de perte ou de dommage.",
            "oldPrice": "Previous price",
            "seller_action_item_paid_warning_ship": "If you are unable to ship within 72 hours, please inform your buyer",
            "add_to_ad": "Add to ad",
        }
    },
    "de": {
        "name": "Deutsch",
        "messages": {
            "book_fast": "Eine Minute!",
            "important": "Hinweis",
            "payment_book_1": "Bevor Sie dieses Teil kaufen, ist es wichtig, dass Sie sich mit dem Verkäufer in Verbindung setzen, um Ihre Versandkosten zu ermitteln.",
            "payment_book_2": "Bei Rückfragen zu Ihre Transaktion können Sie sich jederzeit an info@classic-parts-finder.com wenden. Für die Paketaufgabe hat der Verkäufer 72 Stunden Zeit.",
            "book_tarif_1": "",
            "book_tarif_2": "",
            "pay": "Bezahlen Sie",
            "secure_purchase": "Kaufen",
            "parts_available_button": "Andere verfügbare Teile",
            "parts_notification_message": "Per E-Mail über neue Teile benachrichtigt werden, die für dieses Fahrzeug zum Verkauf angeboten werden.",
            "available_parts": "Verfügbare Teile",
            "registration": "Registrierung",
            "login_failed": "Sich nicht einloggen können",
            "back": "Zurück",
            "choose_country": "Wähle ein Land",
            "max_images": "Maximal 10 Fotos",
            "email": "E-Mail-Adresse",
            "accept_cgu": "Durch das Erstellen eines Konto stimme ich den {0} und der {1} zu",
            "negociable": "Verhandelbar",
            "select_default_lang": "Wählen Sie die Standardsprache :",
            "non_negociable": "Nicht verhandelbar",
            "moderation_message": "Nachricht des Moderators",
            "voir_changements": "Änderungen ansehen",
            "masquer_changements": "Änderungen ausblenden",
            "refus_changement": "Ablehnen",
            "accept_changement": "Änderungen übernehmen und verbreiten",
            "ad_modifications": "Vorgeschlagene Änderungen an Ihrer Anzeige",
            "research_modifications": "Vorgeschlagene Änderungen für Ihre Suche",
            "cgu": "Nutzungsbedingungen",
            "privacy": "Datenschutzerklärung",
            "finish": "Absenden",
            "email_already_used": "Die eingegebene E-Mail wird bereits verwendet,  bitte kontaktieren Sie uns über das {0} .",
            "registering_error": "Leider können wir Sie nicht registrieren, bitte kontaktieren Sie uns über das {0} .",
            "field_required": "Pflichtfeld!",
            "field_email": "Ungültige E-Mail!",
            "field_email_used": "E-Mail bereits verwendet!",
            "registering_email_sent": "Wir haben Ihnen soeben eine E-Mail mit einem Bestätigungslink geschickt.",
            "check_spams": "E-Mail nicht erhalten? Überprüfen Sie Ihren Spam-Ordner oder wenden Sie sich an den Support von Classic Parts Finder unter {1}",
            "back_login": "Zurück zur Anmeldeseite",
            "forgot_your_password": "Haben Sie Ihr Passwort vergessen?",
            "reset_send_email": "Sie erhalten eine E-Mail, um Ihr Passwort zu ändern.",
            "inexistant_email": "E-Mail-Adresse nicht vorhanden!",
            "validate": "Bestätigen",
            "reset_email_sent": "Ihnen wurde eine E-Mail gesendet!",
            "update_your_password": "Ihr Passwort ändern",
            "set_new_password": "Legen Sie ein neues Passwort fest.",
            "at_least_x_char": "Mindestens {0} Zeichen.",
            "password_must_be_identical": "Das Passwort muss identisch sein",
            "modify": "Ändern",
            "password_updated": "Passwort geändert",
            "your_password_updated": "Ihr Passwort wurde erfolgreich geändert!",
            "login": "Sich einloggen",
            "expired_link": "Der Link ist abgelaufen",
            "research_expired_status": "Abgelaufen",
            "confirm_new_passwd": "Neues Passwort bestätigen",
            "log_in": "Einloggen",
            "log_in_error": "Anmeldefehler :",
            "email_address": "E-Mail-Adresse",
            "password": "Passwort",
            "connection": "Anmeldung",
            "not_registered_yet": "Noch nicht registriert?",
            "i_research": "Ich suche Ersatzteile",
            "i_sell": "Ich verkaufe Ersatzteile",
            "log_out": "Ausloggen",
            "my_dashboard": "Mein Dashboard",
            "last_step": "Endspurt",
            "complementary_details_required": "Einige zusätzliche Informationen sind erforderlich.",
            "first_name": "Vorname",
            "field_alpha": "Nur alphabetische Werte!",
            "last_name": "Name",
            "country": "Land",
            "phone_number": "Telefonnummer",
            "confirm_new_password": "Passwort bestätigen",
            "information_editable_dashboard": "Ihre Angaben werden nicht an Dritte weitergegeben. Sie können sie jederzeit in Ihrem Dashboard unter 'Einstellungen' ändern.",
            "complete_registering": "Registrierung abschließen",
            "account_activated": "Ihr Konto wurde freigeschaltet",
            "connect_to_dashboard": "Sie können sich nun in Ihr Dashboard einloggen, neue Suchen erstellen,{0} oder Ihr Konto einrichten, um Teile zu verkaufen!",
            "log_in_dashboard": "Sich in das Dashboard einloggen",
            "criteria_explanation": "Diese Kriterien dienen der Orientierung und erheben keinen Anspruch auf Vollständigkeit; Classic Parts Finder übernimmt keine Haftung. Beachten Sie, dass die Abkürzung OEM (Original Equipment Manufacturer) ein Hinweis auf die Originalnummer ist, um die Herstellernummer eines Autoersatzteils zu bezeichnen. Beachten Sie, dass die Abkürzung OEM (Original Equipment Manufacturer) mit der Original-Herstellernummer eines Autoersatzteils verbunden ist.",
            "factory_oem": "Originalteil (OEM)",
            "strict_origin_factory": "Originalteil, hergestellt nach den Standards des Erstausrüsters während der gesamten Produktionslaufzeit des Modells und darüber hinaus (in der Regel 10 Jahre ohne Unterbrechung).",
            "remade_oem": "Nachproduziertes Originalteil (OEM)",
            "strict_origin_remade": "Nachproduziertes Originalteil, das mit dem Fabrikat des Erstausrüsters identisch ist, jedoch nach dem Ende der Produktionslaufzeit des Modells nachproduziert wurde (in der Regel mehrere Jahrzehnte später). Dieses Teil erfüllt - oder übertrifft - in jeder Hinsicht die Kriterien und Anforderungen für die Herstellung des damals gefertigten Stücks.",
            "old_fixed": "Restauriertes Originalteil (OEM)",
            "strict_origin_fixed": "Streng identisch mit dem Original (Vintage OEM-Teil), aber restauriert.",
            "remplacement_part": "Nachgebautes Teil",
            "quality_replacement": "Teil in vergleichbarer Qualität zum Originalteil (OEM). Es kann aus der Produktionslaufzeit des Modells stammen oder nachproduziert sein, wurde jedoch nie am Fahrzeug montiert. Es können (z.T. kaum sichtbare) Unterschiede zum Originalteil (OEM) bestehen. Das Teil entspricht den Zulassungsbedingungen.",
            "criteria_responsibility": "Diese Kriterien dienen der Orientierung und erheben keinen Anspruch auf Vollständigkeit; Classic Parts Finder übernimmt keine Haftung.",
            "our_advice": "Unser Rat",
            "avoid_issue_defaults": "Unsere Empfehlung: Um Missverständnisse zu vermeiden, denken Sie daran, alle Mängel systematisch zu erwähnen und sie in Ihren Fotos zu dokumentieren!",
            "brand_new": "Neu",
            "never_used": "Artikel nie benutzt und vollständig, vorzugsweise in seiner ursprünglichen Verpackung. Keine Abnutzungsspuren vorhanden.",
            "very_good": "Sehr gut",
            "almost_never_used": "Artikel sehr wenig bis nie benutzt, vollständig. Volle Funktionstüchtigkeit bei mechanischem Teil. Es weist kaum sichtbare Mängel bzw. Gebrauchsspuren auf (z. B. leichte Kratzer oder Oxidationsspuren aufgrund von Lagerung ...)",
            "good": "Gut",
            "few_imperfections": "Bereits benutzter Artikel. Volle Funktionstüchtigkeit bei mechanischem Teil. Es weist teils sichtbare Unvollkommenheiten, Mängel und Gebrauchsspuren auf, für den sofortigen Einbau sind jedoch keine Reparaturen erforderlich.",
            "satisfying": "Befriedigend",
            "needs_cleaning": "Teil mit offensichtlichen, für das bloße Auge erkennbaren Abnutzungsspuren, was u.U. seine ordnungsgemäße Funktionsweise oder Montage beeinträchtigen könnte. Möglicherweise ist eine Revision oder Reinigung nötig.",
            "renovate": "Zu restaurieren",
            "to_renovate_fix": "Nicht funktionstüchtiges Teil, beschädigt, zur Restauration oder Wiedergewinnung von Teilen verwendbar.",
            "other_question": "weitere Frage",
            "enter_your_question": "Geben Sie Ihre Frage ein",
            "send": "Absenden",
            "cancel": "Abbrechen",
            "message_waiting_validation": "Nachricht versendet. Ihren Posteingang erreichen Sie im Dashboard oben rechts.",
            "more_picture_product": "Ich würde gerne mehr Fotos sehen",
            "where_product_from": "Können Sie mir mehr über den Zustand sagen?",
            "thanks_for_comment": "Danke für Ihren Kommentar",
            "add": "Hinzufügen",
            "research": "Suche",
            "vehicle": "Fahrzeug",
            "simplified_announce": "Alert",
            "product": "Anzeige",
            "parameters": "Einstellungen",
            "my_researches": "Meine Suchen",
            "my_vehicles": "Meine Fahrzeuge",
            "my_simplified_announces": "Meine Alerts",
            "my_products": "Meine Anzeigen",
            "email_modification": "Änderung der E-Mail in Bearbeitung",
            "to_change_email_dashboard": "Um Ihre E-Mail zu ändern, loggen Sie sich bitte erneut auf Ihrem Dashboard ein und ändern Sie Ihre E-Mail in Ihren Kontoeinstellungen.{0} Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Classic Parts Finder Support unter {1}.",
            "log_myself": "Einloggen",
            "success_email_change": "Ihre E-Mail wurde erfolgreich geändert",
            "other": "Sonstiges",
            "vendor_parameters": "Anbietereinstellungen",
            "sell_parts": "Verkaufen Sie Ihre Ersatzteile{0}auf Classic Parts Finder",
            "diffuse_products": "Veröffentlichen Sie Ihre Anzeigen in wenigen Minuten!",
            "activate_vendor": "Mein Anbieterkonto aktivieren",
            "all_modifications_taken": "Alle Änderungen wurden berücksichtigt.",
            "error_happened_wrong_param": "Ein Fehler ist aufgetreten, bitte prüfen Sie Ihre Eingaben.",
            "business_name": "Name des Unternehmens",
            "business_address": "Anschrift",
            "zip_code": "Postleitzahl",
            "city": "Stadt",
            "region": "Region",
            "Numéro d'identification de votre entreprise (14 chiffres du Siret pour la France)": "Identifikationsnummer des Unternehmens",
            "save_changes": "Änderungen speichern",
            "account_info_linked_business": "Da Sie Privatverkäufer sind, wird Ihr Anbieterkonto mit Ihren persönlichen Angaben verknüpft.",
            "become_pro": "Händler werden",
            "password_security": "Passwort und Sicherheit",
            "actual_password": "Aktuelles Passwort",
            "new_password": "Neues Passwort",
            "confirm_your_new_password": "Bestätigen Sie Ihr neues Passwort",
            "account_removal": "Alle Ihre Suchen, Anzeigen, Alerts und Treffer werden gelöscht. Sind Sie sicher, dass Sie Ihr Konto löschen möchten?",
            "remove_my_account": "Mein Konto löschen",
            "action_will_disconnect": "Diese Aktion loggt Sie nach der Validierung aus. Ihr Konto ist von diesem Moment an nicht mehr zugänglich.",
            "confirm_account_removal": "Löschung meines Kontos bestätigen",
            "personal_details": "Persönliche Angaben",
            "sell_parts_cpf": "Verkaufen Sie Ihre Ersatzteile{0}auf Classic Parts Finder",
            "publish_products_fast": "Veröffentlichen Sie Ihre Anzeigen in wenigen Minuten!",
            "activate_seller_account": "Mein Anbieterkonto aktivieren",
            "email_changing_to": "In Bearbeitung: Antrag auf E-Mail-Wechsel nach",
            "address": "Anschrift",
            "spoken_langage": "Gesprochene Sprachen",
            "my_account": "Mein Konto",
            "email_already_used_log": "Diese E-Mail-Adresse wird bereits verwendet. Bitte loggen Sie sich ein.",
            "cannot_register": "Wir können Sie nicht registrieren. Bitte kontaktieren Sie den Support von Classic Parts Finder unter {1}.",
            "nearly_there_login": "Sie sind fast am Ziel! Loggen Sie sich einfach ein, um Ihre Suche zu bestätigen!",
            "nearly_there_register": "Fast geschafft! Geben Sie Ihre E-Mail-Adresse an, um Ihre Suche bestätigen zu können.",
            "already_have_account": "Ich habe bereits ein Konto",
            "email_sent_confirm_research": "Bitte checken Sie Ihre E-Mails, um Ihre Anmeldung zu bestätigen.",
            "select_from_own": "Wählen Sie Ihr Fahrzeug aus",
            "find_new_vehicle": "Fügen Sie Ihr neues Fahrzeug hinzu",
            "what_is_vehicle": "Welches ist Ihr Fahrzeug?",
            "brand_modele_etc": "Modell, Marke",
            "cant_find_vehicle": "Mein Fahrzeug wird nicht in der Liste geführt.",
            "vehicle_not_found": "Fahrzeug nicht gefunden",
            "your_vehicle_not_found": "Ihr Fahrzeug",
            "keep_track_demand": "So können wir Sie zu Ihrer Anfrage auf dem Laufenden halten.",
            "required_informations": "Pflichtfeld",
            "thanks_demand": "Vielen Dank für Ihre Anfrage!",
            "email_contact_back": "Wir melden uns per E-Mail, sobald das gewünschte Fahrzeug im Alertsystem verfügbar ist.",
            "next_step": "Weiter",
            "your_email": "Ihre E-Mail",
            "add_vehicle": "Fahrzeug hinzufügen",
            "previous_step": "voriger Schritt",
            "which_part_looking_for": "Welches Teil suchen Sie?",
            "part_name_etc": "Name",
            "loading": "Lädt...",
            "which_kind_of_part": "Wählen Sie Ihre Kategorie",
            "complementary_info": "Weitere Informationen",
            "lets_gain_time": "Bitte machen Sie präzise Angaben damit Ihre Suche sofort von unserem Team validiert werden kann!",
            "year_vehicle": "Jahr des Fahrzeugs",
            "select_year": "Jahr wählen",
            "vehicle_version": "Ausführung",
            "motor_paint_etc": "Ausführung, Karosserie, Antrieb",
            "part_precisions": "Details zum gesuchten Teil",
            "looking_version_part": "Ich suche nach...",
            "part_is_compatible": "Wenn Sie wissen, dass das Teil mit anderen Fahrzeugen kompatibel ist, geben Sie diese bitte an",
            "kind_of_part": "Ihre Anforderungen an das gesuchte Teil",
            "part_type_guide": "Typen-Orientierungshilfe",
            "part_reference": "Teilenummer und\/oder Name des Herstellers",
            "reference_id_etc": "Referenz- oder Identifikationsnummer",
            "maximize_add_photos": "Fotos oder Skizze",
            "maximum_photos": "Maximal 5",
            "drop_files_here": "Legen Sie die Dateien hier ab",
            "or_if_prefer": "oder",
            "select_files": "Wählen Sie die Dateien aus",
            "remove": "Löschen",
            "sending_progress": "In Bearbeitung",
            "your_research": "Ihre Suche",
            "brand_modele": "Modell, Marke",
            "part_category": "Kategorie",
            "part_research": "Gesuchtes Teil",
            "vendor_account_ready": "Ihr Anbieterkonto ist fertig!",
            "account_secured_obvy": "Ihr Anbieterkonto ist bei Stripe sicher!",
            "and_now": "Und nun?",
            "can_sell_products": "Sie können nun Ihre Teile verkaufen und Ihr Geld erhalten.",
            "accept_paiements": "Zahlungen akzeptieren",
            "sell_with_obvy": "Verkaufen Sie Ihre Teile sicher mit Stripe, unserem Partner, der Ihre Transaktionen sichert!",
            "secure_my_account": "Mein Konto sichern",
            "go_further": "Es soll schneller gehen?",
            "tell_part_category": "Geben Sie nur die Kategorie des Teils an, das Sie verkaufen möchten: Wir benachrichtigen Sie, sobald wir einen Kaufinteressenten finden.",
            "create_simplified_announce": "Meine Alert erstellen",
            "add_product": "Meine Anzeigen erstellen",
            "create_first_product": "Schalten Sie Ihre erste Anzeige, wir benachrichtigen Sie, sobald jemand ein Kaufinteresse hat.",
            "complete_later": "Zugriff auf mein Dashboard",
            "all_rights": "Alle Rechte vorbehalten",
            "new_simplified_announce": "Neue Alerts",
            "receive_mail_research": "Schalten Sie einen Alert! Sie werden benachrichtigt, wenn jemand nach einem Ihrer Teile sucht.",
            "vehicles_compatible": "Fahrzeug",
            "vehicles_with_alert": "",
            "brand_modeles_etc": "Modell, Marke",
            "answer_by_mail": "Wir werden uns per E-Mail bei Ihnen melden, sobald das gewünschte Fahrzeug im Alertsystem verfügbar ist.",
            "part_not_found": "Teil nicht gefunden",
            "your_unknown_part": "Ihr Teil",
            "name_part": "Name",
            "unknown_part_mail": "Wir werden uns per E-Mail bei Ihnen melden, sobald das gewünschte Teil im Alertsystem verfügbar ist.",
            "part_categories": "Kategorien",
            "multiple_choices": "(mehrere Wahlmöglichkeiten)",
            "category_all_parts": "Alle Teile der Kategorie",
            "cant_find_part_list": "Ich kann mein Teil nicht in der Liste finden",
            "activate_announce": "Aktivieren Sie die Alerts!",
            "french_german": "Französisch, Englisch, Deutsch...",
            "version_non_renseigne": "keine Angaben zur Ausführung",
            "new_research": "Erweiterte Suche",
            "see_vehicle": "Mein Fahrzeugprofil",
            "find_by_brand_year_etc": "Nach Modell, Marke, Jahr suchen",
            "grid_display": "Grid-Anzeige",
            "line_display": "Linien-Anzeige",
            "table_display": "Tabelle-Anzeige",
            "confirm_vehicle_removal": "Sind Sie sicher, dass Sie das Fahrzeug löschen möchten?",
            "all_research_removal": "Alle laufenden Suchen {0} werden gelöscht.",
            "do_not_remove": "Nicht löschen",
            "searching_x_products": "Sie suchen derzeit {0} Teil | Sie suchen derzeit {0} Teile",
            "no_research_currently": "Keine aktuelle Suche",
            "no_vehicles": "Klicken Sie auf den Tab '+', um Ihr Fahrzeug hinzuzufügen.",
            "non_renseign": "keine Angaben",
            "produit_suggr": "Angebotenes Teil",
            "vehicle_details": "Details zu meinem Fahrzeug",
            "version": "Ausführung",
            "add_version": "Ausführung hinzufügen",
            "year": "Jahr",
            "associated_researches": "Verwandte Suchen",
            "see_x_findings": "Meine {length} Treffer ansehen",
            "see_my_finding": "Meinen neuen Treffer ansehen",
            "research_awaiting_validation": "Suche wartet auf Freigabe",
            "experts_are_looking": "Wir suchen nach Ihrem Teil",
            "vehicle_parameters": "Fahrzeugeigenschaften",
            "new_vehicle": "Neues Fahrzeug",
            "name_too_short": "Name zu kurz.",
            "name_too_long": "Name zu lang.",
            "update": "Aktualisieren",
            "what_is_your_vehicle": "Was ist Ihr Fahrzeug?",
            "select_vehicle_first": "Wählen Sie zuerst ein Fahrzeug",
            "engine_bodywork_etc": "Ausführung, Karosserie, Antrieb",
            "states_guide": "Zustands-Orientierungshilfe",
            "administration": "Administration",
            "inbox": "Posteingang",
            "pice_suggre": "Angebotenes Teil",
            "my_last_researches": "Meine letzten Suchen",
            "no_researches_for_now": "Zur Zeit keine Suche",
            "all_my_researches": "Alle meine Suchen",
            "no_research_made": "Sie haben noch keine Suche erstellt",
            "my_last_simplified_announces": "Meine letzten Alerts",
            "no_simplified_announces_currently": "Zur Zeit keine Alerts",
            "all_my_simplified_announces": "Alle meine Alerts",
            "didnt_config_seller_space": "Sie haben Ihren Verkaufsbereich noch nicht eingerichtet",
            "configure": "Einrichten",
            "new_part_for_your": "Brauchen Sie ein bestimmtes Teil für Ihren",
            "we_look_for_you": "Fragen Sie die Classic Parts Finder Community!",
            "notifications": "Mitteilungen",
            "all": "Alle",
            "no_unread_notifications": "Keine ungelesene Mitteilung",
            "someone_research_your_part": "Jemand sucht eines Ihrer Teile",
            "you_created_simplified_announce": "Sie haben ein Alert erstellt",
            "we_found_product_for_you": "Wir haben ein Teil für Sie gefunden",
            "you_created_research": "Sie haben eine Suche erstellt",
            "part_attributed_to_research": "Ein Teil wurde der Suche zugewiesen",
            "part_attributed_to_product": "Ein Teil wurde zugewiesen",
            "date": "Datum",
            "part": "Kategorie\/Typ",
            "see_simplified_announce": "Treffer anzeigen",
            "details": "Details",
            "no_notification": "Keine Mitteilung",
            "welcome_aboard": "Willkommen an Bord",
            "conversations": "Nachrichten",
            "buying_product": "Teil(e)-Kauf",
            "selling_product": "Teil(e)-Verkauf",
            "no_new_message": "Keine neue Nachricht",
            "vous": "Sie",
            "sent_at": "Am {date}",
            "message_sent_for_validation": "Ihre Nachricht wird verschickt, sobald sie von einem Administrator freigegeben wurde.",
            "moderation_in_progress": "wird geprüft",
            "sent": "Gesendet",
            "read": "Gelesen",
            "new_message": "Hallo, ........ Danke",
            "from": "Von:",
            "refused": "Abgelehnt",
            "actual_message_to_moderate": "Aktuelle Nachricht unter Moderation",
            "missing_info_profil": "Fehlende Angaben in Ihrem Profil",
            "required_info_to_continue": "Sie müssen die folgenden Informationen eingeben, um fortfahren zu können:",
            "save_informations": "Angaben speichern",
            "my_orders": "Meine Bestellungen",
            "reference": "Referenznummer(n)",
            "amount": "Betrag",
            "status": "Status",
            "option": "Option",
            "options": "Optionen",
            "allow_sale": "Verkauf annehmen",
            "refuse_sale": "Verkauf ablehnen",
            "paiement_accept": "Zahlung angenommen",
            "order_sent": "Bestellung versendet",
            "confirm_reception": "Empfang bestätigen",
            "do_reclamation": "Beschwerde einreichen",
            "reimburse_partiel": "anteilige Rückerstattung",
            "reimburse_total": "vollständige Rückerstattung",
            "no_order": "Sie haben noch keine Bestellung",
            "how_does_it_work": "Wie funktioniert es?",
            "advantages": "Vorteile",
            "dashboard": "Dashboard",
            "selling_easy": "Mit Classic Parts Finder ist der Verkauf Ihrer Ersatzteile ein Kinderspiel!",
            "create_market_fast": "Erstellen Sie jetzt Ihr kostenfreies Konto!",
            "i_am_pro": "Ich bin ein Händler",
            "i_am_individual": "Ich bin eine Privatperson",
            "receive_alert_research": "Werden Sie benachrichtigt, wenn jemand nach Ihrem Teil sucht!",
            "simplified_announce_explained": "Zu viele Teile auf Lager und nicht immer die Zeit, um alle Ihre Anzeigen zu schalten? Erstellen Sie unsere Alert-Funktion in nur wenige Sekunden!",
            "publish_products_fast_easy": "Erreichen Sie eine Community von Autoliebhabern",
            "publish_large_catalog": "Erhöhen Sie kostenlos Ihre Verkaufschancen, indem Sie Anzeigen schalten.Einmal wöchentlich werden alle Mitglieder der Classic Parts Finder-Community per Newsletter über neu geschaltete Anzeigen für ihr Fahrzeug informiert. Lassen Sie sich von unserem Anzeigensystem überzeugen, das eigens für den Verkauf von Oldtimer-Ersatzteilen entwickelt wurde. Profitieren Sie außerdem von unserer Beratung, unserem Fachwissen sowie unserer Kundenbetreuung. ",
            "ready_to_sell": "Bereit, Ihre Ersatzteile zu verkaufen?",
            "register_fast": "Eine Registrierung erfordert nur wenige Minuten!",
            "free_service_part": "Das Standardtool für die Suche, den Verkauf und die Aufarbeitung von Ersatzteilen zwischen Privatpersonen und Profis. Originalteile oder hochwertige Nachproduktionen für Oldtimer und Youngtimer.",
            "menu": "Menü",
            "take_my_research": "Ich erstelle eine Suche",
            "facebook_link": "Link zur Facebook-Seite Classic Parts Finder",
            "instagram_link": "Link zur Instagram-Seite Classic Parts Finder",
            "privacy_policies": "Datenschutzerklärung",
            "cgu_full": "Nutzungsbedingungen",
            "legals_info": "Rechtlicher Hinweis",
            "suivant": "Weiter",
            "valeurs_alphabtiques_uniquement": "Nur alphabetische Werte!",
            "doit_tre_compos_de_14_chiffres": "",
            "valeur_numrique_uniquement": "",
            "n_de_siret": "Identifikationsnummer des Unternehmens",
            "adresse_de_lentreprise": "Anschrift",
            "pays_de_lentreprise": "Unternehmenssitz",
            "nom_de_lentreprise": "Name des Unternehmens",
            "au_moins_2_caractres": "Mindestens 2 Zeichen",
            "votre_nom": "Ihr Nachname",
            "votre_prnom": "Ihr Vorname",
            "part_found": "{length} gefundenes Teil | {length} gefundene Teile",
            "recherche_termine": "Suche abgeschlossen",
            "la_recherche_a_t_archive": "Suche archiviert",
            "nos_experts_sont_en_cours_de_recherche": "Wir suchen nach Ihrem Teil",
            "faire_une_nouvelle_recherche": "Suche erstellen",
            "vous_souhaitez_acheter_des_pices_pour_votre_ancien": "Nutzen Sie unsere einzigartige Funktion und befragen Sie die Mitglieder der Community.",
            "aucune_recherche": "Keine Suche",
            "pas_de_recherche": "Keine Suche",
            "product_found": "{length} Teil gefunden | {length} Teile gefunden",
            "dtails_de_la_recherche": "Details zu meiner Suche",
            "suggested_product": "Angebotenes Teil",
            "rechercher_par_modle_marque_produit_recherch": "Suche nach Modell, Marke, Teil...",
            "nous_sommes_dsols_nous_ne_sommes_pas_en_mesure_de": "Es tut uns leid, wir sind derzeit nicht in der Lage, diese Informationen abzurufen. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.",
            "recherches_avec_produits_trouvs": "Suchen mit gefundenen Teilen ({done}\/{total})",
            "afin_damliorer_la_qualit_de_nos_suggestions_pourri": "Um die Qualität der Anzeigen zu verbessern, würden Sie bitte die Gründe für Ihre Wahl angeben?",
            "je_cherche_une_pice_en_meilleur_tat_le_prix_est_tr": "Ich suche ein Teil in besserem Zustand, der Preis ist zu hoch, etc.",
            "nous_envoyer_une_suggestion": "Senden Sie uns eine Rückmeldung",
            "quelle_est_votre_question_pour_ce_vendeur": "Wie lautet Ihre Frage an diesen Verkäufer?",
            "en_savoir_plus_sur_obvy": "Mehr erfahren über Stripe",
            "achat_scuris_avec": "Sichere Zahlung mit",
            "trop_tard_ce_produit_nest_plus_disponible": "Dieses Teil ist nicht mehr verfügbar.",
            "en_savoir_plus": "Mehr erfahren",
            "grce_la_garantie_cpf": "",
            "achetez_en_toute_srnit": "Warum sollten Sie uns vertrauen?",
            "frais_de_port_en_sus_calculer_selon_le_mode_de_liv": "Zuzüglich Versandkosten, die je nach der vom Verkäufer angebotenen Versandart zu berechnen sind.",
            "colis_remis_au_transporteur_sous_jours": "(Pakete werden dem Spediteur innerhalb von {averagepreparationtime} Tagen übergeben)",
            "expdition": "Versand",
            "hors_frais_de_ports": "(ohne Versandkosten)",
            "prix": "Preis inkl. MwSt.",
            "dimensions_du_produit": "Größe (L x B x H)",
            "poids_du_produit": "Gewicht des Pakets",
            "jours": "{average_preparation_time} Tage",
            "temps_moyen_de_prparation": "Durchschnittliche Vorbereitungszeit",
            "contacter_le_vendeur": "Eine Frage stellen",
            "vendu_directement_par_cpf": "Verkauft direkt durch CPF",
            "seller": "Verkäufer",
            "a_propos_du_vendeur": "Über den Verkäufer",
            "fabricant": "Hersteller",
            "rfrence_du_produit": "Referenz(en) des Artikels",
            "description": "Beschreibung",
            "state": "Zustand:",
            "facebook": "Facebook",
            "copier_le_lien": "Link kopieren",
            "partager_le_produit": "Anzeige teilen",
            "trouvailles_par_page": "Treffer pro Seite",
            "ce_formulaire": "dieses Formular",
            "vous_pouvez_nous_faire_votre_demande_via": "Richten Sie Ihre Anfrage an uns über",
            "assistance_en_cas_de_litige": "Support bei Rechtsstreitigkeiten, ohne Chatbots!",
            "larticle_doit_tre_retourn_dans_son_tat_dorigine_et": "Der Artikel muss in seinem Originalzustand und ohne jegliche Gebrauchsspuren zurückgegeben werden. Der Käufer trägt die Versandkosten für die Rücksendung, es sei denn, der Artikel entspricht nicht der Beschreibung. Der Käufer erhält eine volle Rückerstattung, abzüglich der Versandkosten.",
            "si_achat_auprs_dun_professionnel": "(falls bei einem Händler gekauft)",
            "droit_de_rtractation_de_14_jours": "14-tägiges Widerrufsrecht",
            "garantie_lgale_des_vices_cachs": "",
            "garantie_lgale_de_conformit_du_bien": "Gesetzliche Konformitätsgarantie",
            "remboursement_total_ou_partiel_en_cas_de_perte_ou": "",
            "suivi_de_livraison_si_choix_via_mondial_relay_ou_c": "Gesetzliche Garantie für versteckte Mängel",
            "tarifs_de_livraison_ngocis_mondial_relay_et_chrono": "",
            "scurisation_des_fonds_protection_de_lacheteur_et_d": "Schutz vor Betrug durch unseren Partner Stripe",
            "garantie_de_paiement_sur_compte_squestre": "Garantie für sichere Transaktion",
            "garantie_de_transaction_scurise": "",
            "paiement_par_carte_ou_par_virement": "Wir veröffentlichen nur Anzeigen, die von uns gegengeprüft wurden. Verdächtige Nutzer und Verhaltensweisen werden so leichter und schneller erkannt.",
            "garantie_classic_parts_finder": "Die Vorteile von Classic Parts Finder",
            "la_recherche_nest_pas_disponible": "Die Suche ist nicht mehr verfügbar",
            "donnez_nous_plus_de_dtails_sur_le_produit_que_vous": "Geben Sie uns mehr Details zum gesuchten Teil an.",
            "je_cherche_des_produits_neufs_les_prix_sont_trop_l": "Ich suche ein Teil in besserem Zustand, der Preis ist zu hoch...",
            "pas_encore_de_trouvailles": "",
            "dgivrer_loffre": "Angebot auftauen",
            "vous_avez_chang_davis": "",
            "offre_refuse": "Angebot abgelehnt",
            "consulter_loffre": "Angebot anzeigen",
            "la_recherche_est_en_attente_de_validation": "Ihre Suche muss noch validiert werden",
            "research_continues": "Die Suche geht weiter, aber wir haben {size} Angebot gefunden, die Ihnen bereits zusagen könnten | Die Suche geht weiter, aber wir haben {size} Angebote gefunden, die Ihnen bereits zusagen könnten",
            "les_trouvailles": "Meine Suchen",
            "la_recherche_est_termine": "Die Suche ist beendet",
            "date_de_la_recherche": "Datum der Suche",
            "rfrence_du_produit2": "Referenzcode\/-nummer",
            "dtails": "Details",
            "type_de_produit": "Art des Ersatzteils",
            "produit_recherch": "Gesuchtes Teil",
            "dtails_de_votre_recherche": "Details zu meiner Suche",
            "product_suggested": "Vorgeschlagenes Teil",
            "pour": "für",
            "oups": "Hoppla...",
            "votre_recherche_est_introuvable_ou_a_dj_t_prolonge": "Ihre Suche wurde nicht gefunden oder bereits verlängert.",
            "accder_mon_tableau_de_bord": "Zugang zum Dashboard",
            "cest_not": "Verstanden!",
            "votre_recherche_a_bien_t_prolonge": "Ihre Suche wurde verlängert.",
            "accder_mon_tableau_de_bord2": "Zugang zum Dashboard",
            "bienvenue": "Willkommen",
            "activer": "Aktivieren",
            "dsactiver": "Deaktivieren",
            "dsactiv": "Deaktiviert",
            "en_attente_dune_recherche": "Warten auf eine Suchanfrage",
            "voir_les_recherches": "Treffer anzeigen",
            "rfrence_de_la_pice": "Referenzcode\/-nummer",
            "localisation_de_lacheteur": "Standort des Käufers",
            "date_de_la_recherche2": "Datum der Suche",
            "votre_question_pour_cet_acheteur_potentiel": "Ihre Frage an den Antragsteller?",
            "proposer_un_produit": "Ein Teil anbieten",
            "si_vous_avez_besoin_dlments_plus_prcis_en_rapport": "(Beachten Sie bitte, dass die Konversation einer Moderation unterliegt)",
            "contacter_lacheteur_potentiel": "Eine Frage stellen",
            "propos_de_lacheteur": "Über den Käufer",
            "compatible_avec": "Kompatibel mit",
            "crer_mes_annonces_simplifies": "Meine Alerts erstellen",
            "vous_souhaitez_vendre_des_produits_indiqueznous_si": "Zu viele Teile auf Lager und nicht immer die Zeit, um alle Ihre Anzeigen zu schalten? Erstellen Sie unsere Alert-Funktion in nur wenige Sekunden!",
            "aucune_annonces_simplifies": "Kein Alert",
            "aucune_annonce_simplifie_ne_correspond_aux_filtres": "Kein zu den Filtern passendes Alert",
            "supprimer_la_slection": "Auswahl entfernen",
            "annonce_dsactive": "Alert deaktiviert",
            "rechercher_par_marque_modle": "Nach Marke suchen",
            "vous_navez_pas_encore_de_vente": "Sie haben noch keinen Verkauf",
            "commande_livr": "Bestellung geliefert",
            "mes_ventes": "Meine Verkäufe",
            "si_malgr_tout_la_vente_na_pas_lieu_vous_navez_pas": "Wenn der Verkauf nicht zustande kommt, haben Sie Ihre Zeit nicht verschwendet! Ihre Anzeige wird veröffentlicht und an die Community weitergeleitet!",
            "le_produit_sera_transmis_lacheteur_aprs_validation": "Ihr Angebot wird nach Prüfung durch einen Administrator an den Käufer weitergeleitet.",
            "confirmation_dajout_du_produit": "Bestätigung, dass ein Teil hinzugefügt wurde",
            "ajouter_mon_premier_produit": "Mein erstes Teil hinzufügen",
            "crez_et_diffusez_vos_annonces_sur_classic_parts_fi": "",
            "aucun_produit": "Kein Teil",
            "supprimer_la_selection": "Auswahl entfernen",
            "aucun_produit_ne_correspond_votre_recherche": "Keine Anzeige entspricht Ihrer Suche",
            "diffuser": "Veröffentlichen",
            "votre_produit_sera_diffus_ds_validation_par_un_adm": "Ihre Anzeige wird nach Prüfung durch einen Administrator freigegeben wurde.",
            "exporter_vos_produits": "Meine Anzeigen exportieren",
            "rechercher_par_type_de_produit_modle": "Nach Teilbezeichnung suchen",
            "catgorie": "Kategorie",
            "lannonce_simplifie_nest_pas_disponible": "Zu spät! Es scheint, dass der Käufer bereits sein Glück gefunden hat...",
            "complter_la_fiche_produit": "Anzeige erstellen",
            "vrifier_que_vous_navez_pas_dj_cette_pice_dans_votr": "Vergewissern Sie sich, dass Sie dieses Teil nicht bereits veröffentlicht haben (siehe 'Meine Anzeigen').",
            "de_quelques_informations_complmentaires_sur_votre": "einige zusätzliche Informationen zu Ihrem Teil",
            "nous_avons_dsormais_besoin": "Wir brauchen nun",
            "flicitations": "Glückwunsch!",
            "a_propos_de_lacheteur": "Über den Käufer",
            "pas_cette_piece": "Dieses Teil habe ich nicht",
            "jai_trait_ce_produit": "Ich habe diese Anfrage bearbeitet",
            "en_attente_de_traitement": "Anfrage zu bearbeiten",
            "je_nai_pas_le_produit": "Ich habe das Teil nicht",
            "vous_avez_chang_davis2": "Haben Sie Ihre Meinung geändert?",
            "jai_trait_ce_produit2": "Ich habe diese Anfrage bearbeitet",
            "jai_ce_produit": "Suche erneut anzeigen",
            "vous_avez_le_produit": "",
            "je_nai_pas_ce_produit2": "Dieses Teil habe ich nicht.",
            "acheteur": "potenzieller Käufer | potenzielle Käufer",
            "vos_acheteurs_potentiels": "Ihre potenziellen Käufer",
            "date_de_publication": "Datum der Veröffentlichung :",
            "catgorie_cible": "Angebotene Kategorie",
            "pice_cible": "Angebotenes Teil",
            "dtails_de_lannonce_simplifie": "Details zum Alert",
            "dtails_de_votre_annonce_simplifie": "Details zu Ihrem Alert",
            "rsultats_de_mon_annonce": "Treffer",
            "je_nai_pas_trouv_ma_pice": "Ich habe mein Teil nicht gefunden",
            "diffuser_le_produit": "Anzeige veröffentlichen",
            "en_cours_denvoi": "Wird gesendet",
            "brouillon": "entwurf",
            "temps_moyen_de_prparation_jours": "Durchschnittliche Vorbereitungszeit: {0} Tag | Durchschnittliche Vorbereitungszeit: {0} Tage",
            "aperu_et_diffusion": "Vorschau und Veröffentlichung",
            "les_frais_lis_une_livraison_sont_la_charge_de_lach": "Die Versandkosten sind vom Käufer zu tragen.",
            "longueur": "Höhe",
            "largeur": "Breite",
            "hauteur": "Länge",
            "remise_en_main_propre_uniquement": "Nur persönliche Übergabe",
            "remise_en_main_propre_et_envoi_postal": "Persönliche Übergabe und Postversand",
            "envoi_postal": "Postversand",
            "veuillez_slectionner_une_option": "Bitte wählen Sie eine Option",
            "mode_de_transport_du_produit": "Zustellungsart",
            "dlai_avant_remise_au_transporteur": "Zustellfrist an das Versandunternehmen",
            "pensez_lemballage_arrondir_au_dessus": "Bedenken Sie das Gewicht Ihrer Verpackung.",
            "poids_approximatif_du_produit": "Ungefähres Gewicht Ihres Packets",
            "oui": "Ja",
            "non": "Nein",
            "le_prix_estil_ngociable": "Ist der Preis verhandelbar?",
            "est_destine_couvrir_les_frais_de_recherche_et_de_t": ", die vom Käufer zu zahlen ist, deckt die Betriebs- und Transaktionskosten.",
            "la_commission_de": "Eine Kommission von",
            "the_selling_price": "Der veröffentlichte Verkaufspreis liegt bei",
            "pour_vous": "Ihr Preis (inkl. MwSt.)",
            "indiquez_le_prix_de_vente_hors_livraison_minimum_2": "Geben Sie den Verkaufspreis ohne Versandkosten an (mindestens 2 €).",
            "prix_de_vente_affich": "Veröffentlichter Verkaufspreis",
            "prix_et_livraison": "Preis und Lieferung",
            "dplacer": "Verschieben",
            "rotation": "Drehen",
            "slectionnez_les_photos": "Wählen Sie Ihre Fotos aus",
            "dposez_les_photos_de_votre_produit_ici": "Legen Sie hier Ihre Fotos ab",
            "maximiser_vos_chances_de_vendre_en_proposant_plusi": "Maximieren Sie Ihre Verkaufschancen, indem Sie verschiedene Ansichten hochladen!",
            "cette_pice_convient_aux_modles_dans_son_emballage": "Angaben zum Zustand, seiner Herkunft, den kompatiblen Modellen...",
            "merci_de_prciser_du_mieux_possible_les_spcificits": "Bitte beschreiben Sie Ihr Teil so genau wie möglich!",
            "rfrence_interne_votre_stock_invisible_pour_lachete": "Nur für Sie (in der Anzeige unsichtbar): interner Referenzcode in Ihrem Lager",
            "typologie_de_la_produit": "Art des gesuchten Teils",
            "etat_du_produit": "Zustand",
            "quantit_disponible": "Verfügbare Menge",
            "titre_nom_prcis_du_produit": "Anzeigentitel",
            "informations_gnrales": "Beschreibung",
            "votre_produit_pourra_tre_diffus_aprs_la_validation": "Ihre Anzeige wird nach der Validierung durch einen Administrator veröffentlicht",
            "nom_de_votre_produit": "Bezeichnung Ihres Teils",
            "vous_ne_trouvez_pas_votre_produit": "Sie können Ihr Teil nicht finden?",
            "nom_du_produit": "Name",
            "indiquez_le_nom_du_produit": "Geben Sie den Namen mit Hilfe der Liste an",
            "type_de_produit_catgorie": "Teil",
            "ce_produit_est_compatible_pour_les_modles": "Dieses Teil ist mit den folgenden Modellen kompatibel ...",
            "nouveau_produit": "Neue Anzeige",
            "edition_de_produit": "Anzeige bearbeiten",
            "recherches_par_page": "Alerts pro Seite",
            "tous": "Alle",
            "prcdent": "Vorige",
            "operational_fees": "Transaktionsgebühren",
            "selling_price": "Verkaufspreis",
            "lments_slectionns": "ausgewählte(s) Element(e)",
            "dslectionner_tout": "Alle abwählen",
            "tous_les_produits_de_la_catgorie": "Alle Teile der Kategorie",
            "image": "Bild",
            "marque": "Marke",
            "modle": "Modell",
            "recherches": "Suchen",
            "dition": "Bearbeitung",
            "sure_supprimer_ces_annonces_simplifies": "Sind Sie sicher, dass Sie diese Alerts löschen möchten?",
            "sure_supprimer_cette_annonce_simplifie": "Sind Sie sicher, dass Sie dieses Alert entfernen möchten?",
            "annonces_par_page": "Anzeige pro Seite",
            "titre_de_lannonce": "Anzeigentitel",
            "filtrer_par_nom": "Nach Name filtern",
            "filtrer_par_type_de_produit": "Nach Teile-Kategorie filtern",
            "marque_modle": "Marke \/ Modell",
            "filtrer_par_modle": "Nach Modell filtern",
            "rfrence_interne": "Interne Referenz",
            "filtrer_par_rfrence": "Nach Referenznummer\/-code filtern",
            "stock": "Lager",
            "etat": "Zustand",
            "moderation_diffus": "Moderiert",
            "pas_de_modle": "Kein Modell",
            "pas_de_ref_interne": "Keine interne Referenz",
            "sure_supprimer_produit": "Sind Sie sicher, dass Sie die Anzeige löschen möchten?",
            "max_photos": "Maximal 10 Fotos",
            "the_buyer": "Der Käufer",
            "the_seller": "Der Verkäufer",
            "sure_supprimer_vehicule": "Sind Sie sicher, dass Sie das Fahrzeug löschen möchten?",
            "sure_supprimer_research": "Sind Sie sicher, dass Sie diese Suche löschen möchten?",
            "action": "Action",
            "type": "Typ",
            "diffus": "veröffentlicht",
            "optional": "Optional",
            "max_vehicles_in_list": "Maximale Anzahl an Fahrzeugen erreicht",
            "no_product_for_the_moment": "Keine Ergebnisse für Ihre Suche gefunden",
            "espace_recherche": "Suchbereich",
            "espace_vente": "Verkaufsbereich",
            "we_may_have_more_products_in_stock_for_this_vehicle": "Wir haben vielleicht andere Teile für dieses Fahrzeug!",
            "sur": "von",
            "next": "Weiter",
            "vehicles_per_page": "Fahrzeuge pro Seite",
            "page": "Seite",
            "pro_seller": "Händler",
            "private_seller": "Privatverkäufer",
            "before_continuing": "Bitte beachten Sie!",
            "not_search_engine_search_service_give_us_search_distribute_entire_classic_parts_finder_community_collectors_garages_breakers_etc": "Willkommen in der Classic Parts Finder Community! Wenn Sie ein bestimmtes Teil suchen, können Sie eine Suchanfrage schalten, die in der Community veröffentlicht wird.",
            "prefer_view_parts_already_available_classic_parts_finder_simply_register_enter_vehicle_model": "Wenn Sie die vorhandenen Teile für Ihr Fahrzeug anzeigen lassen möchten, melden Sie sich zuerst an.",
            "register_add_vehicle": "Ich melde mich an und füge mein Fahrzeug hinzu",
            "understand": "Ich habe verstanden",
            "start_research": "Suche erstellen",
            "These credentials do not match our records.": "Wir können keinen Account mit diesen Anmeldedaten finden.",
            "process_request": "Antrag ansehen",
            "parts_available_2": "Derzeit verfügbare Teile",
            "delete_research": "Löschen",
            "bulk_upload_a_file": "Datei hochladen",
            "bulk_column_mapping": "Spaltenzuordnung",
            "bulk_import": "Importieren",
            "bulk_importing_ads_file": "Importieren Sie Anzeigen aus einer Datei",
            "bulk_tool_allows_import_merge_ad_data_shop_excel_csv_file": "Mit diesem Tool können Sie Anzeigendaten in Ihrem Geschäft aus einer Excel- oder CSV -Datei importieren (oder verschmelzen).",
            "bulk_list_mandatory_fields": "Liste der obligatorischen Felder",
            "bulk_download_info": "Unsere Vorlage für eine <a href='\/assets\/classic-parts-finder-import-example.csv'>CSV-Datei<\/a> oder <a href='\/assets\/classic-parts-finder-import-example.xlsx'>Excel-Datei<\/a> herunterladen",
            "bulk_vehicle_model": "Fahrzeugmodell",
            "bulk_brand_vehicle": "Fahrzeug",
            "bulk_name_piece": "Name\/Typ des Teils",
            "bulk_title_ad": "Titel Ihrer Anzeige",
            "bulk_quantity": "Menge",
            "bulk_url_image_1": "Hauptbild -URL",
            "bulk_state": "Zustand",
            "bulk_info": "die Info",
            "bulk_type": "Art",
            "bulk_description": "Beschreibung",
            "bulk_price": "Preis in € inkl.",
            "bulk_approximate_weight_piece": "Stückgewicht pro kg",
            "bulk_proposed_mode_transport": "Transportmittel angeboten",
            "bulk_show_optional_fields": "Optionale Felder anzeigen",
            "bulk_hide_optional_fields": "Verstecken Sie die optionalen Felder",
            "bulk_list_optional_fields": "Liste der optionalen Felder",
            "bulk_internal_reference": "Interne Referenz",
            "bulk_year_vehicle": "Fahrzeugjahr",
            "bulk_manufacturer": "Hersteller",
            "bulk_reference_part": "Stückreferenz",
            "bulk_price_negotiable": "Ist der Preis verhandelbar?",
            "bulk_time_delivery_carrier_days": "Frist vor Rückkehr zum Träger (Tage)",
            "bulk_height": "Höhe",
            "bulk_width": "Breite",
            "bulk_lenght": "Länge",
            "bulk_url_image_2": "URL -Bild 2",
            "bulk_url_image_3": "URL Bild 3",
            "bulk_url_image_4": "URL Bild 4",
            "bulk_url_image_5": "URL -Bild 5",
            "bulk_start": "Start",
            "bulk_configuration_import_parameters": "Konfiguration der Importparameter",
            "bulk_select_file_computer": "Wählen Sie eine Datei von Ihrem Computer aus",
            "bulk_maximum_size_8_mb": "Maximale Größe 8 MB",
            "bulk_csv_separator": "CSV -Separator",
            "bulk_offer_ads_compatible_vehicles": "Ankündigungen für kompatible Fahrzeuge anbieten?",
            "bulk_checked_parts_will_displayed_compatible_vehicles_according_classic_parts_finder_database": "Wenn Sie überprüft werden, werden Ihre Teile gemäß der klassischen Teile -Finder -Datenbank als kompatibel mit anderen Fahrzeugen angezeigt.",
            "bulk_can_make_adjustment_individually_ad_import": "Sie können diese Einstellung in jeder Anzeige nach dem Import einzeln vornehmen.",
            "bulk_update_already_imported_ads": "Aktualisieren Sie die bereits importierten Ankündigungen?",
            "bulk_check_box_want_update_ads_already_imported": "Aktivieren Sie dieses Kontrollkästchen, wenn Sie Ankündigungen aktualisieren möchten, die Sie bereits importiert haben.",
            "bulk_important": "Wichtig",
            "bulk_internal_reference_new_ads_must_identical_internal_reference_ads_already_imported": "Die interne Referenz neuer Ankündigungen muss mit der internen Referenz der bereits importierten Ankündigungen identisch sein.",
            "bulk_ignore_first_line_file": "Ignorieren Sie die erste Zeile der Datei?",
            "bulk_check_box_first_line_file_not_ad_example_named_columns": "Aktivieren Sie dieses Kontrollkästchen, wenn die erste Zeile Ihrer Datei keine Anzeige ist. Zum Beispiel, wenn Sie Ihre Spalten benannt haben.",
            "bulk_previous_step": "Vorheriger Schritt",
            "bulk_continue": "Weitermachen",
            "bulk_associate_fields_file": "Kombinieren Sie die Felder Ihrer Datei",
            "bulk_column_choose_corresponding_criterion": "Wählen Sie für jede Spalte das entsprechende Kriterium aus.",
            "bulk_columns_file": "Spalten Ihrer Datei",
            "bulk_correspondence": "Korrespondenz",
            "bulk_column": "Spalte",
            "bulk_not_assigned": "Nicht zugeschrieben",
            "bulk_required": "Obligatorisch",
            "bulk_start_import": "Einfuhrimporte starten",
            "bulk_import_started_will_not_able_cancel_check_columns_mapped_correspond_field_selected": "Sobald der Import gestartet ist, können Sie ihn nicht mehr stornieren. Stellen Sie sicher, dass die von Ihnen kartierenden Spalten dem von Ihnen ausgewählten Feld entsprechen.",
            "bulk_successful_column_mapping": "Erfolgreiche Spaltenzuordnung!",
            "bulk_successful_column_mapping_description": "Ihre Anzeigen werden jetzt importiert. Unsere Roboter geben das Beste von sich, alle Ihre Anzeigen so schnell wie möglich zu importieren. Sie können die Seite verlassen, Sie werden per E-Mail benachrichtigt, wenn der Import vorbei ist.",
            "bulk_back_ads": "Kehre zu meinen Anzeigen zurück",
            "btn_bulk_import": "Masse",
            "status_to_be_verified": "Überprüft werden",
            "transport_propose_global_description": "",
            "transport_propose_description_1": "",
            "transport_propose_description_2": "",
            "transport_propose_description_3": "",
            "notice_cpf_title": "Classic Parts Finders Review",
            "original_notice": "In der Originalsprache ansehen",
            "add_personal_comment": "Möchten Sie einen Kommentar abgeben? Dann los!",
            "report_ad": "Diese Anzeige melden",
            "automatically_translated": "Automatisch übersetzt",
            "view_original": "Original einblenden",
            "hide_original": "Original ausblenden",
            "price_negotiable_explanation": "",
            "price_negotiable_title_0": "Der Preis Ihrer Anzeige ist nicht verhandelbar",
            "price_negotiable_description_0": "",
            "price_negotiable_title_1": "Der Preis für Ihre Anzeige ist verhandelbar",
            "price_negotiable_description_1": "",
            "no_research_alert": "Keine Suche in Verbindung zu diesem Teil",
            "french": "Französisch",
            "english": "Englisch",
            "german": "Deutsch",
            "image_is_processing": "Bilder werden importiert",
            "empty_car_title": "Kein Fahrzeug",
            "empty_car_description": "",
            "empty_car_add_first_car": "Mein erstes Fahrzeug hinzufügen",
            "own_research_title": "Sie können Ihr Teil nicht finden?",
            "contact": "Kontakt",
            "already_registered": "Bereits registriert?",
            "log_on_to": "Sich einloggen",
            "confirm_room_removal": "Sind Sie sicher, dass Sie die Konversation löschen wollen ?",
            "confirm": "Bestätigen",
            "msg_search_alert": "Suchalarm",
            "msg_product_is_no_longer_available": "Der Artikel ist nicht mehr verfügbar",
            "msg_you_have_no_conversation": "Keine Gespräche",
            "msg_name_of_the_conversation": "Unterhaltung umbenennen",
            "msg_modify_advert": "Anzeige bearbeiten",
            "msg_modify_name_conversation": "Bearbeiten Sie den Namen der Unterhaltung",
            "msg_no_conversation_selected": "Wählen Sie eine Unterhaltung aus",
            "shipping_address": "Adresse für die Lieferung",
            "send_offer": "Angebot bestätigen",
            "reservation_success": "Ihre Bestellung wurde erfolgreich versendet. Wir werden uns innerhalb von maximal 24 Stunden bei Ihnen melden und Ihnen die günstigsten Versandkosten mitteilen.",
            "well_done": "Bravo !",
            "thanks_trust": "Danke für Ihr Vertrauen",
            "parts_reservation": "Bestellung",
            "parts_reservation_description": "",
            "make_offer": "Kaufen",
            "day": "{average_preparation_time} tag",
            "address_2": "Anschrift (Forts.)",
            "activate_stripe_account": "Aktivieren Sie Ihr Stripe-Konto",
            "resume_stripe_activation": "Mit der Aktivierung meines Kontos fortfahren",
            "check_stripe_account": "Mein Stripe-Konto anzeigen",
            "stripe_redirection_message": "Sie werden in wenigen Augenblicken weitergeleitet, bitte haben Sie einen Moment Geduld...",
            "stripe_onboarding_success": "Die Anmeldung wurde erfolgreich abgeschlossen, Sie werden nun weitergeleitet",
            "stripe_onboarding_failure": "Die Anmeldung wurde nicht korrekt abgeschlossen, Sie werden weitergeleitet",
            "making_offer_widget_menu_title": "Preis anpassen",
            "shipping_widget_menu_title": "Versandkosten angeben",
            "buyer_not_specified_shipping_address": "Der Käufer hat noch keine Lieferadresse angegeben, fragen Sie ihn zunächst danach.",
            "request_shipping_address": "Lieferadresse anfordern",
            "stripe_account_not_activated": "Um in Kaufangebot zu unterbreiten, müssen Sie zuerst Ihr Verkäuferkonto bei Stripe aktivieren.",
            "shipping_widget_title": "Ich füge die Versandkosten hinzu",
            "already_know_cost": "Die Kosten kenne ich bereits",
            "hand_delivered": "Persönliche Übergabe",
            "product_price": "Preis des Teils",
            "shipping_costs": "Versandkosten",
            "no_shipping_costs": "Keine Versandkosten",
            "shipping_widget_select_label": "Art der Lieferung",
            "shipping_widget_alert": "Achtung: Die derzeit ausgewählte Versandart entspricht nicht der vom Käufer gewünschten Versandart :",
            "total": "Gesamt",
            "do_not_know_cost": "Ich kenne die Kosten nicht",
            "calcul_shipping_cost_instruction": "Wir bieten Ihnen das Vergleichstool Packlink an, um Ihre Versandkosten zu berechnen. Sie können aber auch gleichwertige Lösungen verwenden, die in Ihrem Land angeboten werden.",
            "calculate_cost": "Berechnen",
            "warning": "Vorsicht",
            "shipping_widget_send_proposal_btn": "Mein Angebot senden",
            "making_offer_widget_title": "Mein Angebot ändern",
            "actual_price": "Aktueller Preis",
            "cpf_commission_included": "CPF-Provision inbegriffen",
            "cpf_commission_explanation_cost": "Eine Provision von {0} dient zur Deckung der Betriebs- und Transaktionskosten. Der Betrag von {1} wird Ihnen zurückerstattet.",
            "if_buyer_accept_offer_condition": "Wenn der Käufer dieses Angebot annimmt, können Sie Ihren Preis nicht mehr ändern und der Verkauf wird durchgeführt.",
            "making_offer_widget_next_step_btn": "Nächster Schritt",
            "add_my_shipping_address": "Meine Lieferadresse",
            "confirm_shipping_address": "Kaufanfrage",
            "confirm_my_address": "Lieferadresse bestätigen",
            "confirm_shipping_address_explanation": "Für eine Lieferung bestätigen Sie bitte Ihre Adresse, damit der Verkäufer die Versandkosten berechnen kann (zunächst werden ihm nur die Postleitzahl und der Ort mitgeteilt).",
            "change_shipping_address": "Lieferadresse ändern",
            "hand_delivery_only": "Nur persönliche Übergabe",
            "hand_delivery_only_explanation": "Bitte besprechen Sie die Details vor Ihrem Kauf mit dem Verkäufer.",
            "understood": "Ich habe verstanden",
            "seller_message_template_7": "Dem Käufer wurde eine Benachrichtigung zugesandt, um seine Lieferadresse zu bestätigen.",
            "buyer_message_template_7": "Hallo,\nUm die Gesamtkosten der Transaktion abzuschätzen, muss der Verkäufer die Versandkosten schätzen. Bitte bestätigen Sie Ihre Lieferadresse",
            "buyer_action_template_7": "Bestätigen Sie Ihre Lieferadresse",
            "admin_message_template_7": "Dem Käufer wurde eine Benachrichtigung zur Bestätigung seiner Lieferadresse gesendet.",
            "seller_message_template_8": "Perfekt! Ihr Kontakt hat seine Lieferadresse bestätigt: {0} Die vollständige Adresse wird Ihnen nach Abschluss der Transaktion übermittelt.",
            "seller_action_template_8": "Versandkosten angeben",
            "buyer_message_template_8": "Der Verkäufer wird nun die Versandkosten für diese Adresse berechnen: {0}",
            "admin_message_template_8": "Der Käufer hat die Lieferadresse bestätigt: {0}",
            "seller_message_template_9": "Ihr Gesprächspartner wird über Ihr neues Angebot informiert: {0} {1} {2} \n Abzüglich der Provisionskosten wird Ihnen die Summe von {3} ausgezahlt. \n Der Vorschlag wurde verlesen: {4}",
            "buyer_message_template_9": "Mein neuer Vorschlag ist da! Ich schlage vor, den Verkaufspreis anzupassen: {0} \n {1} {2} {3}",
            "buyer_action_template_9": "Jetzt kaufen",
            "admin_message_template_9": "Hier ist neues Angebot des Verkäufers: {0} {1} {2}",
            "seller_message_template_10": "Eine Benachrichtigung wurde an Ihren Gesprächspartner gesendet: {0} {1} {2} \n Abzüglich der Provisionskosten wird Ihnen die Summe von {3} ausgezahlt.\n\nWenn Sie es für nötig halten, können Sie ihm eine kurze persönliche Nachricht schicken. Wenn Sie nach 48 Stunden keine Nachricht erhalten haben, empfehlen wir Ihnen, dem Käufer eine persönliche Nachricht zu senden.",
            "buyer_message_template_10": "Ihr Angebot beläuft sich auf: {0} {1} {2}",
            "buyer_action_template_10": "Jetzt kaufen",
            "admin_message_template_10": "Hier ist das Angebot des Verkäufers: {0} {1} {2}",
            "seller_message_template_11": "Gute Nachrichten, {0} möchte Ihr Teil {1} zum angegebenen Preis von Ihnen kaufen. \nBitte berechnen Sie die Versandkosten für die Lieferung an die Adresse: {2} Die vollständige Adresse wird Ihnen nach Abschluss der Transaktion übermittelt.",
            "seller_action_template_11": "Versandkosten angeben",
            "buyer_message_template_11": "Sie werden per E-mail benachrichtigt, sobald der Verkäufer die Versandkosten für diese Adresse berechnet hat: {0}  Zögern Sie nicht, eine Nachricht zu schicken, wenn Sie besondere Anforderungen haben.",
            "admin_message_template_11": "Aufforderung an den Verkäufer, die Lieferkosten an diese Adresse zu berechnen: {0}",
            "seller_message_template_12": "Bravo! \n{0} hat gerade Ihr Teil zum Preis von {1} gekauft. Abzüglich der Provisionskosten wird Ihnen die Summe von {2} ausgezahlt. Es ist Zeit für Sie, Ihr Teil über den von Ihnen gewählten Spediteur an die folgende Adresse zu senden: {3}",
            "seller_hand_delivery_message_template_12": "Bravo ! \n{0} hat gerade Ihr Teil zum Preis von {1} gekauft. Es ist Zeit für Sie, einen Termin zu vereinbaren, um das Teil abzuholen.",
            "check_list_step_1_message_template_12": "Transaktion bestätigt",
            "check_list_step_2_message_template_12": "Bestätigen Sie den Versand des Pakets.",
            "check_list_step_3_message_template_12": "Freigabe des Geldes",
            "check_list_step_2_description_message_template_12": "Sie haben maximal 72 Stunden Zeit, um das Paket zu versenden (bitte benachrichtigen Sie ihn ansonsten so schnell wie möglich).",
            "check_list_step_2_button_message_template_12": "Versand bestätigen",
            "buyer_message_template_12": "Danke! \nWir haben den Verkäufer soeben über Ihren Kauf informiert. Sofern Sie nichts anderes vereinbart haben, hat der Verkäufer maximal 72 Stunden Zeit, um den Artikel an Sie zu versenden.",
            "buyer_hand_delivery_message_template_12": "Danke! \nWir haben den Verkäufer soeben über Ihren Kauf informiert. Bitte setzen Sie sich mit ihm in Verbindung, um einen Termin für die Abholung zu vereinbaren.",
            "admin_message_template_12": "Der Kauf wurde von {0} für insgesamt {1} bestätigt.",
            "seller_message_template_13": "👋 Jemand interessiert sich für Ihr Teil!\n\nFalls gewünscht, können Sie die Schaltfläche unten rechts nutzen, wenn Sie den Preis oder Versandkosten während der Kommunikation mit dem Käufer anpassen möchten.\n\nBeachten Sie bitte, dass Ihre Kommunikation mit dem Käufer einer Moderation unterliegt und der Austausch von Kontaktdaten untersagt ist. Bei Rückfragen erreichen Sie uns unter <a class='basic-link' href='mailto:info@classic-parts-finder.com'>info@classic-parts-finder.com<\/a>\n\nDas Team von Classic Parts Finder 🚗✨",
            "buyer_message_template_13": "👋 Willkommen in Ihrem Nachrichten- und Kaufbereich!\n\nBeachten Sie bitte, dass Ihre Kommunikation mit dem Verkäufer moderiert wird und der Austausch von Kontaktdaten untersagt ist. So sichern wir die Qualität der Transaktion, die Finanzierung der Plattform und unseren Beistand im Streitfall.\n\nBei Rückfragen erreichen Sie uns unter <a class='basic-link' href='mailto:info@classic-parts-finder.com'>info@classic-parts-finder.com<\/a>\n\nDas Team von Classic Parts Finder 🚗✨",
            "admin_message_template_13": "Chat-Regeln",
            "admin_name_template_13": "",
            "if_wish_change_shipping_address_instructions": "Wenn Sie Ihre Lieferadresse ändern möchten, benachrichtigen Sie bitte den Verkäufer, der die Lieferkosten anhand Ihrer neuen Adresse neu berechnen wird.",
            "payment_title": "Sichere Zahlung",
            "buyer_payment_more_informations": "Seien Sie versichert, dass Ihr Geld während der gesamten Transaktion sicher ist. Sie haben nach Erhalt 48 Stunden Zeit, um ein Problem zu melden.",
            "stripe_error_code": "Fehlercode",
            "stripe_redirect_error_code": "Bei der Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
            "buy_with_stripe": "Zahlen via",
            "payment_in_progress": "Zahlung läuft",
            "offer_no_longer_available": "Das Angebot ist nicht mehr verfügbar...",
            "card_holder_name": "Name des Karteninhabers",
            "stripe_create_acount_explanation": "Wenn Sie Probleme bei der Einrichtung Ihres Verkäuferkontos über Stripe haben, wenden Sie sich bitte per E-Mail an einen Administrator unter info@classic-parts-finder.com.",
            "stripe_account": "Stripe-Konto",
            "stripe_find_out_more": "Mehr über Stripe",
            "see_product": "Ansehen",
            "contact_administrator": "Administrator kontaktieren",
            "verified_identity": "Geprüfte Identität",
            "order_validation": "Überprüfung Ihre Bestellung",
            "contact_details": "Kontaktdaten",
            "order_summary": "Zusammenfassung Ihrer Bestellung",
            "displayed_selling_price": "Angezeigter Preis",
            "cpf_commission_included_price": "CPF-Provision {0} inbegriffen",
            "for": "für",
            "phone_number_required_for_delivery": "Telefonnummer für die Sendungsverfolgung erforderlich.",
            "message_price_proposal_buyer_is_ue_and_seller_not_ue": "Dieses Teil befindet sich in einem Land außerhalb der Europäischen Union. Bei der Lieferung könnten Zollgebühren anfallen.",
            "message_price_proposal_buyer_not_ue": "Dieses Teil befindet sich in einem anderen Land als Ihrem. Bei der Lieferung könnten Zollgebühren anfallen.",
            "whats_prefered_shipping_mode": "Gewünschte Lieferart?",
            "no_preference": "Egal",
            "home_delivery": "Lieferung nach Hause",
            "relay_point_delivery": "Paketshop",
            "by_hand_delivery": "Persönlich übergeben",
            "by_hand_delivery_alert": "Bitte setzen Sie sich mit dem Verkäufer in Verbindung, um einen Ort und eine Uhrzeit für den Umtausch zu vereinbaren.",
            "by_hand_delivery_button": "Ich kontaktiere den Verkäufer",
            "relay_point_delivery_alert": "Der Verkäufer wird aufgefordert, einen Paketshop in der Nähe Ihrer Lieferadresse auszuwählen.",
            "relay_point_delivery_seller_alert": "Wenn der Käufer keine Angabe macht, wählen Sie bitte einen Paketshop in der Nähe der Lieferadresse (Wohnort).",
            "buyer_prefered_shipping_mode": "Gewünschte Lieferart:",
            "buyer_action_decline_offer": "Kaufangebot ablehnen",
            "seller_message_template_14": "Das Kaufangebot wurde aus folgendem Grund abgelehnt:",
            "buyer_message_template_14": "Sie haben das Kaufangebot aus folgendem Grund abgelehnt:",
            "admin_message_template_14": "Das Kaufangebot wurde aus folgendem Grund abgelehnt:",
            "decline_offer_modal_title": "Ablehnen",
            "decline_offer_modal_select_label": "Grund für Ihre Ablehnung",
            "decline_offer_default_select_option": "Grund auswählen",
            "too_high_select_option": "Versandkosten zu hoch",
            "found_another_part_select_option": "Ich habe das Teil bereits gefunden",
            "decline_offer_modal_other_reason_label": "Bitte geben Sie an, warum Sie das Kaufangebot ablehnen",
            "decline_offer_modal_btn_decline": "Ich lehne das Kaufangebot ab",
            "confirm_shipping_widget_menu_title": "Den Versand bestätigen",
            "confirm_shipping_widget_title": "Den Versand bestätigen",
            "confirm_shipping_widget_send_btn": "Bestätigen Sie den Versand",
            "confirm_shipping_carrier_label_name": "Name des Spediteurs",
            "confirm_shipping_carrier_select_placeholder": "Aus der Liste auswählen",
            "confirm_shipping_carrier_select_other": "Sonstiges ...",
            "confirm_shipping_parcel_tracking": "Tracking-Nummer",
            "confirm_shipping_tracking_url_label": "Vollständige URL für die Nachverfolgung",
            "seller_action_template_15": "Bestellung verfolgen",
            "buyer_action_template_15": "Meine Bestellung verfolgen",
            "admin_action_template_15": "Bestellung verfolgen",
            "seller_message_title_template_15": "Bestellung versendet",
            "buyer_message_title_template_15": "Ihre Bestellung ist unterwegs!",
            "admin_message_title_template_15": "Die Bestellung wurde versendet.",
            "seller_message_template_15": "Sie haben den Versand Ihrer Bestellung bestätigt. Sie können Ihr Paket auf der Website des Spediteurs verfolgen.",
            "buyer_message_template_15": "Der Versender hat den Versand Ihrer Bestellung bestätigt. Sie können Ihr Paket auf der Website des Spediteurs verfolgen.",
            "admin_message_template_15": "Der Absender hat den Versand der Bestellung bestätigt.",
            "complementary_info_second_title": "Referenzen und Illustrationen",
            "complementary_info_second_title_description": "Bitte füllen Sie mindestens eines der beiden folgenden Felder aus",
            "buyer_message_to_tell_choice_to_seller": "Wenn Ihnen dieses Angebot nicht zusagt, lehnen Sie es bitte ab!",
            "address_confirmation_already_sent_to_seller": "Sie haben Ihre Adresse bereits bestätigt. Bitte warten Sie auf die Antwort des Verkäufers.",
            "address_confirmation_limit_reached": "Sie haben die Grenze für die Adressbestätigung erreicht.",
            "loading_products": "Laden...",
            "typologie_de_la_produit_2": "Art",
            "scroll_to_top": "Nach oben blättern",
            "translate_in": "Übersetzen in",
            "view_translation_message": "Übersetzung ansehen",
            "view_original_message": "Siehe das Original",
            "translate_is_processing": "Übersetzung wird verarbeitet",
            "your_interlocutor_speaks": "Ihr Gesprächspartner spricht",
            "your_messages_can_be_automatically_translated": "(falls erforderlich, Ihre Nachrichten können automatisch übersetzt werden).",
            "seller_offer": "Angebot des Verkäufers",
            "vehicle_not_found_info": "Haben Sie den Namen Ihres Fahrzeugs vor der Marke eingegeben? (Die Angabe der Version ist nicht erforderlich.) Andernfalls versuchen Sie es bitte erneut, indem Sie auf die Schaltfläche „Abbrechen” klicken.",
            "edit_research": "Suche ändern",
            "ask_the_community": "Fragen Sie die Community",
            "we_forward_your_request_to_members": "Fragen Sie die Classic Parts Finder-Community!",
            "check_stock_first": "Zuerst den Lagerbestand prüfen",
            "1_piece_currently_available": "1 Teil derzeit verfügbar",
            "parts_currently_available": "Teile derzeit verfügbar",
            "what_do_you_want_to_do_now": "Was möchtest du jetzt tun?",
            "advanced_search_button": "Erweiterte Suche",
            "search_product_list": "Teile verfügbar",
            "unsubscribed_email_vehicle_notification_message": "Die Benachrichtigung wurde erfolgreich deaktiviert. Sie können sie jederzeit in den Detailinformationen zu Ihrem Fahrzeug wieder aktivieren.",
            "user_left_without_purchase": "{0} verlässt die Unterhaltung, der Verkauf wird an dieser Stelle abgeschlossen", // TODO: remove with the good message
            "seller_message_template_17": `Ihre Nachricht konnte nicht gesendet werden, da private Kontaktdaten angegeben wurden. Dies verstößt gegen unsere Allgemeinen Geschäftsbedingungen. Bitte versuchen Sie es erneut. \n Nachricht: {0}`,
            "reading_new_price_9": "Der Vorschlag wurde verlesen: {0}",
            "copy_info": "Informationen kopieren",
            "info_copied": "Kopiert!",
            "select_shipping_mode": "-- Versandart auswählen --",
            "seller_action_item_paid_title": "Bestellung vom Käufer bezahlt!",
            "seller_action_item_paid_desc": "Denken Sie daran, den Versand zu bestätigen und die Sendungsnummer hinzuzufügen, sobald der Artikel versendet wurde.",
            "seller_action_item_paid_warning": "Achtung: Sie sind für die ordnungsgemäße Zustellung Ihres Pakets verantwortlich. Stellen Sie sicher, dass Ihr Paket im Falle von Verlust oder Beschädigung ausreichend versichert ist.",
            "oldPrice": "Alter Preis",
            "seller_action_item_paid_warning_ship": "Wenn Sie nicht innerhalb von 72 Stunden versenden können, informieren Sie bitte Ihren Käufer",
            "add_to_ad": "Anzeige hinzufügen",
        }
    },
    "sl": {
        "name": "Slug",
        "messages": {
            "book_fast": "book_fast",
            "important": "important",
            "payment_book_1": "payment_book_1",
            "payment_book_2": "payment_book_2",
            "book_tarif_1": "book_tarif_1",
            "book_tarif_2": "book_tarif_2",
            "pay": "pay",
            "secure_purchase": "secure_purchase",
            "parts_available_button": "parts_available_button",
            "parts_notification_message": "parts_notification_message",
            "available_parts": "available_parts",
            "registration": "registration",
            "login_failed": "login_failed",
            "back": "back",
            "choose_country": "choose_country",
            "max_images": "max_images",
            "email": "email",
            "accept_cgu": "accept_cgu",
            "negociable": "negociable",
            "select_default_lang": "select_default_lang",
            "non_negociable": "non_negociable",
            "moderation_message": "moderation_message",
            "voir_changements": "voir_changements",
            "masquer_changements": "masquer_changements",
            "refus_changement": "refus_changement",
            "accept_changement": "accept_changement",
            "ad_modifications": "ad_modifications",
            "research_modifications": "research_modifications",
            "cgu": "cgu",
            "privacy": "privacy",
            "finish": "finish",
            "email_already_used": "email_already_used",
            "registering_error": "registering_error",
            "field_required": "field_required",
            "field_email": "field_email",
            "field_email_used": "field_email_used",
            "registering_email_sent": "registering_email_sent",
            "check_spams": "check_spams",
            "back_login": "back_login",
            "forgot_your_password": "forgot_your_password",
            "reset_send_email": "reset_send_email",
            "inexistant_email": "inexistant_email",
            "validate": "validate",
            "reset_email_sent": "reset_email_sent",
            "update_your_password": "update_your_password",
            "set_new_password": "set_new_password",
            "at_least_x_char": "at_least_x_char",
            "password_must_be_identical": "password_must_be_identical",
            "modify": "modify",
            "password_updated": "password_updated",
            "your_password_updated": "your_password_updated",
            "login": "login",
            "expired_link": "expired_link",
            "research_expired_status": "research_expired_status",
            "confirm_new_passwd": "confirm_new_passwd",
            "log_in": "log_in",
            "log_in_error": "log_in_error",
            "email_address": "email_address",
            "password": "password",
            "connection": "connection",
            "not_registered_yet": "not_registered_yet",
            "i_research": "i_research",
            "i_sell": "i_sell",
            "log_out": "log_out",
            "my_dashboard": "my_dashboard",
            "last_step": "last_step",
            "complementary_details_required": "complementary_details_required",
            "first_name": "first_name",
            "field_alpha": "field_alpha",
            "last_name": "last_name",
            "country": "country",
            "phone_number": "phone_number",
            "confirm_new_password": "confirm_new_password",
            "information_editable_dashboard": "information_editable_dashboard",
            "complete_registering": "complete_registering",
            "account_activated": "account_activated",
            "connect_to_dashboard": "connect_to_dashboard",
            "log_in_dashboard": "log_in_dashboard",
            "criteria_explanation": "criteria_explanation",
            "factory_oem": "factory_oem",
            "strict_origin_factory": "strict_origin_factory",
            "remade_oem": "remade_oem",
            "strict_origin_remade": "strict_origin_remade",
            "old_fixed": "old_fixed",
            "strict_origin_fixed": "strict_origin_fixed",
            "remplacement_part": "remplacement_part",
            "quality_replacement": "quality_replacement",
            "criteria_responsibility": "criteria_responsibility",
            "our_advice": "our_advice",
            "avoid_issue_defaults": "avoid_issue_defaults",
            "brand_new": "brand_new",
            "never_used": "never_used",
            "very_good": "very_good",
            "almost_never_used": "almost_never_used",
            "good": "good",
            "few_imperfections": "few_imperfections",
            "satisfying": "satisfying",
            "needs_cleaning": "needs_cleaning",
            "renovate": "renovate",
            "to_renovate_fix": "to_renovate_fix",
            "other_question": "other_question",
            "enter_your_question": "enter_your_question",
            "send": "send",
            "cancel": "cancel",
            "message_waiting_validation": "message_waiting_validation",
            "more_picture_product": "more_picture_product",
            "where_product_from": "where_product_from",
            "thanks_for_comment": "thanks_for_comment",
            "add": "add",
            "research": "research",
            "vehicle": "vehicle",
            "simplified_announce": "simplified_announce",
            "product": "product",
            "parameters": "parameters",
            "my_researches": "my_researches",
            "my_vehicles": "my_vehicles",
            "my_simplified_announces": "my_simplified_announces",
            "my_products": "my_products",
            "email_modification": "email_modification",
            "to_change_email_dashboard": "to_change_email_dashboard",
            "log_myself": "log_myself",
            "success_email_change": "success_email_change",
            "other": "other",
            "vendor_parameters": "vendor_parameters",
            "sell_parts": "sell_parts",
            "diffuse_products": "diffuse_products",
            "activate_vendor": "activate_vendor",
            "all_modifications_taken": "all_modifications_taken",
            "error_happened_wrong_param": "error_happened_wrong_param",
            "business_name": "business_name",
            "business_address": "business_address",
            "zip_code": "zip_code",
            "city": "city",
            "region": "region",
            "Numéro d'identification de votre entreprise (14 chiffres du Siret pour la France)": "Numéro d'identification de votre entreprise (14 chiffres du Siret pour la France)",
            "save_changes": "save_changes",
            "account_info_linked_business": "account_info_linked_business",
            "become_pro": "become_pro",
            "password_security": "password_security",
            "actual_password": "actual_password",
            "new_password": "new_password",
            "confirm_your_new_password": "confirm_your_new_password",
            "account_removal": "account_removal",
            "remove_my_account": "remove_my_account",
            "action_will_disconnect": "action_will_disconnect",
            "confirm_account_removal": "confirm_account_removal",
            "personal_details": "personal_details",
            "sell_parts_cpf": "sell_parts_cpf",
            "publish_products_fast": "publish_products_fast",
            "activate_seller_account": "activate_seller_account",
            "email_changing_to": "email_changing_to",
            "address": "address",
            "spoken_langage": "spoken_langage",
            "my_account": "my_account",
            "email_already_used_log": "email_already_used_log",
            "cannot_register": "cannot_register",
            "nearly_there_login": "nearly_there_login",
            "nearly_there_register": "nearly_there_register",
            "already_have_account": "already_have_account",
            "email_sent_confirm_research": "email_sent_confirm_research",
            "select_from_own": "select_from_own",
            "find_new_vehicle": "find_new_vehicle",
            "what_is_vehicle": "what_is_vehicle",
            "brand_modele_etc": "brand_modele_etc",
            "cant_find_vehicle": "cant_find_vehicle",
            "vehicle_not_found": "vehicle_not_found",
            "your_vehicle_not_found": "your_vehicle_not_found",
            "keep_track_demand": "keep_track_demand",
            "required_informations": "required_informations",
            "thanks_demand": "thanks_demand",
            "email_contact_back": "email_contact_back",
            "next_step": "next_step",
            "your_email": "your_email",
            "add_vehicle": "add_vehicle",
            "previous_step": "previous_step",
            "which_part_looking_for": "which_part_looking_for",
            "part_name_etc": "part_name_etc",
            "loading": "loading",
            "which_kind_of_part": "which_kind_of_part",
            "complementary_info": "complementary_info",
            "lets_gain_time": "lets_gain_time",
            "year_vehicle": "year_vehicle",
            "select_year": "select_year",
            "vehicle_version": "vehicle_version",
            "motor_paint_etc": "motor_paint_etc",
            "part_precisions": "part_precisions",
            "looking_version_part": "looking_version_part",
            "part_is_compatible": "part_is_compatible",
            "kind_of_part": "kind_of_part",
            "part_type_guide": "part_type_guide",
            "part_reference": "part_reference",
            "reference_id_etc": "reference_id_etc",
            "maximize_add_photos": "maximize_add_photos",
            "maximum_photos": "maximum_photos",
            "drop_files_here": "drop_files_here",
            "or_if_prefer": "or_if_prefer",
            "select_files": "select_files",
            "remove": "remove",
            "sending_progress": "sending_progress",
            "your_research": "your_research",
            "brand_modele": "brand_modele",
            "part_category": "part_category",
            "part_research": "part_research",
            "vendor_account_ready": "vendor_account_ready",
            "account_secured_obvy": "account_secured_obvy",
            "and_now": "and_now",
            "can_sell_products": "can_sell_products",
            "accept_paiements": "accept_paiements",
            "sell_with_obvy": "sell_with_obvy",
            "secure_my_account": "secure_my_account",
            "go_further": "go_further",
            "tell_part_category": "tell_part_category",
            "create_simplified_announce": "create_simplified_announce",
            "add_product": "add_product",
            "create_first_product": "create_first_product",
            "complete_later": "complete_later",
            "all_rights": "all_rights",
            "new_simplified_announce": "new_simplified_announce",
            "receive_mail_research": "receive_mail_research",
            "vehicles_compatible": "vehicles_compatible",
            "vehicles_with_alert": "vehicles_with_alert",
            "brand_modeles_etc": "brand_modeles_etc",
            "answer_by_mail": "answer_by_mail",
            "part_not_found": "part_not_found",
            "your_unknown_part": "your_unknown_part",
            "name_part": "name_part",
            "unknown_part_mail": "unknown_part_mail",
            "part_categories": "part_categories",
            "multiple_choices": "multiple_choices",
            "category_all_parts": "category_all_parts",
            "cant_find_part_list": "cant_find_part_list",
            "activate_announce": "activate_announce",
            "french_german": "french_german",
            "version_non_renseigne": "version_non_renseigne",
            "new_research": "new_research",
            "see_vehicle": "see_vehicle",
            "find_by_brand_year_etc": "find_by_brand_year_etc",
            "grid_display": "grid_display",
            "line_display": "line_display",
            "table_display": "table_display",
            "confirm_vehicle_removal": "confirm_vehicle_removal",
            "all_research_removal": "all_research_removal",
            "do_not_remove": "do_not_remove",
            "searching_x_products": "searching_x_products",
            "no_research_currently": "no_research_currently",
            "no_vehicles": "no_vehicles",
            "non_renseign": "non_renseign",
            "produit_suggr": "produit_suggr",
            "vehicle_details": "vehicle_details",
            "version": "version",
            "add_version": "add_version",
            "year": "year",
            "associated_researches": "associated_researches",
            "see_x_findings": "see_x_findings",
            "see_my_finding": "see_my_finding",
            "research_awaiting_validation": "research_awaiting_validation",
            "experts_are_looking": "experts_are_looking",
            "vehicle_parameters": "vehicle_parameters",
            "new_vehicle": "new_vehicle",
            "name_too_short": "name_too_short",
            "name_too_long": "name_too_long",
            "update": "update",
            "what_is_your_vehicle": "what_is_your_vehicle",
            "select_vehicle_first": "select_vehicle_first",
            "engine_bodywork_etc": "engine_bodywork_etc",
            "states_guide": "states_guide",
            "administration": "administration",
            "inbox": "inbox",
            "pice_suggre": "pice_suggre",
            "my_last_researches": "my_last_researches",
            "no_researches_for_now": "no_researches_for_now",
            "all_my_researches": "all_my_researches",
            "no_research_made": "no_research_made",
            "my_last_simplified_announces": "my_last_simplified_announces",
            "no_simplified_announces_currently": "no_simplified_announces_currently",
            "all_my_simplified_announces": "all_my_simplified_announces",
            "didnt_config_seller_space": "didnt_config_seller_space",
            "configure": "configure",
            "new_part_for_your": "new_part_for_your",
            "we_look_for_you": "we_look_for_you",
            "notifications": "notifications",
            "all": "all",
            "no_unread_notifications": "no_unread_notifications",
            "someone_research_your_part": "someone_research_your_part",
            "you_created_simplified_announce": "you_created_simplified_announce",
            "we_found_product_for_you": "we_found_product_for_you",
            "you_created_research": "you_created_research",
            "part_attributed_to_research": "part_attributed_to_research",
            "part_attributed_to_product": "part_attributed_to_product",
            "date": "date",
            "part": "part",
            "see_simplified_announce": "see_simplified_announce",
            "details": "details",
            "no_notification": "no_notification",
            "welcome_aboard": "welcome_aboard",
            "conversations": "conversations",
            "buying_product": "buying_product",
            "selling_product": "selling_product",
            "no_new_message": "no_new_message",
            "vous": "vous",
            "sent_at": "sent_at",
            "message_sent_for_validation": "message_sent_for_validation",
            "moderation_in_progress": "moderation_in_progress",
            "sent": "sent",
            "read": "read",
            "new_message": "new_message",
            "from": "from",
            "refused": "refused",
            "actual_message_to_moderate": "actual_message_to_moderate",
            "missing_info_profil": "missing_info_profil",
            "required_info_to_continue": "required_info_to_continue",
            "save_informations": "save_informations",
            "my_orders": "my_orders",
            "reference": "reference",
            "amount": "amount",
            "status": "status",
            "option": "option",
            "options": "options",
            "allow_sale": "allow_sale",
            "refuse_sale": "refuse_sale",
            "paiement_accept": "paiement_accept",
            "order_sent": "order_sent",
            "confirm_reception": "confirm_reception",
            "do_reclamation": "do_reclamation",
            "reimburse_partiel": "reimburse_partiel",
            "reimburse_total": "reimburse_total",
            "no_order": "no_order",
            "how_does_it_work": "how_does_it_work",
            "advantages": "advantages",
            "dashboard": "dashboard",
            "selling_easy": "selling_easy",
            "create_market_fast": "create_market_fast",
            "i_am_pro": "i_am_pro",
            "i_am_individual": "i_am_individual",
            "receive_alert_research": "receive_alert_research",
            "simplified_announce_explained": "simplified_announce_explained",
            "publish_products_fast_easy": "publish_products_fast_easy",
            "publish_large_catalog": "publish_large_catalog",
            "ready_to_sell": "ready_to_sell",
            "register_fast": "register_fast",
            "free_service_part": "free_service_part",
            "menu": "menu",
            "take_my_research": "take_my_research",
            "facebook_link": "facebook_link",
            "instagram_link": "instagram_link",
            "privacy_policies": "privacy_policies",
            "cgu_full": "cgu_full",
            "legals_info": "legals_info",
            "suivant": "suivant",
            "valeurs_alphabtiques_uniquement": "valeurs_alphabtiques_uniquement",
            "doit_tre_compos_de_14_chiffres": "doit_tre_compos_de_14_chiffres",
            "valeur_numrique_uniquement": "valeur_numrique_uniquement",
            "n_de_siret": "n_de_siret",
            "adresse_de_lentreprise": "adresse_de_lentreprise",
            "pays_de_lentreprise": "pays_de_lentreprise",
            "nom_de_lentreprise": "nom_de_lentreprise",
            "au_moins_2_caractres": "au_moins_2_caractres",
            "votre_nom": "votre_nom",
            "votre_prnom": "votre_prnom",
            "part_found": "part_found",
            "recherche_termine": "recherche_termine",
            "la_recherche_a_t_archive": "la_recherche_a_t_archive",
            "nos_experts_sont_en_cours_de_recherche": "nos_experts_sont_en_cours_de_recherche",
            "faire_une_nouvelle_recherche": "faire_une_nouvelle_recherche",
            "vous_souhaitez_acheter_des_pices_pour_votre_ancien": "vous_souhaitez_acheter_des_pices_pour_votre_ancien",
            "aucune_recherche": "aucune_recherche",
            "pas_de_recherche": "pas_de_recherche",
            "product_found": "product_found",
            "dtails_de_la_recherche": "dtails_de_la_recherche",
            "suggested_product": "suggested_product",
            "rechercher_par_modle_marque_produit_recherch": "rechercher_par_modle_marque_produit_recherch",
            "nous_sommes_dsols_nous_ne_sommes_pas_en_mesure_de": "nous_sommes_dsols_nous_ne_sommes_pas_en_mesure_de",
            "recherches_avec_produits_trouvs": "recherches_avec_produits_trouvs",
            "afin_damliorer_la_qualit_de_nos_suggestions_pourri": "afin_damliorer_la_qualit_de_nos_suggestions_pourri",
            "je_cherche_une_pice_en_meilleur_tat_le_prix_est_tr": "je_cherche_une_pice_en_meilleur_tat_le_prix_est_tr",
            "nous_envoyer_une_suggestion": "nous_envoyer_une_suggestion",
            "quelle_est_votre_question_pour_ce_vendeur": "quelle_est_votre_question_pour_ce_vendeur",
            "en_savoir_plus_sur_obvy": "en_savoir_plus_sur_obvy",
            "achat_scuris_avec": "achat_scuris_avec",
            "trop_tard_ce_produit_nest_plus_disponible": "trop_tard_ce_produit_nest_plus_disponible",
            "en_savoir_plus": "en_savoir_plus",
            "grce_la_garantie_cpf": "grce_la_garantie_cpf",
            "achetez_en_toute_srnit": "achetez_en_toute_srnit",
            "frais_de_port_en_sus_calculer_selon_le_mode_de_liv": "frais_de_port_en_sus_calculer_selon_le_mode_de_liv",
            "colis_remis_au_transporteur_sous_jours": "colis_remis_au_transporteur_sous_jours",
            "expdition": "expdition",
            "hors_frais_de_ports": "hors_frais_de_ports",
            "prix": "prix",
            "dimensions_du_produit": "dimensions_du_produit",
            "poids_du_produit": "poids_du_produit",
            "jours": "jours",
            "temps_moyen_de_prparation": "temps_moyen_de_prparation",
            "contacter_le_vendeur": "contacter_le_vendeur",
            "vendu_directement_par_cpf": "vendu_directement_par_cpf",
            "seller": "seller",
            "a_propos_du_vendeur": "a_propos_du_vendeur",
            "fabricant": "fabricant",
            "rfrence_du_produit": "rfrence_du_produit",
            "description": "description",
            "state": "state",
            "facebook": "facebook",
            "copier_le_lien": "copier_le_lien",
            "partager_le_produit": "partager_le_produit",
            "trouvailles_par_page": "trouvailles_par_page",
            "ce_formulaire": "ce_formulaire",
            "vous_pouvez_nous_faire_votre_demande_via": "vous_pouvez_nous_faire_votre_demande_via",
            "assistance_en_cas_de_litige": "assistance_en_cas_de_litige",
            "larticle_doit_tre_retourn_dans_son_tat_dorigine_et": "larticle_doit_tre_retourn_dans_son_tat_dorigine_et",
            "si_achat_auprs_dun_professionnel": "si_achat_auprs_dun_professionnel",
            "droit_de_rtractation_de_14_jours": "droit_de_rtractation_de_14_jours",
            "garantie_lgale_des_vices_cachs": "garantie_lgale_des_vices_cachs",
            "garantie_lgale_de_conformit_du_bien": "garantie_lgale_de_conformit_du_bien",
            "remboursement_total_ou_partiel_en_cas_de_perte_ou": "remboursement_total_ou_partiel_en_cas_de_perte_ou",
            "suivi_de_livraison_si_choix_via_mondial_relay_ou_c": "suivi_de_livraison_si_choix_via_mondial_relay_ou_c",
            "tarifs_de_livraison_ngocis_mondial_relay_et_chrono": "tarifs_de_livraison_ngocis_mondial_relay_et_chrono",
            "scurisation_des_fonds_protection_de_lacheteur_et_d": "scurisation_des_fonds_protection_de_lacheteur_et_d",
            "garantie_de_paiement_sur_compte_squestre": "garantie_de_paiement_sur_compte_squestre",
            "garantie_de_transaction_scurise": "garantie_de_transaction_scurise",
            "paiement_par_carte_ou_par_virement": "paiement_par_carte_ou_par_virement",
            "garantie_classic_parts_finder": "garantie_classic_parts_finder",
            "la_recherche_nest_pas_disponible": "la_recherche_nest_pas_disponible",
            "donnez_nous_plus_de_dtails_sur_le_produit_que_vous": "donnez_nous_plus_de_dtails_sur_le_produit_que_vous",
            "je_cherche_des_produits_neufs_les_prix_sont_trop_l": "je_cherche_des_produits_neufs_les_prix_sont_trop_l",
            "pas_encore_de_trouvailles": "pas_encore_de_trouvailles",
            "dgivrer_loffre": "dgivrer_loffre",
            "vous_avez_chang_davis": "vous_avez_chang_davis",
            "offre_refuse": "offre_refuse",
            "consulter_loffre": "consulter_loffre",
            "la_recherche_est_en_attente_de_validation": "la_recherche_est_en_attente_de_validation",
            "research_continues": "research_continues",
            "les_trouvailles": "les_trouvailles",
            "la_recherche_est_termine": "la_recherche_est_termine",
            "date_de_la_recherche": "date_de_la_recherche",
            "rfrence_du_produit2": "rfrence_du_produit2",
            "dtails": "dtails",
            "type_de_produit": "type_de_produit",
            "produit_recherch": "produit_recherch",
            "dtails_de_votre_recherche": "dtails_de_votre_recherche",
            "product_suggested": "product_suggested",
            "pour": "pour",
            "oups": "oups",
            "votre_recherche_est_introuvable_ou_a_dj_t_prolonge": "votre_recherche_est_introuvable_ou_a_dj_t_prolonge",
            "accder_mon_tableau_de_bord": "accder_mon_tableau_de_bord",
            "cest_not": "cest_not",
            "votre_recherche_a_bien_t_prolonge": "votre_recherche_a_bien_t_prolonge",
            "accder_mon_tableau_de_bord2": "accder_mon_tableau_de_bord2",
            "bienvenue": "bienvenue",
            "activer": "activer",
            "dsactiver": "dsactiver",
            "dsactiv": "dsactiv",
            "en_attente_dune_recherche": "en_attente_dune_recherche",
            "voir_les_recherches": "voir_les_recherches",
            "rfrence_de_la_pice": "rfrence_de_la_pice",
            "localisation_de_lacheteur": "localisation_de_lacheteur",
            "date_de_la_recherche2": "date_de_la_recherche2",
            "votre_question_pour_cet_acheteur_potentiel": "votre_question_pour_cet_acheteur_potentiel",
            "proposer_un_produit": "proposer_un_produit",
            "si_vous_avez_besoin_dlments_plus_prcis_en_rapport": "si_vous_avez_besoin_dlments_plus_prcis_en_rapport",
            "contacter_lacheteur_potentiel": "contacter_lacheteur_potentiel",
            "propos_de_lacheteur": "propos_de_lacheteur",
            "compatible_avec": "compatible_avec",
            "crer_mes_annonces_simplifies": "crer_mes_annonces_simplifies",
            "vous_souhaitez_vendre_des_produits_indiqueznous_si": "vous_souhaitez_vendre_des_produits_indiqueznous_si",
            "aucune_annonces_simplifies": "aucune_annonces_simplifies",
            "aucune_annonce_simplifie_ne_correspond_aux_filtres": "aucune_annonce_simplifie_ne_correspond_aux_filtres",
            "supprimer_la_slection": "supprimer_la_slection",
            "annonce_dsactive": "annonce_dsactive",
            "rechercher_par_marque_modle": "rechercher_par_marque_modle",
            "vous_navez_pas_encore_de_vente": "vous_navez_pas_encore_de_vente",
            "commande_livr": "commande_livr",
            "mes_ventes": "mes_ventes",
            "si_malgr_tout_la_vente_na_pas_lieu_vous_navez_pas": "si_malgr_tout_la_vente_na_pas_lieu_vous_navez_pas",
            "le_produit_sera_transmis_lacheteur_aprs_validation": "le_produit_sera_transmis_lacheteur_aprs_validation",
            "confirmation_dajout_du_produit": "confirmation_dajout_du_produit",
            "ajouter_mon_premier_produit": "ajouter_mon_premier_produit",
            "crez_et_diffusez_vos_annonces_sur_classic_parts_fi": "crez_et_diffusez_vos_annonces_sur_classic_parts_fi",
            "aucun_produit": "aucun_produit",
            "supprimer_la_selection": "supprimer_la_selection",
            "aucun_produit_ne_correspond_votre_recherche": "aucun_produit_ne_correspond_votre_recherche",
            "diffuser": "diffuser",
            "votre_produit_sera_diffus_ds_validation_par_un_adm": "votre_produit_sera_diffus_ds_validation_par_un_adm",
            "exporter_vos_produits": "exporter_vos_produits",
            "rechercher_par_type_de_produit_modle": "rechercher_par_type_de_produit_modle",
            "catgorie": "catgorie",
            "lannonce_simplifie_nest_pas_disponible": "lannonce_simplifie_nest_pas_disponible",
            "complter_la_fiche_produit": "complter_la_fiche_produit",
            "vrifier_que_vous_navez_pas_dj_cette_pice_dans_votr": "vrifier_que_vous_navez_pas_dj_cette_pice_dans_votr",
            "de_quelques_informations_complmentaires_sur_votre": "de_quelques_informations_complmentaires_sur_votre",
            "nous_avons_dsormais_besoin": "nous_avons_dsormais_besoin",
            "flicitations": "flicitations",
            "a_propos_de_lacheteur": "a_propos_de_lacheteur",
            "pas_cette_piece": "pas_cette_piece",
            "jai_trait_ce_produit": "jai_trait_ce_produit",
            "en_attente_de_traitement": "en_attente_de_traitement",
            "je_nai_pas_le_produit": "je_nai_pas_le_produit",
            "vous_avez_chang_davis2": "vous_avez_chang_davis2",
            "jai_trait_ce_produit2": "jai_trait_ce_produit2",
            "jai_ce_produit": "jai_ce_produit",
            "vous_avez_le_produit": "vous_avez_le_produit",
            "je_nai_pas_ce_produit2": "je_nai_pas_ce_produit2",
            "acheteur": "acheteur",
            "vos_acheteurs_potentiels": "vos_acheteurs_potentiels",
            "date_de_publication": "date_de_publication",
            "catgorie_cible": "catgorie_cible",
            "pice_cible": "pice_cible",
            "dtails_de_lannonce_simplifie": "dtails_de_lannonce_simplifie",
            "dtails_de_votre_annonce_simplifie": "dtails_de_votre_annonce_simplifie",
            "rsultats_de_mon_annonce": "rsultats_de_mon_annonce",
            "je_nai_pas_trouv_ma_pice": "je_nai_pas_trouv_ma_pice",
            "diffuser_le_produit": "diffuser_le_produit",
            "en_cours_denvoi": "en_cours_denvoi",
            "brouillon": "brouillon",
            "temps_moyen_de_prparation_jours": "temps_moyen_de_prparation_jours",
            "aperu_et_diffusion": "aperu_et_diffusion",
            "les_frais_lis_une_livraison_sont_la_charge_de_lach": "les_frais_lis_une_livraison_sont_la_charge_de_lach",
            "longueur": "longueur",
            "largeur": "largeur",
            "hauteur": "hauteur",
            "remise_en_main_propre_uniquement": "remise_en_main_propre_uniquement",
            "remise_en_main_propre_et_envoi_postal": "remise_en_main_propre_et_envoi_postal",
            "envoi_postal": "envoi_postal",
            "veuillez_slectionner_une_option": "veuillez_slectionner_une_option",
            "mode_de_transport_du_produit": "mode_de_transport_du_produit",
            "dlai_avant_remise_au_transporteur": "dlai_avant_remise_au_transporteur",
            "pensez_lemballage_arrondir_au_dessus": "pensez_lemballage_arrondir_au_dessus",
            "poids_approximatif_du_produit": "poids_approximatif_du_produit",
            "oui": "oui",
            "non": "non",
            "le_prix_estil_ngociable": "le_prix_estil_ngociable",
            "est_destine_couvrir_les_frais_de_recherche_et_de_t": "est_destine_couvrir_les_frais_de_recherche_et_de_t",
            "la_commission_de": "la_commission_de",
            "the_selling_price": "the_selling_price",
            "pour_vous": "pour_vous",
            "indiquez_le_prix_de_vente_hors_livraison_minimum_2": "indiquez_le_prix_de_vente_hors_livraison_minimum_2",
            "prix_de_vente_affich": "prix_de_vente_affich",
            "prix_et_livraison": "prix_et_livraison",
            "dplacer": "dplacer",
            "rotation": "rotation",
            "slectionnez_les_photos": "slectionnez_les_photos",
            "dposez_les_photos_de_votre_produit_ici": "dposez_les_photos_de_votre_produit_ici",
            "maximiser_vos_chances_de_vendre_en_proposant_plusi": "maximiser_vos_chances_de_vendre_en_proposant_plusi",
            "cette_pice_convient_aux_modles_dans_son_emballage": "cette_pice_convient_aux_modles_dans_son_emballage",
            "merci_de_prciser_du_mieux_possible_les_spcificits": "merci_de_prciser_du_mieux_possible_les_spcificits",
            "rfrence_interne_votre_stock_invisible_pour_lachete": "rfrence_interne_votre_stock_invisible_pour_lachete",
            "typologie_de_la_produit": "typologie_de_la_produit",
            "etat_du_produit": "etat_du_produit",
            "quantit_disponible": "quantit_disponible",
            "titre_nom_prcis_du_produit": "titre_nom_prcis_du_produit",
            "informations_gnrales": "informations_gnrales",
            "votre_produit_pourra_tre_diffus_aprs_la_validation": "votre_produit_pourra_tre_diffus_aprs_la_validation",
            "nom_de_votre_produit": "nom_de_votre_produit",
            "vous_ne_trouvez_pas_votre_produit": "vous_ne_trouvez_pas_votre_produit",
            "nom_du_produit": "nom_du_produit",
            "indiquez_le_nom_du_produit": "indiquez_le_nom_du_produit",
            "type_de_produit_catgorie": "type_de_produit_catgorie",
            "ce_produit_est_compatible_pour_les_modles": "ce_produit_est_compatible_pour_les_modles",
            "nouveau_produit": "nouveau_produit",
            "edition_de_produit": "edition_de_produit",
            "recherches_par_page": "recherches_par_page",
            "tous": "tous",
            "prcdent": "prcdent",
            "operational_fees": "operational_fees",
            "selling_price": "selling_price",
            "lments_slectionns": "lments_slectionns",
            "dslectionner_tout": "dslectionner_tout",
            "tous_les_produits_de_la_catgorie": "tous_les_produits_de_la_catgorie",
            "image": "image",
            "marque": "marque",
            "modle": "modle",
            "recherches": "recherches",
            "dition": "dition",
            "sure_supprimer_ces_annonces_simplifies": "sure_supprimer_ces_annonces_simplifies",
            "sure_supprimer_cette_annonce_simplifie": "sure_supprimer_cette_annonce_simplifie",
            "annonces_par_page": "annonces_par_page",
            "titre_de_lannonce": "titre_de_lannonce",
            "filtrer_par_nom": "filtrer_par_nom",
            "filtrer_par_type_de_produit": "filtrer_par_type_de_produit",
            "marque_modle": "marque_modle",
            "filtrer_par_modle": "filtrer_par_modle",
            "rfrence_interne": "rfrence_interne",
            "filtrer_par_rfrence": "filtrer_par_rfrence",
            "stock": "stock",
            "etat": "etat",
            "moderation_diffus": "moderation_diffus",
            "pas_de_modle": "pas_de_modle",
            "pas_de_ref_interne": "pas_de_ref_interne",
            "sure_supprimer_produit": "sure_supprimer_produit",
            "max_photos": "max_photos",
            "the_buyer": "the_buyer",
            "the_seller": "the_seller",
            "sure_supprimer_vehicule": "sure_supprimer_vehicule",
            "sure_supprimer_research": "sure_supprimer_research",
            "action": "action",
            "type": "type",
            "diffus": "diffus",
            "optional": "optional",
            "max_vehicles_in_list": "max_vehicles_in_list",
            "no_product_for_the_moment": "no_product_for_the_moment",
            "espace_recherche": "espace_recherche",
            "espace_vente": "espace_vente",
            "we_may_have_more_products_in_stock_for_this_vehicle": "we_may_have_more_products_in_stock_for_this_vehicle",
            "sur": "sur",
            "next": "next",
            "vehicles_per_page": "vehicles_per_page",
            "page": "page",
            "pro_seller": "pro_seller",
            "private_seller": "private_seller",
            "before_continuing": "before_continuing",
            "not_search_engine_search_service_give_us_search_distribute_entire_classic_parts_finder_community_collectors_garages_breakers_etc": "not_search_engine_search_service_give_us_search_distribute_entire_classic_parts_finder_community_collectors_garages_breakers_etc",
            "prefer_view_parts_already_available_classic_parts_finder_simply_register_enter_vehicle_model": "prefer_view_parts_already_available_classic_parts_finder_simply_register_enter_vehicle_model",
            "register_add_vehicle": "register_add_vehicle",
            "understand": "understand",
            "start_research": "start_research",
            "These credentials do not match our records.": "These credentials do not match our records.",
            "process_request": "process_request",
            "parts_available_2": "parts_available_2",
            "delete_research": "delete_research",
            "bulk_upload_a_file": "bulk_upload_a_file",
            "bulk_column_mapping": "bulk_column_mapping",
            "bulk_import": "bulk_import",
            "bulk_importing_ads_file": "bulk_importing_ads_file",
            "bulk_tool_allows_import_merge_ad_data_shop_excel_csv_file": "bulk_tool_allows_import_merge_ad_data_shop_excel_csv_file",
            "bulk_list_mandatory_fields": "bulk_list_mandatory_fields",
            "bulk_download_info": "bulk_download_info",
            "bulk_vehicle_model": "bulk_vehicle_model",
            "bulk_brand_vehicle": "bulk_brand_vehicle",
            "bulk_name_piece": "bulk_name_piece",
            "bulk_title_ad": "bulk_title_ad",
            "bulk_quantity": "bulk_quantity",
            "bulk_url_image_1": "bulk_url_image_1",
            "bulk_state": "bulk_state",
            "bulk_info": "bulk_info",
            "bulk_type": "bulk_type",
            "bulk_description": "bulk_description",
            "bulk_price": "bulk_price",
            "bulk_approximate_weight_piece": "bulk_approximate_weight_piece",
            "bulk_proposed_mode_transport": "bulk_proposed_mode_transport",
            "bulk_show_optional_fields": "bulk_show_optional_fields",
            "bulk_hide_optional_fields": "bulk_hide_optional_fields",
            "bulk_list_optional_fields": "bulk_list_optional_fields",
            "bulk_internal_reference": "bulk_internal_reference",
            "bulk_year_vehicle": "bulk_year_vehicle",
            "bulk_manufacturer": "bulk_manufacturer",
            "bulk_reference_part": "bulk_reference_part",
            "bulk_price_negotiable": "bulk_price_negotiable",
            "bulk_time_delivery_carrier_days": "bulk_time_delivery_carrier_days",
            "bulk_height": "bulk_height",
            "bulk_width": "bulk_width",
            "bulk_lenght": "bulk_lenght",
            "bulk_url_image_2": "bulk_url_image_2",
            "bulk_url_image_3": "bulk_url_image_3",
            "bulk_url_image_4": "bulk_url_image_4",
            "bulk_url_image_5": "bulk_url_image_5",
            "bulk_start": "bulk_start",
            "bulk_configuration_import_parameters": "bulk_configuration_import_parameters",
            "bulk_select_file_computer": "bulk_select_file_computer",
            "bulk_maximum_size_8_mb": "bulk_maximum_size_8_mb",
            "bulk_csv_separator": "bulk_csv_separator",
            "bulk_offer_ads_compatible_vehicles": "bulk_offer_ads_compatible_vehicles",
            "bulk_checked_parts_will_displayed_compatible_vehicles_according_classic_parts_finder_database": "bulk_checked_parts_will_displayed_compatible_vehicles_according_classic_parts_finder_database",
            "bulk_can_make_adjustment_individually_ad_import": "bulk_can_make_adjustment_individually_ad_import",
            "bulk_update_already_imported_ads": "bulk_update_already_imported_ads",
            "bulk_check_box_want_update_ads_already_imported": "bulk_check_box_want_update_ads_already_imported",
            "bulk_important": "bulk_important",
            "bulk_internal_reference_new_ads_must_identical_internal_reference_ads_already_imported": "bulk_internal_reference_new_ads_must_identical_internal_reference_ads_already_imported",
            "bulk_ignore_first_line_file": "bulk_ignore_first_line_file",
            "bulk_check_box_first_line_file_not_ad_example_named_columns": "bulk_check_box_first_line_file_not_ad_example_named_columns",
            "bulk_previous_step": "bulk_previous_step",
            "bulk_continue": "bulk_continue",
            "bulk_associate_fields_file": "bulk_associate_fields_file",
            "bulk_column_choose_corresponding_criterion": "bulk_column_choose_corresponding_criterion",
            "bulk_columns_file": "bulk_columns_file",
            "bulk_correspondence": "bulk_correspondence",
            "bulk_column": "bulk_column",
            "bulk_not_assigned": "bulk_not_assigned",
            "bulk_required": "bulk_required",
            "bulk_start_import": "bulk_start_import",
            "bulk_import_started_will_not_able_cancel_check_columns_mapped_correspond_field_selected": "bulk_import_started_will_not_able_cancel_check_columns_mapped_correspond_field_selected",
            "bulk_successful_column_mapping": "bulk_successful_column_mapping",
            "bulk_successful_column_mapping_description": "bulk_successful_column_mapping_description",
            "bulk_back_ads": "bulk_back_ads",
            "btn_bulk_import": "btn_bulk_import",
            "status_to_be_verified": "status_to_be_verified",
            "transport_propose_global_description": "transport_propose_global_description",
            "transport_propose_description_1": "transport_propose_description_1",
            "transport_propose_description_2": "transport_propose_description_2",
            "transport_propose_description_3": "transport_propose_description_3",
            "notice_cpf_title": "notice_cpf_title",
            "original_notice": "original_notice",
            "add_personal_comment": "add_personal_comment",
            "report_ad": "report_ad",
            "automatically_translated": "automatically_translated",
            "view_original": "view_original",
            "hide_original": "hide_original",
            "price_negotiable_explanation": "price_negotiable_explanation",
            "price_negotiable_title_0": "price_negotiable_title_0",
            "price_negotiable_description_0": "price_negotiable_description_0",
            "price_negotiable_title_1": "price_negotiable_title_1",
            "price_negotiable_description_1": "price_negotiable_description_1",
            "no_research_alert": "no_research_alert",
            "french": "french",
            "english": "english",
            "german": "german",
            "image_is_processing": "image_is_processing",
            "empty_car_title": "empty_car_title",
            "empty_car_description": "empty_car_description",
            "empty_car_add_first_car": "empty_car_add_first_car",
            "own_research_title": "own_research_title",
            "contact": "contact",
            "already_registered": "already_registered",
            "log_on_to": "log_on_to",
            "confirm_room_removal": "confirm_room_removal",
            "confirm": "confirm",
            "msg_search_alert": "msg_search_alert",
            "msg_product_is_no_longer_available": "msg_product_is_no_longer_available",
            "msg_you_have_no_conversation": "msg_you_have_no_conversation",
            "msg_name_of_the_conversation": "msg_name_of_the_conversation",
            "msg_modify_advert": "msg_modify_advert",
            "msg_modify_name_conversation": "msg_modify_name_conversation",
            "msg_no_conversation_selected": "msg_no_conversation_selected",
            "shipping_address": "shipping_address",
            "send_offer": "send_offer",
            "reservation_success": "reservation_success",
            "well_done": "well_done",
            "thanks_trust": "thanks_trust",
            "parts_reservation": "parts_reservation",
            "parts_reservation_description": "parts_reservation_description",
            "make_offer": "make_offer",
            "day": "day",
            "address_2": "address_2",
            "activate_stripe_account": "activate_stripe_account",
            "resume_stripe_activation": "resume_stripe_activation",
            "check_stripe_account": "check_stripe_account",
            "stripe_redirection_message": "stripe_redirection_message",
            "stripe_onboarding_success": "stripe_onboarding_success",
            "stripe_onboarding_failure": "stripe_onboarding_failure",
            "making_offer_widget_menu_title": "making_offer_widget_menu_title",
            "shipping_widget_menu_title": "shipping_widget_menu_title",
            "buyer_not_specified_shipping_address": "buyer_not_specified_shipping_address",
            "request_shipping_address": "request_shipping_address",
            "stripe_account_not_activated": "stripe_account_not_activated",
            "shipping_widget_title": "shipping_widget_title",
            "already_know_cost": "already_know_cost",
            "hand_delivered": "hand_delivered",
            "product_price": "product_price",
            "shipping_costs": "shipping_costs",
            "no_shipping_costs": "no_shipping_costs",
            "shipping_widget_select_label": "shipping_widget_select_label",
            "shipping_widget_alert": "shipping_widget_alert",
            "total": "total",
            "do_not_know_cost": "do_not_know_cost",
            "calcul_shipping_cost_instruction": "calcul_shipping_cost_instruction",
            "calculate_cost": "calculate_cost",
            "warning": "warning",
            "shipping_widget_send_proposal_btn": "shipping_widget_send_proposal_btn",
            "making_offer_widget_title": "making_offer_widget_title",
            "actual_price": "actual_price",
            "cpf_commission_included": "cpf_commission_included",
            "cpf_commission_explanation_cost": "cpf_commission_explanation_cost",
            "if_buyer_accept_offer_condition": "if_buyer_accept_offer_condition",
            "making_offer_widget_next_step_btn": "making_offer_widget_next_step_btn",
            "add_my_shipping_address": "add_my_shipping_address",
            "confirm_shipping_address": "confirm_shipping_address",
            "confirm_my_address": "confirm_my_address",
            "confirm_shipping_address_explanation": "confirm_shipping_address_explanation",
            "change_shipping_address": "change_shipping_address",
            "hand_delivery_only": "hand_delivery_only",
            "hand_delivery_only_explanation": "hand_delivery_only_explanation",
            "understood": "understood",
            "seller_message_template_7": "seller_message_template_7",
            "buyer_message_template_7": "buyer_message_template_7",
            "buyer_action_template_7": "buyer_action_template_7",
            "admin_message_template_7": "admin_message_template_7",
            "seller_message_template_8": "seller_message_template_8",
            "seller_action_template_8": "seller_action_template_8",
            "buyer_message_template_8": "buyer_message_template_8",
            "admin_message_template_8": "admin_message_template_8",
            "seller_message_template_9": "seller_message_template_9",
            "buyer_message_template_9": "buyer_message_template_9",
            "buyer_action_template_9": "buyer_action_template_9",
            "admin_message_template_9": "admin_message_template_9",
            "seller_message_template_10": "seller_message_template_10",
            "buyer_message_template_10": "buyer_message_template_10",
            "buyer_action_template_10": "buyer_action_template_10",
            "admin_message_template_10": "admin_message_template_10",
            "seller_message_template_11": "seller_message_template_11",
            "seller_action_template_11": "seller_action_template_11",
            "buyer_message_template_11": "buyer_message_template_11",
            "admin_message_template_11": "admin_message_template_11",
            "seller_message_template_12": "seller_message_template_12",
            "seller_hand_delivery_message_template_12": "seller_hand_delivery_message_template_12",
            "check_list_step_1_message_template_12": "check_list_step_1_message_template_12",
            "check_list_step_2_message_template_12": "check_list_step_2_message_template_12",
            "check_list_step_3_message_template_12": "check_list_step_3_message_template_12",
            "check_list_step_2_description_message_template_12": "check_list_step_2_description_message_template_12",
            "check_list_step_2_button_message_template_12": "check_list_step_2_button_message_template_12",
            "buyer_message_template_12": "buyer_message_template_12",
            "buyer_hand_delivery_message_template_12": "buyer_hand_delivery_message_template_12",
            "admin_message_template_12": "admin_message_template_12",
            "seller_message_template_13": "seller_message_template_13",
            "buyer_message_template_13": "buyer_message_template_13",
            "admin_message_template_13": "admin_message_template_13",
            "admin_name_template_13": "admin_name_template_13",
            "if_wish_change_shipping_address_instructions": "if_wish_change_shipping_address_instructions",
            "payment_title": "payment_title",
            "buyer_payment_more_informations": "buyer_payment_more_informations",
            "stripe_error_code": "stripe_error_code",
            "stripe_redirect_error_code": "stripe_redirect_error_code",
            "buy_with_stripe": "buy_with_stripe",
            "payment_in_progress": "payment_in_progress",
            "offer_no_longer_available": "offer_no_longer_available",
            "card_holder_name": "card_holder_name",
            "stripe_create_acount_explanation": "stripe_create_acount_explanation",
            "stripe_account": "stripe_account",
            "stripe_find_out_more": "stripe_find_out_more",
            "see_product": "see_product",
            "contact_administrator": "contact_administrator",
            "verified_identity": "verified_identity",
            "order_validation": "order_validation",
            "contact_details": "contact_details",
            "order_summary": "order_summary",
            "displayed_selling_price": "displayed_selling_price",
            "cpf_commission_included_price": "cpf_commission_included_price",
            "for": "for",
            "phone_number_required_for_delivery": "phone_number_required_for_delivery",
            "message_price_proposal_buyer_is_ue_and_seller_not_ue": "message_price_proposal_buyer_is_ue_and_seller_not_ue",
            "message_price_proposal_buyer_not_ue": "message_price_proposal_buyer_not_ue",
            "whats_prefered_shipping_mode": "whats_prefered_shipping_mode",
            "no_preference": "no_preference",
            "home_delivery": "home_delivery",
            "relay_point_delivery": "relay_point_delivery",
            "by_hand_delivery": "by_hand_delivery",
            "by_hand_delivery_alert": "by_hand_delivery_alert",
            "by_hand_delivery_button": "by_hand_delivery_button",
            "relay_point_delivery_alert": "relay_point_delivery_alert",
            "relay_point_delivery_seller_alert": "relay_point_delivery_seller_alert",
            "buyer_prefered_shipping_mode": "buyer_prefered_shipping_mode",
            "buyer_action_decline_offer": "buyer_action_decline_offer",
            "seller_message_template_14": "seller_message_template_14",
            "buyer_message_template_14": "buyer_message_template_14",
            "admin_message_template_14": "admin_message_template_14",
            "decline_offer_modal_title": "decline_offer_modal_title",
            "decline_offer_modal_select_label": "decline_offer_modal_select_label",
            "decline_offer_default_select_option": "decline_offer_default_select_option",
            "too_high_select_option": "too_high_select_option",
            "found_another_part_select_option": "found_another_part_select_option",
            "decline_offer_modal_other_reason_label": "decline_offer_modal_other_reason_label",
            "decline_offer_modal_btn_decline": "decline_offer_modal_btn_decline",
            "confirm_shipping_widget_menu_title": "confirm_shipping_widget_menu_title",
            "confirm_shipping_widget_title": "confirm_shipping_widget_title",
            "confirm_shipping_widget_send_btn": "confirm_shipping_widget_send_btn",
            "confirm_shipping_carrier_label_name": "confirm_shipping_carrier_label_name",
            "confirm_shipping_carrier_select_placeholder": "confirm_shipping_carrier_select_placeholder",
            "confirm_shipping_carrier_select_other": "confirm_shipping_carrier_select_other",
            "confirm_shipping_parcel_tracking": "confirm_shipping_parcel_tracking",
            "confirm_shipping_tracking_url_label": "confirm_shipping_tracking_url_label",
            "seller_action_template_15": "seller_action_template_15",
            "buyer_action_template_15": "buyer_action_template_15",
            "admin_action_template_15": "admin_action_template_15",
            "seller_message_title_template_15": "seller_message_title_template_15",
            "buyer_message_title_template_15": "buyer_message_title_template_15",
            "admin_message_title_template_15": "admin_message_title_template_15",
            "seller_message_template_15": "seller_message_template_15",
            "buyer_message_template_15": "buyer_message_template_15",
            "admin_message_template_15": "admin_message_template_15",
            "complementary_info_second_title": "complementary_info_second_title",
            "complementary_info_second_title_description": "complementary_info_second_title_description",
            "buyer_message_to_tell_choice_to_seller": "buyer_message_to_tell_choice_to_seller",
            "address_confirmation_already_sent_to_seller": "address_confirmation_already_sent_to_seller",
            "address_confirmation_limit_reached": "address_confirmation_limit_reached",
            "loading_products": "loading_products",
            "typologie_de_la_produit_2": "typologie_de_la_produit_2",
            "scroll_to_top": "scroll_to_top",
            "translate_in": "translate_in",
            "view_translation_message": "view_translation_message",
            "view_original_message": "view_original_message",
            "translate_is_processing": "translate_is_processing",
            "your_interlocutor_speaks": "your_interlocutor_speaks",
            "your_messages_can_be_automatically_translated": "your_messages_can_be_automatically_translated",
            "seller_offer": "seller_offer",
            "vehicle_not_found_info": "vehicle_not_found_info",
            "edit_research": "edit_research",
            "ask_the_community": "ask_the_community",
            "we_forward_your_request_to_members": "we_forward_your_request_to_members",
            "check_stock_first": "check_stock_first",
            "1_piece_currently_available": "1_piece_currently_available",
            "parts_currently_available": "parts_currently_available",
            "what_do_you_want_to_do_now": "what_do_you_want_to_do_now",
            "advanced_search_button": "advanced_search_button",
            "search_product_list": "search_product_list",
            "unsubscribed_email_vehicle_notification_message": "unsubscribed_email_vehicle_notification_message",
            "user_left_without_purchase": "user_left_without_purchase", // TODO: remove with the good message
            "seller_message_template_17": "seller_message_template_17",
            "reading_new_price_9": "reading_new_price_9",
            "copy_info": "copy_info",
            "info_copied": "info_copied",
            "select_shipping_mode": "select_shipping_mode",
            "seller_action_item_paid_title": "seller_action_item_paid_title",
            "seller_action_item_paid_desc": "seller_action_item_paid_desc",
            "seller_action_item_paid_warning": "seller_action_item_paid_warning",
            "oldPrice": "oldPrice",
            "seller_action_item_paid_warning_ship": "seller_action_item_paid_warning_ship",
            "add_to_ad": "add_to_ad",
        }
    }
};
